(function () {
  'use strict';

  var TABS = ['dashboard', 'orders', 'invoices', 'rma', 'bulk', 'favorites', 'lists', 'addresses', 'payment', 'team', 'profile', 'help'];

  // ERP customer numbers allowed to see the Bulk upload tab. Add an entry to roll the
  // feature out to another account. Uppercase — the check normalises before comparing.
  //   C0017916 = 20/20 Mobile, C0018718 = NEW-VIRGIN INC (both Boost head offices)
  var VA_BULK_ERP_ALLOWLIST = ['C0017916', 'C0018718'];

  // ── Shared credit-card brand icon ────────────────────────
  var _ccBrandPaths = {
    visa:       '<rect width="52" height="34" rx="5" fill="#1A1F71"/><text x="26" y="23" text-anchor="middle" fill="white" font-size="16" font-style="italic" font-weight="700" font-family="Arial,sans-serif" letter-spacing="-0.5">VISA</text>',
    mastercard: '<rect width="52" height="34" rx="5" fill="#252525"/><circle cx="21" cy="17" r="10" fill="#EB001B"/><circle cx="31" cy="17" r="10" fill="#F79E1B" fill-opacity="0.9"/>',
    amex:       '<rect width="52" height="34" rx="5" fill="#007BC1"/><text x="26" y="16" text-anchor="middle" fill="white" font-size="8" font-weight="700" font-family="Arial,sans-serif" letter-spacing="0.5">AMERICAN</text><text x="26" y="26" text-anchor="middle" fill="white" font-size="8" font-weight="700" font-family="Arial,sans-serif" letter-spacing="0.5">EXPRESS</text>',
    discover:   '<rect width="52" height="34" rx="5" fill="#231F20"/><circle cx="37" cy="17" r="16" fill="#F76F20"/><text x="19" y="21" text-anchor="middle" fill="white" font-size="8" font-weight="700" font-family="Arial,sans-serif">DISC</text>',
  };
  function brandIcon(brand, w, h) {
    var paths = _ccBrandPaths[brand];
    var svg = paths
      ? '<svg viewBox="0 0 52 34" width="' + w + '" height="' + h + '">' + paths + '</svg>'
      : '<svg viewBox="0 0 52 34" width="' + w + '" height="' + h + '" fill="none"><rect width="52" height="34" rx="5" stroke="#ccc" stroke-width="1.5"/><path d="M0 11h52" stroke="#ccc" stroke-width="1.5"/><rect x="4" y="15" width="10" height="6" rx="1" fill="#d0d8e4"/></svg>';
    return '<div class="va-pay-icon' + (paths ? ' va-cc-brand-icon' : '') + '">' + svg + '</div>';
  }

  // ── Market handle + company info ─────────────────────────
  var vaMarketHandle = null;
  var vaCompanyName  = null;
  var vaHasChildren  = false;
  var vaIsParentAccount = false;
  var vaBulkAllowed  = false;
  // window.__vaCustomerInfo is set by theme.liquid before any section script runs
  var vaMarketReady = window.__vaCustomerInfo.then(function (data) {
    if (data) {
      vaMarketHandle = (data.shopifyMarketHandle || '').toUpperCase();
      vaCompanyName  = data.Name || data.name || null;
      vaIsParentAccount = data.isParentAccount === true || data.IsParentAccount === true;
      vaHasChildren  = vaIsParentAccount || (data.childCount || 0) > 0;
      // Bulk upload is limited to the head-office accounts piloting it. Gate on the ERP
      // customer number rather than the market, so adding an account is a one-line change.
      // NOTE: this only controls the UI — it is not an authorization boundary. Anyone can
      // edit client-side JS, so the bulk-order API must enforce access on its own side.
      var vaErpNo = String(data.No || data.no || '').trim().toUpperCase();
      vaBulkAllowed = VA_BULK_ERP_ALLOWLIST.indexOf(vaErpNo) !== -1;
      var bulkNavLink = document.querySelector('.va-side-link[data-tab="bulk"]');
      var bulkPanel = document.getElementById('va-tab-bulk');
      if (bulkNavLink) bulkNavLink.hidden = !vaBulkAllowed;
      if (bulkPanel) bulkPanel.hidden = !vaBulkAllowed;
      if (location.hash.replace('#', '') === 'bulk') {
        if (vaBulkAllowed) applyHash();
        else {
          history.replaceState(null, '', '#dashboard');
          activateTab('dashboard');
        }
      }
      // Show team & permissions nav entry only for multi-location accounts
      var teamNavLink = document.querySelector('.va-side-link[data-tab="team"]');
      if (teamNavLink) teamNavLink.style.display = vaHasChildren ? '' : 'none';
      // Apply company name to sidebar and profile panel
      if (vaCompanyName) {
        var sideInfo = document.querySelector('.va-side-info');
        if (sideInfo && !sideInfo.querySelector('.va-side-company')) {
          var nameEl = sideInfo.querySelector('.va-side-name');
          var compEl = document.createElement('div');
          compEl.className = 'va-side-company';
          compEl.textContent = vaCompanyName;
          if (nameEl && nameEl.nextSibling) sideInfo.insertBefore(compEl, nameEl.nextSibling);
          else sideInfo.appendChild(compEl);
        }
        var profileCompany = document.getElementById('va-profile-company-name');
        if (profileCompany) profileCompany.textContent = vaCompanyName;
        var customerNoVal = data.No || data.no || '';
        var customerNoEl = document.getElementById('va-profile-company-no');
        if (customerNoEl && customerNoVal) {
          customerNoEl.textContent = customerNoVal;
          var customerNoRow = document.getElementById('va-profile-company-no-row');
          if (customerNoRow) customerNoRow.hidden = false;
        }
        var sideNoEl = document.getElementById('va-side-customer-no');
        if (sideNoEl && customerNoVal) { sideNoEl.textContent = 'Customer # ' + customerNoVal; sideNoEl.hidden = false; }
        // Help center: pre-fill email subject + WhatsApp message with "Customer # <no> - <company>"
        if (customerNoVal) {
          var helpRef = 'Customer # ' + customerNoVal + ' - ' + vaCompanyName;
          document.querySelectorAll('.va-help-mail[data-mail]').forEach(function (a) {
            a.href = 'mailto:' + a.dataset.mail + '?subject=' + encodeURIComponent(helpRef);
          });
          var waSupport = document.querySelector('.va-help-wa-support[data-base]');
          if (waSupport) waSupport.href = waSupport.dataset.base + encodeURIComponent('Hi, this is ' + helpRef + '. I have a question about an order.');
        }
        var marketEl = document.getElementById('va-profile-company-market');
        if (marketEl && vaMarketHandle) {
          marketEl.textContent = vaMarketHandle.toLowerCase().replace(/[-_]/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
          var marketRow = document.getElementById('va-profile-company-market-row');
          if (marketRow) marketRow.hidden = false;
        }
        // Address from BC
        var dd = data;
        var addrParts = [
          dd.Address  || dd.address  || '',
          dd.Address2 || dd.address2 || '',
          [dd.City || dd.city || '', dd.County || dd.county || '', dd.PostCode || dd.postCode || '', dd.CountryRegionCode || dd.countryRegionCode || ''].filter(Boolean).join(', '),
        ].filter(Boolean);
        var addrEl = document.getElementById('va-profile-company-addr');
        if (addrEl && addrParts.length) {
          addrEl.textContent = addrParts.join('\n');
          addrEl.style.whiteSpace = 'pre-line';
          var addrRow = document.getElementById('va-profile-company-addr-row');
          if (addrRow) addrRow.hidden = false;
        }
        var phoneVal = dd.PhoneNo || dd.phoneNo || '';
        var phoneEl = document.getElementById('va-profile-company-phone');
        if (phoneEl && phoneVal) {
          phoneEl.textContent = phoneVal;
          var phoneRow = document.getElementById('va-profile-company-phone-row');
          if (phoneRow) phoneRow.hidden = false;
        }
        var profilePanel = document.getElementById('va-profile-company-panel');
        if (profilePanel) profilePanel.hidden = false;
      }

      // Account balance and payment terms
      var termsCode = data.paymentTermsCode || data.PaymentTermsCode || '';
      var balanceRaw = data.BalanceLCY;
      if (balanceRaw == null) balanceRaw = data.balanceLCY;
      var displayBalance = data.displayBalanceLCY;
      if (displayBalance == null) displayBalance = data.DisplayBalanceLCY;
      var displayPastDue = data.displayBalanceDueLCY;
      if (displayPastDue == null) displayPastDue = data.DisplayBalanceDueLCY;
      if (displayBalance != null) balanceRaw = displayBalance;
      var hasBalance = balanceRaw !== null && balanceRaw !== undefined && balanceRaw !== '';
      var termsEl    = document.getElementById('va-pt-code');
      var balanceEl  = document.getElementById('va-current-balance');
      var pastDueEl  = document.getElementById('va-past-due');
      var pastDueNote = document.getElementById('va-past-due-note');
      var paymentDescription = document.getElementById('va-pt-description');
      var balanceNote = document.getElementById('va-balance-note');
      var overdueAlertPrefix = document.getElementById('va-overdue-alert-prefix');
      var overdueAlertSuffix = document.getElementById('va-overdue-alert-suffix');

      if (vaIsParentAccount) {
        if (paymentDescription) paymentDescription.textContent = 'Your combined billed balance and overdue amount across all doors, plus your account\u2019s invoice payment terms.';
        if (balanceNote) balanceNote.textContent = 'Includes billed amounts across all doors, including amounts not yet due.';
        if (overdueAlertPrefix) overdueAlertPrefix.textContent = 'Your doors have ';
        if (overdueAlertSuffix) overdueAlertSuffix.textContent = ' past due in total. Review your payment options and terms.';
      }

      if (termsEl) termsEl.textContent = (termsCode && termsCode !== '0') ? termsCode : '\u2014';
      if (balanceEl && hasBalance) balanceEl.textContent = odFmtMoney(balanceRaw, 'USD');
      var renderPastDue = function (rawAmount, currency) {
        var pastDueAmount = parseFloat(rawAmount);
        if (!isFinite(pastDueAmount)) return;
        // BC may return a negative overdue amount when credits or payments
        // exceed past-due entries. That is an account credit, not a negative
        // amount owed, so customer-facing past due must stop at zero.
        pastDueAmount = Math.max(0, pastDueAmount);
        if (pastDueEl) {
          pastDueEl.textContent = odFmtMoney(pastDueAmount, currency || 'USD');
          pastDueEl.classList.toggle('is-overdue', pastDueAmount > 0);
          pastDueEl.classList.toggle('is-clear', pastDueAmount <= 0);
        }
        if (pastDueNote) {
          if (vaIsParentAccount) {
            pastDueNote.textContent = pastDueAmount > 0 ? 'Total overdue balance across all doors as of today.' : 'No overdue balance across your doors.';
          } else {
            pastDueNote.textContent = pastDueAmount > 0 ? 'Payment is overdue as of today.' : 'No overdue balance.';
          }
        }
        var overdueAlert = document.getElementById('va-overdue-alert');
        var overdueAlertAmount = document.getElementById('va-overdue-alert-amount');
        if (overdueAlertAmount) overdueAlertAmount.textContent = odFmtMoney(pastDueAmount, currency || 'USD');
        if (overdueAlert) overdueAlert.hidden = !(pastDueAmount > 0);
      };

      // customer-info always carries displayBalanceDueLCY, sourced from BC's
      // customer-financial-summaries.overdueAmount — date-aware and inclusive of aged
      // entries. The old overdue-summary fallback undercounted (it only scanned posted
      // invoices), so we no longer fall back to it: showing nothing beats showing a
      // number that is quietly too low.
      if (displayPastDue !== null && displayPastDue !== undefined && displayPastDue !== '') {
        renderPastDue(displayPastDue, 'USD');
      }

      // Dashboard address widget
      var addrCount   = data.addressCount || 0;
      var defShipTo   = data.defaultShipTo || null;
      var metricEl    = document.getElementById('va-metric-addr-count');
      var dashSubEl   = document.getElementById('va-dash-addr-sub');
      var dashListEl  = document.getElementById('va-dash-addr-list');
      if (metricEl)  metricEl.textContent = addrCount || '';
      if (dashSubEl) dashSubEl.textContent = addrCount + ' ship-to location' + (addrCount !== 1 ? 's' : '');
      if (dashListEl) {
        if (!defShipTo) {
          dashListEl.innerHTML = '<div class="va-empty">No addresses on file.</div>';
        } else {
          var addrHtml = '<div class="va-list-item">'
            + '<div class="va-list-item-icon" style="background:var(--va-parchment);color:var(--va-steel);">'
            + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>'
            + '</div>'
            + '<div class="va-list-info">'
            + '<div class="va-list-name">' + escHtml(defShipTo.company || '') + '</div>'
            + '<div class="va-list-meta">' + escHtml([defShipTo.city, defShipTo.state].filter(Boolean).join(', ')) + '</div>'
            + '</div></div>';
          if (addrCount > 1) {
            addrHtml += '<div class="va-list-item va-list-item--more">'
              + '<span style="font-size:13px;color:var(--va-steel);padding:6px 10px;">+ ' + (addrCount - 1) + ' more location' + (addrCount - 1 !== 1 ? 's' : '') + '</span>'
              + '</div>';
          }
          dashListEl.innerHTML = addrHtml;
        }
      }

      return vaMarketHandle;
    }
    return null;
  });

  // [warmup ping disabled — no cold start on Azure]
  // window.__vaWarmupPing = (function () {
  //   var auth = window.__vaAuth || {};
  //   if (!auth.proxy) return Promise.resolve();
  //   return fetch(auth.proxy, {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //     body: JSON.stringify({ action: 'ping', customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop })
  //   }).catch(function () {});
  // })();

  // ── Tab activation ──────────────────────────────────────
  // "New" dot on the Quick Reorder nav entry until the customer opens the tab once
  // (remembered per browser; nothing is stored server-side).
  var qrNewKey = 'va-seen-quick-reorder';
  var qrNewDot = document.querySelector('.va-side-link[data-tab="favorites"] [data-va-side-new]');
  function qrSeen() { try { return !!window.localStorage.getItem(qrNewKey); } catch (_) { return false; } }
  if (qrNewDot && !qrSeen()) qrNewDot.hidden = false;

  function activateTab(tab) {
    if (TABS.indexOf(tab) === -1) tab = 'dashboard';
    if (tab === 'bulk' && !vaBulkAllowed) tab = 'dashboard';
    if (tab === 'favorites' && qrNewDot && !qrNewDot.hidden) {
      qrNewDot.hidden = true;
      try { window.localStorage.setItem(qrNewKey, '1'); } catch (_) {}
    }
    TABS.forEach(function (t) {
      var el = document.getElementById('va-tab-' + t);
      if (el) el.classList.toggle('va-tab--active', t === tab);
    });
    document.querySelectorAll('.va-side-link[data-tab]').forEach(function (link) {
      link.classList.toggle('va-side-link--active', link.dataset.tab === tab);
    });
  }

  // ── Order detail panel state ─────────────────────────────
  var odPanel     = document.getElementById('va-od-panel');
  var odContent   = document.getElementById('va-od-content');
  var odBack      = document.getElementById('va-od-back');
  var odTopName   = document.getElementById('va-od-topbar-name');
  var odTopNum    = document.getElementById('va-od-topbar-num');
  var odTopExt    = document.getElementById('va-od-topbar-ext');
  var ordersSub   = document.getElementById('va-orders-page-sub');
  var ordersPanel = document.getElementById('va-orders-list-panel');
  var odCache        = {};
  var odLinesCache   = {}; // variantId lines keyed by orderId, parallel to odCache
  var odFromTab      = null; // track which tab opened the detail panel
  var odReorderLines = null; // [{variantId, title, qty}] for the open order

  // ── Reorder button ───────────────────────────────────────
  var odReorderBtn = document.getElementById('va-od-reorder-btn');
  if (odReorderBtn) {
    odReorderBtn.addEventListener('click', function () { startReorder(); });
  }

  function showOrderDetail(orderId, name, source, sellTo) {
    console.log('[showOrderDetail] orderId=' + orderId + ' source=' + source + ' panel=' + !!odPanel + ' content=' + !!odContent);
    if (!odPanel || !odContent) { console.error('[showOrderDetail] panel/content missing, aborting'); return; }
    odFromTab = getTabFromHash();
    // Hide orders-specific chrome only when coming from the orders tab
    if (odFromTab === 'orders') {
      ordersSub   && (ordersSub.hidden   = true);
      ordersPanel && (ordersPanel.hidden = true);
    }
    odPanel.hidden = false;
    if (odTopName) odTopName.textContent = name || '';
    if (odTopNum) { odTopNum.hidden = true; odTopNum.textContent = ''; }
    if (odTopExt) { odTopExt.hidden = true; odTopExt.textContent = ''; }
    if (odCache[orderId]) {
      odContent.innerHTML = odCache[orderId];
      odReorderLines = odLinesCache[orderId] || [];
      if (odReorderBtn) odReorderBtn.hidden = odReorderLines.length === 0;
      initDetailPanel();
      return;
    }
    odContent.innerHTML = '<div class="va-od-skeleton"><div class="va-od-skel va-od-skel--short"></div><div class="va-od-skel"></div><div class="va-od-skel va-od-skel--wide"></div><div class="va-od-skel va-od-skel--short"></div></div>';
    var auth = window.__vaAuth || {};
    console.log('[showOrderDetail] fetching proxy=' + (auth.proxy || '(empty)') + ' orderId=' + orderId);
    fetch(auth.proxy || '', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action:      'order-detail',
        customer_id: auth.customer_id,
        ts:          auth.ts,
        token:       auth.token,
        shop:        Shopify.shop,
        order_id:             orderId,
        source:               source || '',
        sell_to_customer_no:  sellTo || ''
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.ok) throw new Error(data.error || 'Error');
        var orderData = data.data;
        if (odTopName && orderData.name) odTopName.textContent = orderData.name;
        if (odTopNum && orderData.orderNo) {
          odTopNum.textContent = 'Order# \u00a0' + orderData.orderNo;
          odTopNum.hidden = false;
        }
        if (odTopExt && orderData.externalDocumentNo) {
          odTopExt.textContent = 'Ext. Doc No. \u00a0' + orderData.externalDocumentNo;
          odTopExt.hidden = false;
        }
        var lineNodes = orderData.lineItems ? orderData.lineItems.nodes : [];
        odReorderLines = lineNodes.reduce(function (acc, li) {
          if (li.variant && li.variant.id) {
            acc.push({
              variantId: li.variant.id.replace('gid://shopify/ProductVariant/', ''),
              title:     li.title + (li.variantTitle && li.variantTitle !== 'Default Title' ? ' — ' + li.variantTitle : ''),
              qty:       li.quantity
            });
          }
          return acc;
        }, []);
        odLinesCache[orderId] = odReorderLines;
        if (odReorderBtn) odReorderBtn.hidden = odReorderLines.length === 0;
        vaMarketReady.then(function () {
          odCache[orderId] = renderOrderDetailHtml(orderData);
          odContent.innerHTML = odCache[orderId];
          initDetailPanel();
        });
      })
      .catch(function (err) {
        console.error('[showOrderDetail] fetch/parse error:', err);
        odContent.innerHTML = '<div class="va-empty" style="flex-direction:column;gap:10px;"><p>Could not load order details: ' + escHtml(err.message) + '</p></div>';
      });
  }

  function closeOrderDetail() {
    if (!odPanel) return;
    odPanel.hidden = true;
    if (odFromTab === 'orders') {
      ordersSub   && (ordersSub.hidden   = false);
      ordersPanel && (ordersPanel.hidden = false);
    }
    odFromTab = null;
    odReorderLines = null;
    if (odReorderBtn) { odReorderBtn.hidden = true; odReorderBtn.disabled = false; }
  }

  // ── Reorder logic ────────────────────────────────────────
  function startReorder() {
    if (!odReorderLines || !odReorderLines.length) return;
    odReorderBtn.disabled = true;

    // 1. Check inventory via proxy (single request for all variants)
    var proxy = window.__vaProxy || '';
    var shop  = Shopify.shop;
    var ids   = odReorderLines.map(function (l) { return l.variantId; }).join(',');
    fetch(proxy + '?action=variants&shop=' + encodeURIComponent(shop) + '&ids=' + ids)
      .then(function (r) { return r.ok ? r.json() : []; })
      .catch(function () { return []; })
      .then(function (data) {
        var availMap = {};
        (Array.isArray(data) ? data : []).forEach(function (v) { availMap[String(v.id)] = v.available > 0; });
        var available  = [];
        var outOfStock = [];
        odReorderLines.forEach(function (line) {
          var key   = String(line.variantId);
          var avail = Object.prototype.hasOwnProperty.call(availMap, key) ? availMap[key] : true;
          (avail ? available : outOfStock).push(line);
        });

        if (available.length === 0) {
          odReorderBtn.disabled = false;
          vaConfirm({ msg: 'All items in this order are currently out of stock and cannot be added to your cart.', okLabel: 'OK' });
          return;
        }
        if (outOfStock.length > 0) {
          showReorderOosDialog(outOfStock, available);
        } else {
          confirmCartClearAndReorder(available);
        }
      })
      .catch(function () {
        odReorderBtn.disabled = false;
      });
  }

  function showReorderOosDialog(outOfStock, available) {
    var dlg   = document.getElementById('va-reorder-oos-dialog');
    var msg   = document.getElementById('va-reorder-oos-msg');
    var list  = document.getElementById('va-reorder-oos-list');
    var okBtn = document.getElementById('va-reorder-oos-continue');
    var canBtn = document.getElementById('va-reorder-oos-cancel');
    if (!dlg) { confirmCartClearAndReorder(available); return; }

    msg.textContent = outOfStock.length + ' item' + (outOfStock.length > 1 ? 's are' : ' is') + ' out of stock and will not be added:';
    list.innerHTML = outOfStock.map(function (l) { return '<li>' + escHtml(l.title) + '</li>'; }).join('');
    okBtn.disabled = false;
    dlg.showModal();

    function cleanup() {
      dlg.close();
      okBtn.removeEventListener('click', onContinue);
      canBtn.removeEventListener('click', onCancel);
      dlg.removeEventListener('cancel', onCancel);
    }
    function onContinue() { cleanup(); confirmCartClearAndReorder(available); }
    function onCancel()   { cleanup(); odReorderBtn.disabled = false; }
    okBtn.addEventListener('click',  onContinue);
    canBtn.addEventListener('click', onCancel);
    dlg.addEventListener('cancel',   onCancel);
  }

  function confirmCartClearAndReorder(lines) {
    // 2. Check if cart is non-empty before clearing
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count || 0;
        if (count > 0) {
          var noun = count === 1 ? '1 item' : count + ' items';
          vaConfirm({
            msg:     'Your cart currently has ' + noun + '. Duplicating this order will replace your cart. Continue?',
            okLabel: 'Replace cart'
          }).then(function (ok) {
            if (ok) doReorder(lines);
            else odReorderBtn.disabled = false;
          });
        } else {
          doReorder(lines);
        }
      })
      .catch(function () { doReorder(lines); });
  }

  function doReorder(lines) {
    fetch('/cart/clear.js', { method: 'POST' })
      .then(function () {
        return fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ items: lines.map(function (l) { return { id: parseInt(l.variantId, 10), quantity: l.qty }; }) })
        });
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        odReorderBtn.disabled = false;
      });
  }

  function initDetailPanel() {
    odContent.querySelectorAll('.va-multiship-detail[data-order]:not([data-rendered])').forEach(function (ms) {
      try {
        var orderData = JSON.parse(ms.dataset.order    || '[]');
        var liMap     = JSON.parse(ms.dataset.lineitems || '{}');
        renderMultiship(ms, orderData, liMap);
        ms.dataset.rendered = '1';
      } catch (e) {
        ms.innerHTML = '<div class="va-empty"><p>Could not parse distribution data.</p></div>';
      }
    });

    // CC authorization wiring — loads stored cards and lets customer pick one (ORDER_ON_CREDIT_HOLD)
    odContent.querySelectorAll('.va-od-pay-section').forEach(function (section) {
      var methodInfo = section.querySelector('.va-od-pay-method-info');
      var authBtn    = section.querySelector('.va-od-cc-authorize');
      var chooseBtn  = section.querySelector('.va-od-pay-choose-btn');
      var payList    = section.querySelector('.va-od-pay-list');
      var errEl      = section.querySelector('.va-od-cc-form-err');
      var selectedId = null;
      var allAccts   = [];

      function showErr(msg) { if (errEl) { errEl.textContent = msg; errEl.hidden = false; } }
      function _acctLabel(acct) {
        // Decode literal \u{XXXX} and \uXXXX sequences stored by PHP single-quoted strings.
        var name = (acct.bankName || '')
          .replace(/\\u\{([0-9a-fA-F]+)\}/g, function (_, hex) {
            return String.fromCharCode(parseInt(hex, 16));
          })
          .replace(/\\u([0-9a-fA-F]{4})/g, function (_, hex) {
            return String.fromCharCode(parseInt(hex, 16));
          });
        if (!name && acct.last4) {
          var br = acct.brand ? acct.brand.charAt(0).toUpperCase() + acct.brand.slice(1) : 'Card';
          name = br + ' \u2022\u2022\u2022\u2022' + acct.last4;
        }
        return name || 'Payment card';
      }
      function renderSelected(acct) {
        if (!methodInfo) return;
        methodInfo.innerHTML = brandIcon(acct.brand, 36, 23)
          + '<span class="va-od-pay-acct-name">' + escHtml(_acctLabel(acct)) + '</span>';
      }

      // Fetch stored credit cards
      var auth = window.__vaAuth || {};
      fetch(auth.proxy || '', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'ach-list', customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop })
      })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d.ok) throw new Error(d.error || 'Error');
        allAccts = (d.accounts || []).filter(function (a) { return a.accountType === 'CreditCard'; });
        if (!allAccts.length) {
          if (methodInfo) methodInfo.innerHTML = '<span class="va-od-pay-empty">No credit cards saved. <a href="#payment">Add a card</a> in Payment &amp; Terms.</span>';
          return;
        }
        var def = allAccts.find(function (a) { return a.autoPayForABO; }) || allAccts[0];
        selectedId = def.id;
        renderSelected(def);
        if (authBtn) authBtn.disabled = false;
        if (allAccts.length > 1 && chooseBtn) {
          chooseBtn.hidden = false;
          if (payList) payList.innerHTML = allAccts.map(function (a) {
            return '<div class="va-od-pay-list-item' + (a.id === def.id ? ' va-od-pay-list-item--selected' : '') + '" data-acct-id="' + escHtml(a.id) + '">'
              + brandIcon(a.brand, 36, 23)
              + '<span class="va-od-pay-acct-name">' + escHtml(_acctLabel(a)) + '</span>'
              + '</div>';
          }).join('');
        }
      })
      .catch(function () {
        if (methodInfo) methodInfo.innerHTML = '<span class="va-od-pay-empty">Could not load payment methods.</span>';
      });

      // Toggle account chooser list
      if (chooseBtn) chooseBtn.addEventListener('click', function () {
        if (!payList) return;
        payList.hidden = !payList.hidden;
        chooseBtn.textContent = payList.hidden ? 'Change \u25be' : 'Change \u25b4';
      });

      // Select a different account from the list
      if (payList) payList.addEventListener('click', function (e) {
        var item = e.target.closest && e.target.closest('.va-od-pay-list-item');
        if (!item) return;
        selectedId = item.dataset.acctId;
        var acct = allAccts.find(function (a) { return a.id === selectedId; });
        if (acct) renderSelected(acct);
        payList.querySelectorAll('.va-od-pay-list-item').forEach(function (el) {
          el.classList.toggle('va-od-pay-list-item--selected', el.dataset.acctId === selectedId);
        });
        payList.hidden = true;
        if (chooseBtn) chooseBtn.textContent = 'Change \u25be';
      });

      // Authorize with selected stored card
      if (authBtn) authBtn.addEventListener('click', function () {
        if (!selectedId) return;
        if (errEl) errEl.hidden = true;
        authBtn.disabled = true;
        authBtn.textContent = 'Authorizing\u2026';
        fetch(auth.proxy || '', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action:                  'cc-authorize-order',
            customer_id:             auth.customer_id,
            ts:                      auth.ts,
            token:                   auth.token,
            shop:                    Shopify.shop,
            order_id:                section.dataset.orderId,
            order_name:              section.dataset.orderName,
            bank_account_system_id:  selectedId
          })
        })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (!d.ok) throw new Error(d.error || 'Authorization failed');
          section.innerHTML = '<div class="va-od-cc-success">\u2713 Payment authorized successfully.</div>';
          delete odCache[section.dataset.orderId];
        })
        .catch(function (err) {
          authBtn.disabled = false;
          authBtn.textContent = 'Authorize payment';
          showErr(err.message || 'Authorization failed. Please try again.');
        });
      });
    });
  }

  if (odBack) {
    odBack.addEventListener('click', function () {
      history.pushState(null, '', '#orders');
      closeOrderDetail();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // ── Hash routing ─────────────────────────────────────────
  function getTabFromHash() {
    var hash = location.hash.replace('#', '');
    if (hash.indexOf('orders/') === 0) return 'orders';
    return TABS.indexOf(hash) !== -1 ? hash : 'dashboard';
  }

  var _vaPendingOrderSlug = null;

  function applyHash() {
    var hash = location.hash.replace('#', '');
    var tab  = getTabFromHash();
    activateTab(tab);
    console.log('[applyHash] hash="' + hash + '" tab=' + tab);
    if (hash.indexOf('orders/') === 0) {
      var slug = hash.slice('orders/'.length);
      var row  = document.querySelector('.va-order-row[data-order-slug="' + slug + '"]');
      console.log('[applyHash] slug="' + slug + '" rowFound=' + !!row);
      if (row) {
        console.log('[applyHash] using row orderId=' + row.dataset.orderId + ' source=' + row.dataset.source);
        showOrderDetail(row.dataset.orderId, row.dataset.orderName, row.dataset.source, row.dataset.sellTo);
      } else {
        // Row not in DOM yet — orders list is still loading.
        // Open the panel with a skeleton and wait for orderLoad to make the accurate call.
        // If the row isn't found after orderLoad, the pending check will fall back to an inferred call.
        _vaPendingOrderSlug = slug;
        odFromTab = tab;
        if (odFromTab === 'orders') {
          ordersSub   && (ordersSub.hidden   = true);
          ordersPanel && (ordersPanel.hidden = true);
        }
        if (odPanel)   odPanel.hidden = false;
        if (odTopName) odTopName.textContent = slug;
        if (odTopNum)  { odTopNum.hidden = true;  odTopNum.textContent  = ''; }
        if (odTopExt)  { odTopExt.hidden = true;  odTopExt.textContent  = ''; }
        if (odReorderBtn) odReorderBtn.hidden = true;
        if (odContent) odContent.innerHTML = '<div class="va-od-skeleton"><div class="va-od-skel va-od-skel--short"></div><div class="va-od-skel"></div><div class="va-od-skel va-od-skel--wide"></div><div class="va-od-skel va-od-skel--short"></div></div>';
      }
    } else {
      _vaPendingOrderSlug = null;
      closeOrderDetail();
    }
  }

  function renderOrderVolumeChart(months, currency) {
    var chartEl = document.getElementById('va-order-volume-chart');
    if (!chartEl) return;
    months = Array.isArray(months) ? months : [];
    if (!months.length) {
      chartEl.innerHTML = '<div class="va-empty">Order volume is unavailable.</div>';
      return;
    }

    var width = 600, height = 180, left = 58, right = 14, top = 12, bottom = 32;
    var plotWidth = width - left - right;
    var baseline = height - bottom;
    var plotHeight = baseline - top;
    var values = months.map(function (month) {
      var value = parseFloat(month.total);
      return isFinite(value) && value > 0 ? value : 0;
    });
    var maxValue = Math.max.apply(Math, values);
    var scaleMax = maxValue > 0 ? maxValue : 1;
    var points = values.map(function (value, index) {
      var x = left + (months.length === 1 ? plotWidth / 2 : (plotWidth * index / (months.length - 1)));
      var y = baseline - (value / scaleMax * plotHeight);
      return { x: x, y: y, value: value, month: months[index].month || '' };
    });
    var linePath = points.map(function (point, index) {
      return (index ? 'L ' : 'M ') + point.x.toFixed(1) + ' ' + point.y.toFixed(1);
    }).join(' ');
    var areaPath = linePath + ' L ' + points[points.length - 1].x.toFixed(1) + ' ' + baseline
      + ' L ' + points[0].x.toFixed(1) + ' ' + baseline + ' Z';
    var compactMoney = function (value) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD', notation: 'compact', maximumFractionDigits: 1 }).format(value);
    };
    var monthLabel = function (period) {
      var parts = String(period).split('-');
      var date = new Date(Date.UTC(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, 1));
      return isNaN(date.getTime()) ? period : date.toLocaleDateString('en-US', { month: 'short', timeZone: 'UTC' });
    };
    var grid = [1, 0.5, 0].map(function (ratio) {
      var y = baseline - ratio * plotHeight;
      return '<line x1="' + left + '" y1="' + y.toFixed(1) + '" x2="' + (width - right) + '" y2="' + y.toFixed(1) + '" stroke="#EEEDE7" stroke-width="1"/>'
        + '<text x="' + (left - 8) + '" y="' + (y + 4).toFixed(1) + '" text-anchor="end" fill="#6B7280" font-size="10">' + escHtml(compactMoney(scaleMax * ratio)) + '</text>';
    }).join('');
    var labels = points.map(function (point, index) {
      if (index % 2 !== 0 && index !== points.length - 1) return '';
      return '<text x="' + point.x.toFixed(1) + '" y="170" text-anchor="middle" fill="#6B7280" font-size="10">' + escHtml(monthLabel(point.month)) + '</text>';
    }).join('');
    var dots = points.map(function (point, index) {
      var current = index === points.length - 1;
      return '<circle cx="' + point.x.toFixed(1) + '" cy="' + point.y.toFixed(1) + '" r="' + (current ? 4 : 3) + '" fill="' + (current ? '#C54448' : '#2B3A55') + '">'
        + '<title>' + escHtml(monthLabel(point.month) + ': ' + odFmtMoney(point.value, currency || 'USD')) + '</title></circle>';
    }).join('');

    chartEl.innerHTML = '<svg viewBox="0 0 ' + width + ' ' + height + '" role="img" aria-label="Order volume for the last 12 months" style="width:100%;height:100%;">'
      + '<defs><linearGradient id="va-g1" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#2B3A55" stop-opacity="0.15"/><stop offset="100%" stop-color="#2B3A55" stop-opacity="0"/></linearGradient></defs>'
      + grid
      + '<path d="' + areaPath + '" fill="url(#va-g1)"/>'
      + '<path d="' + linePath + '" stroke="#2B3A55" stroke-width="2" fill="none" vector-effect="non-scaling-stroke"/>'
      + dots + labels + '</svg>';
  }

  // ── Dashboard: recent invoices and account-wide order metrics ──────────
  function dashLoad() {
    var auth = window.__vaAuth || {};
    fetch(auth.proxy || '', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'dash-recent', customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (!data.ok) throw new Error(data.error || 'Error');
      var orders = data.orders || [];
      var dashEl   = document.getElementById('va-dash-order-list');
      var dashSubEl = document.getElementById('va-dash-order-sub');
      var openOrdersEl = document.getElementById('va-metric-open-orders');
      var ytdVolumeEl = document.getElementById('va-metric-ytd-volume');
      var emptyDash = '<div class="va-empty"><svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/></svg>No invoices in the last 30 days.</div>';
      if (dashEl) dashEl.innerHTML = orders.length
        ? orders.map(function (o) { return renderOrderRowHtml(o, true); }).join('')
        : emptyDash;
      if (dashSubEl) dashSubEl.textContent = orders.length
        ? orders.length + ' invoice' + (orders.length !== 1 ? 's' : '') + ' in the last 30 days'
        : 'Last 30 days';
      if (openOrdersEl && data.openOrders !== null && data.openOrders !== undefined) {
        openOrdersEl.textContent = parseInt(data.openOrders, 10) || 0;
      }
      if (ytdVolumeEl && data.ytdVolume !== null && data.ytdVolume !== undefined) {
        ytdVolumeEl.textContent = odFmtMoney(data.ytdVolume, data.currency || 'USD');
      }
      renderOrderVolumeChart(data.monthlyVolume, data.currency || 'USD');
    })
    .catch(function (err) {
      var dashEl = document.getElementById('va-dash-order-list');
      if (dashEl) dashEl.innerHTML = '<div class="va-empty">Could not load recent orders: ' + escHtml(err.message) + '</div>';
      var chartEl = document.getElementById('va-order-volume-chart');
      if (chartEl) chartEl.innerHTML = '<div class="va-empty">Could not load order volume.</div>';
    });
  }

  // ── Spendback credit (dashboard strip + panel) ──────────
  var MONTH_NAMES = ['January','February','March','April','May','June','July','August','September','October','November','December'];

  function monthLabel(period, offset) {
    var parts = period.split('-');
    var y = parseInt(parts[0]), m = parseInt(parts[1]) - 1 + (offset || 0);
    var yr = y + Math.floor(m / 12);
    var mi = ((m % 12) + 12) % 12;
    return MONTH_NAMES[mi] + ' ' + yr;
  }

  function initStoreCredit() {
    vaMarketReady.then(function () {
      if (vaMarketHandle !== 'CRICKET-WIRELESS') return;
      var customerNoEl = document.getElementById('va-profile-company-no');
	  console.log(customerNoEl?.textContent);
      if (!customerNoEl || customerNoEl.textContent !== 'C0000105') return;
      var auth = window.__vaAuth || {};
      if (!auth.customer_id) return;

      fetch(auth.proxy || '', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'store-credit-quote', customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop })
      })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (!res.ok || !res.data) return;
        var sc = res.data;
        var avail = odFmtMoney(sc.available, sc.currency || 'USD');
        var alloc = odFmtMoney(sc.allocation, sc.currency || 'USD');
        var period = sc.period || '';

        // Metric tile: swap addresses → credit
        var addrMetric = document.getElementById('va-metric-addr');
        var metricEl   = document.getElementById('va-sbk-metric');
        var metricVal  = metricEl && metricEl.querySelector('[data-va-sbk-metric-val]');
        if (metricVal)  metricVal.textContent  = '$' + Math.round(parseFloat(sc.available)).toLocaleString('en-US');
        if (addrMetric) addrMetric.style.display = 'none';
        if (metricEl)   metricEl.style.display   = '';

        // Strip
        var stripWrap = document.getElementById('va-sbk-strip');
        var availEl   = stripWrap && stripWrap.querySelector('[data-va-sbk-avail]');
        var periodEl  = stripWrap && stripWrap.querySelector('[data-va-sbk-period]');
        if (availEl)  availEl.textContent  = avail;
        if (periodEl) periodEl.textContent = monthLabel(period, 0);
        if (stripWrap) stripWrap.style.display = '';

        // Panel hero
        var panel    = document.getElementById('va-sbk-panel');
        var pillEl   = panel && panel.querySelector('[data-va-sbk-pill]');
        var heroAmt  = panel && panel.querySelector('[data-va-sbk-hero-amt]');
        if (pillEl)  pillEl.textContent  = monthLabel(period, 0).toUpperCase();
        if (heroAmt) heroAmt.textContent = avail;

        // Schedule rows
        var schedEl = document.getElementById('va-sbk-sched');
        if (schedEl) {
          var checkSvg = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>';
          var clockSvg = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
          function schedRow(dotCls, dotIcon, monthOffset, label, amt, amtCls) {
            return '<div class="va-sbk-sched-row">'
              + '<div class="va-sbk-sched-left">'
              + '<div class="va-sbk-sched-dot ' + dotCls + '">' + dotIcon + '</div>'
              + '<div class="va-sbk-sched-info">'
              + '<div class="m">' + escHtml(monthLabel(period, monthOffset) + ' credit') + '</div>'
              + '<div class="d">' + escHtml(label) + '</div>'
              + '</div></div>'
              + '<div class="va-sbk-sched-amt' + (amtCls ? ' ' + amtCls : '') + '">' + escHtml(amt) + '</div>'
              + '</div>';
          }
          schedEl.innerHTML =
            schedRow('live',     checkSvg, 0, 'Available Now', avail, '') +
            schedRow('upcoming', clockSvg, 1, 'Pending',       alloc, 'muted') +
            schedRow('upcoming', clockSvg, 2, 'Pending',       alloc, 'muted');
        }

        if (panel) panel.style.display = '';
      })
      .catch(function () {});
    });
  }

  // ── Order list: fetch + render (paginated) ───────────────
  var orderState = { page: 1, hasMore: false, totalPages: null, totalCount: 0, loading: false, dashLoaded: true };

  applyHash();
  dashLoad();
  initStoreCredit();

  function initCreditMemoTotal() {
    var auth = window.__vaAuth || {};
    var panel = document.getElementById('va-credit-memo-panel');
    var valueEl = panel && panel.querySelector('[data-va-credit-memo-value]');
    var summaryItem = document.getElementById('va-credit-memo-summary');
    var summaryValue = document.getElementById('va-credit-memo-total');
    var accountSummary = summaryItem && summaryItem.closest('.va-account-summary');
    var detailPanel = document.getElementById('va-credit-memo-detail');
    var detailRows = document.getElementById('va-credit-memo-rows');
    var heroSub = panel && panel.querySelector('[data-va-credit-memo-sub]');
    var summaryNote = document.getElementById('va-credit-memo-note');
    if (!auth.customer_id || (!valueEl && !summaryValue && !detailPanel)) return;

    fetch('https://app.rnrn.us/valor/credit-memo.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customer_id: auth.customer_id,
        shop: Shopify.shop,
        include_all_children: true,
        include_memos: true
      })
    })
    .then(function (response) { return response.json(); })
    .then(function (result) {
      var totalCredit = parseFloat(result && result.availableCredit) || 0;
      if (!result || !result.ok || result.enabled === false || totalCredit <= 0) {
        if (panel) panel.hidden = true;
        if (summaryItem) summaryItem.hidden = true;
        if (detailPanel) detailPanel.hidden = true;
        if (accountSummary) accountSummary.classList.remove('has-credit-memo');
        return;
      }
      // This login can apply every location's memo from the cart, one switch per
      // location, so the headline is the total across them. Each memo still only
      // pays for an order shipping to the location that holds it, which the note
      // says. creditByCustomerNo is summed over every open memo, so unlike the
      // detail rows it is not cut by the row limit.
      var ownNo = result.customerNo || '';
      var byNo = result.creditByCustomerNo || {};
      var ownCredit = parseFloat(byNo[ownNo]) || 0;
      var childCredit = Math.max(0, Math.round((totalCredit - ownCredit) * 100) / 100);
      var locationCount = Object.keys(byNo).filter(function (no) { return (parseFloat(byNo[no]) || 0) > 0; }).length;
      var formattedCredit = odFmtMoney(totalCredit, 'USD');
      var creditNote = locationCount > 1
        ? 'Across ' + locationCount + ' locations. Each memo applies only to orders shipping to its own location.'
        : 'Applies only to orders shipping to the location that holds it.';
      if (valueEl) valueEl.textContent = formattedCredit;
      if (heroSub) heroSub.textContent = creditNote;
      if (panel) panel.hidden = false;
      if (summaryValue) summaryValue.textContent = formattedCredit;
      if (summaryNote) summaryNote.textContent = creditNote;
      if (summaryItem) summaryItem.hidden = false;
      if (accountSummary) accountSummary.classList.add('has-credit-memo');
      renderCreditMemoDetail(result, ownNo, ownCredit, childCredit, byNo);
    })
    .catch(function () {});

    // Open memos, newest first. credit-memo.php sends the rows already sorted and
    // already scoped to the locations this contact is allowed to see, so this only
    // orders and formats them: this account's own memos first, then the child
    // locations', in one table with one total. When more than one location holds
    // credit, a per-location total comes first, matching the one switch per
    // location on the cart. An absent `memos` array means the
    // endpoint predates the detail table: keep the headline total and leave the
    // panel hidden rather than rendering an empty one.
    function renderCreditMemoDetail(result, ownNo, ownCredit, childCredit, byNo) {
      if (!detailPanel || !detailRows) return;
      var memos = (result && Array.isArray(result.memos)) ? result.memos : null;
      if (!memos || !memos.length) { detailPanel.hidden = true; return; }

      var ownMemos = memos.filter(function (memo) { return memo.customerNo === ownNo; });
      var childMemos = memos.filter(function (memo) { return memo.customerNo !== ownNo; });

      var head = '<div class="va-cm-row va-cm-head">'
        + '<div>Memo</div>'
        + '<div>Location</div>'
        + '<div class="va-cm-date">Issued</div>'
        + '<div class="va-cm-amt">Amount</div>'
        + '<div class="va-cm-amt">Applied</div>'
        + '<div class="va-cm-amt">Remaining</div>'
        + '</div>';

      // Street, suite, then "City, ST ZIP". Older endpoint responses carry no
      // street, which leaves the city line on its own as before.
      function memoAddress(memo) {
        var locality = [memo.city, [memo.state, memo.postCode].filter(Boolean).join(' ')].filter(Boolean).join(', ');
        return [memo.address, memo.address2, locality].filter(Boolean).join(', ');
      }

      function memoLocation(memo) {
        var addr = memoAddress(memo);
        return (memo.customerName ? '<div class="va-inv-addr-loc">' + escHtml(memo.customerName) + '</div>' : '')
          + (addr ? '<div class="va-inv-addr-loc va-cm-addr">' + escHtml(addr) + '</div>' : '');
      }

      function memoRow(memo) {
        var cur = memo.currencyCode || 'USD';
        // externalDocumentNo is a free-text BC field (often just 'CREDIT'), so it
        // only earns a line when it says something the memo number does not.
        var ref = memo.returnOrderNo
          || (memo.externalDocumentNo && memo.externalDocumentNo.toUpperCase() !== 'CREDIT' ? memo.externalDocumentNo : '');
        return '<div class="va-cm-row">'
          + '<div><div class="va-cm-no">' + escHtml(memo.no || '') + '</div>'
          + (ref ? '<div class="va-cm-ref">' + escHtml(ref) + '</div>' : '')
          + '</div>'
          + '<div class="va-inv-addr-cell">'
          + '<div class="va-inv-addr-name">' + escHtml(memo.customerNo || '') + '</div>'
          + '</div>'
          + '<div class="va-cm-date">' + escHtml(fmtDate(memo.postingDate || memo.documentDate) || '—') + '</div>'
          + '<div class="va-cm-amt va-cm-amt--muted">' + odFmtMoney(memo.issuedAmount, cur) + '</div>'
          + '<div class="va-cm-amt va-cm-amt--muted">' + (memo.appliedAmount > 0 ? odFmtMoney(memo.appliedAmount, cur) : '—') + '</div>'
          + '<div class="va-cm-amt va-cm-amt--remaining">' + odFmtMoney(memo.remainingAmount, cur) + '</div>'
          + '</div>';
      }

      // One row per location holding credit, largest first. Names come from the
      // memo rows, so a location whose memos fell past the row limit shows its
      // number alone; its amount is still exact, from creditByCustomerNo.
      function locationSummary(byNo, memos) {
        var numbers = Object.keys(byNo || {}).filter(function (no) { return (parseFloat(byNo[no]) || 0) > 0; });
        if (numbers.length < 2) return '';
        numbers.sort(function (a, b) { return (parseFloat(byNo[b]) || 0) - (parseFloat(byNo[a]) || 0) || (a < b ? -1 : 1); });
        var info = {};
        memos.forEach(function (memo) {
          if (memo.customerNo && !info[memo.customerNo]) {
            info[memo.customerNo] = memoLocation(memo);
          }
        });
        return '<div class="va-cm-group">'
          + '<div class="va-cm-group-title">By location · ' + numbers.length + ' locations</div>'
          + '<div class="va-cm-group-sub">Switch each one on in the cart when you choose shipping addresses.</div>'
          + '</div>'
          + numbers.map(function (no) {
            return '<div class="va-cm-loc-row">'
              + '<div class="va-inv-addr-cell">'
              + '<div class="va-inv-addr-name">' + escHtml(no) + (no === ownNo ? ' · this account' : '') + '</div>'
              + (info[no] || '')
              + '</div>'
              + '<div class="va-cm-amt va-cm-amt--remaining">' + odFmtMoney(parseFloat(byNo[no]) || 0, 'USD') + '</div>'
              + '</div>';
          }).join('');
      }

      function totalRow(rows, label, total) {
        return '<div class="va-cm-total-row">'
          + '<div>' + rows.length + (rows.length === 1 ? ' open memo' : ' open memos') + '</div>'
          + '<div></div><div></div><div></div>'
          + '<div class="va-cm-amt">' + label + '</div>'
          + '<div class="va-cm-amt">' + odFmtMoney(total, 'USD') + '</div>'
          + '</div>';
      }

      // One table: this account's memos first, then the child locations'. A
      // location with no memos simply has no rows, so nothing renders empty.
      var rows = ownMemos.concat(childMemos);
      var summary = locationSummary(byNo, memos);
      var html = summary
        + '<div class="va-cm-list' + (summary ? ' va-cm-list--after-summary' : '') + '">'
        + '<div class="va-cm-group">'
        + '<div class="va-cm-group-title">Open credit memos · ' + rows.length + (rows.length === 1 ? ' memo' : ' memos') + '</div>'
        + '<div class="va-cm-group-sub">Newest first. Remaining is what can still be applied to an order.</div>'
        + '</div>'
        + head + rows.map(memoRow).join('')
        + totalRow(rows, 'Total', Math.round((ownCredit + childCredit) * 100) / 100)
        + '</div>';

      if (result.memosTruncated) {
        html += '<div class="va-cm-note">Showing the ' + memos.length
          + ' most recent open memos. Contact your account manager for the full list.</div>';
      }

      detailRows.innerHTML = html;
      detailPanel.hidden = false;
    }
  }

  initCreditMemoTotal();
  orderLoad(1);

  window.addEventListener('hashchange', function () {
    applyHash();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  // Help center: "Chat with Lily" opens the Tidio conversation (theme.liquid shows
  // the widget sitewide for logged-in customers).
  var lilyBtn = document.getElementById('va-help-lily-chat');
  if (lilyBtn) {
    lilyBtn.addEventListener('click', function () {
      var openChat = function () {
        try { window.tidioChatApi.show(); window.tidioChatApi.open(); } catch (e) {}
      };
      if (window.tidioChatApi && window.tidioChatApi.readyEventWasFired) openChat();
      else document.addEventListener('tidioChat-ready', openChat, { once: true });
    });
  }

  document.querySelectorAll('.va-side-link[data-tab], .va-side-link-trigger[data-tab]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var tab = this.dataset.tab;
      if (TABS.indexOf(tab) === -1) return;
      e.preventDefault();
      history.pushState(null, '', '#' + tab);
      activateTab(tab);
      closeOrderDetail();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });

  // ── Order row click (delegated — works with dynamically rendered rows) ───
  document.addEventListener('click', function (e) {
    var row = e.target.closest && e.target.closest('.va-order-row[data-order-id]');
    if (!row) return;
    if (e.target.closest('a, button:not(.va-order-chev)')) return;
    var orderId = row.dataset.orderId;
    activateTab('orders');
    var slug = row.dataset.orderSlug || (row.dataset.orderId || '').replace(/^INV-/, '');
    history.pushState(null, '', slug ? '#orders/' + slug : '#orders');
    showOrderDetail(orderId, row.dataset.orderName, row.dataset.source, row.dataset.sellTo);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  function orderLoad(pg) {
    if (orderState.loading) return;
    orderState.loading = true;
    pg = pg || 1;
    var listEl  = document.getElementById('va-orders-list');
    var pagerEl = document.getElementById('va-orders-pager');
    var progEl  = document.getElementById('va-order-progress');
    if (progEl) progEl.classList.add('is-loading');
    if (listEl)  { listEl.innerHTML = '<div class="va-empty">Loading orders\u2026</div>'; if (progEl) listEl.insertBefore(progEl, listEl.firstChild); }
    if (pagerEl) pagerEl.hidden = true;
    var auth = window.__vaAuth || {};
    fetch(auth.proxy || '', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action:      'order-list',
        customer_id: auth.customer_id,
        ts:          auth.ts,
        token:       auth.token,
        shop:        Shopify.shop,
        page:        pg
      })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (!data.ok) throw new Error(data.error || 'Error');
      orderState.loading    = false;
      orderState.page       = data.page || pg;
      orderState.hasMore    = !!data.hasMore;
      orderState.totalPages = data.totalPages || null;
      orderState.totalCount = data.totalCount || 0;
      if (progEl) progEl.classList.remove('is-loading');
      var orders = data.orders || [];
      orderRender(orders);
      ordersApplyFilter();
      updateOrderSubs(orderState.totalCount);
    })
    .catch(function (err) {
      orderState.loading = false;
      if (progEl) progEl.classList.remove('is-loading');
      var errHtml = '<div class="va-empty">Could not load orders: ' + escHtml(err.message) + '</div>';
      var el = document.getElementById('va-dash-order-list');
      if (el && !orderState.dashLoaded) el.innerHTML = errHtml;
      el = document.getElementById('va-orders-list');
      if (el) el.innerHTML = errHtml;
    });
  }

  function orderRender(orders) {
    var listEl  = document.getElementById('va-orders-list');
    var pagerEl = document.getElementById('va-orders-pager');
    var emptyFull = '<div class="va-empty"><svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>No orders yet.</div>';
    if (listEl) listEl.innerHTML = orders.length
      ? orders.map(function (o) { return renderOrderRowHtml(o, false); }).join('')
      : emptyFull;
    if (pagerEl) {
      var pg = orderState.page, tp = orderState.totalPages, pagerNums = '', pgLast = null, delta = 2;
      if (tp && tp > 1) {
        for (var pi = 1; pi <= tp; pi++) {
          if (pi === 1 || pi === tp || (pi >= pg - delta && pi <= pg + delta)) {
            if (pgLast !== null && pi - pgLast > 1) pagerNums += '<span class="va-inv-pg-ellipsis">\u2026</span>';
            pagerNums += '<button class="va-inv-pg-num' + (pi === pg ? ' va-inv-pg-num--active' : '') + '" data-order-page="' + pi + '"' + (pi === pg ? ' disabled' : '') + '>' + pi + '</button>';
            pgLast = pi;
          }
        }
      }
      var pagerContent = '<button class="va-inv-pager-btn" id="va-order-prev"' + (pg <= 1 ? ' disabled' : '') + '>\u2190 Prev</button>'
        + (pagerNums || '<span class="va-inv-pager-info">Page ' + pg + (tp ? ' of ' + tp : '') + '</span>')
        + '<button class="va-inv-pager-btn" id="va-order-next"' + (!orderState.hasMore ? ' disabled' : '') + '>Next \u2192</button>';
      pagerEl.innerHTML = pagerContent;
      pagerEl.hidden = !orders.length || (pg <= 1 && !orderState.hasMore);
      var pagerTopEl = document.getElementById('va-orders-pager-top');
      if (pagerTopEl) {
        pagerTopEl.innerHTML = '<button class="va-inv-pager-btn" id="va-order-prev-top"' + (pg <= 1 ? ' disabled' : '') + '>\u2190 Prev</button>'
          + (pagerNums || '<span class="va-inv-pager-info">Page ' + pg + (tp ? ' of ' + tp : '') + '</span>')
          + '<button class="va-inv-pager-btn" id="va-order-next-top"' + (!orderState.hasMore ? ' disabled' : '') + '>Next \u2192</button>';
        pagerTopEl.hidden = !orders.length || (pg <= 1 && !orderState.hasMore);
      }
    }
    if (_vaPendingOrderSlug) {
      var pendingSlug = _vaPendingOrderSlug;
      var pendingRow  = document.querySelector('.va-order-row[data-order-slug="' + pendingSlug + '"]');
      _vaPendingOrderSlug = null;
      if (pendingRow) {
        // Accurate row data now available — make the one real call.
        showOrderDetail(pendingRow.dataset.orderId, pendingRow.dataset.orderName, pendingRow.dataset.source, pendingRow.dataset.sellTo);
      } else {
        // Order not on this page — fall back to inferred call.
        var inferredSource = /^PSI/i.test(pendingSlug) ? 'invoice' : 'order';
        var inferredId     = inferredSource === 'invoice' ? 'INV-' + pendingSlug : pendingSlug;
        showOrderDetail(inferredId, pendingSlug, inferredSource, '');
      }
    }
  }

  // Update just the active page number in all pagers without touching the list.
  function orderPagerSync() {
    var pg = orderState.page, tp = orderState.totalPages;
    [document.getElementById('va-orders-pager'), document.getElementById('va-orders-pager-top')].forEach(function (el) {
      if (!el) return;
      el.querySelectorAll('[data-order-page]').forEach(function (btn) {
        var p = parseInt(btn.dataset.orderPage, 10);
        btn.classList.toggle('va-inv-pg-num--active', p === pg);
        btn.disabled = p === pg;
      });
      var info = el.querySelector('.va-inv-pager-info');
      if (info) info.textContent = 'Page ' + pg + (tp ? ' of ' + tp : '');
    });
  }

  document.addEventListener('click', function (e) {
    var newPg = null;
    if ((e.target.id === 'va-order-prev' || e.target.id === 'va-order-prev-top') && orderState.page > 1) newPg = orderState.page - 1;
    else if ((e.target.id === 'va-order-next' || e.target.id === 'va-order-next-top') && orderState.hasMore) newPg = orderState.page + 1;
    else { var pgBtn = e.target.closest && e.target.closest('[data-order-page]'); if (pgBtn && !pgBtn.disabled) newPg = parseInt(pgBtn.dataset.orderPage, 10); }
    if (newPg !== null) { orderState.page = newPg; orderPagerSync(); orderLoad(newPg); }
  });

  function renderOrderRowHtml(order, isDash) {
    var sc    = odStatusClass(order);
    var id    = order.id || '';
    var slug  = (order.orderNo || order.name || id.replace(/^INV-/, '') || '').replace('#', '');
    var lines = order.lineItemsCount || 0;
    var odAttr = function (keys) {
      var a = (order.customAttributes || []).find(function (x) { return keys.indexOf(x.key) !== -1; });
      return a && a.value ? String(a.value).trim() : '';
    };
    var extVal = odAttr(['Ext. Doc No.']);
    var poVal  = odAttr(['po_number', 'PO Number', 'PO #']);
    var isMs = (order.customAttributes || []).some(function (a) { return a.key === '_order' && a.value; });
    var poLine   = (extVal ? '<div>Ext. Doc No.:\u00a0' + escHtml(extVal) + '</div>' : '')
                 + (poVal  ? '<div>PO#:\u00a0' + escHtml(poVal)  + '</div>' : '');
    var qtyParts = [];
    if (lines > 0) qtyParts.push(lines + ' line' + (lines !== 1 ? 's' : ''));
    if (isMs) qtyParts.push('multiship');
    var qtyLine = qtyParts.join(' \u00b7 ');
    var money = order.totalPriceSet ? order.totalPriceSet.shopMoney : null;
    var moneyStr = (money && parseFloat(money.amount) > 0) ? escHtml(odFmtMoney(money.amount, money.currencyCode)) : '';
    var _sta = order._shipToAddress || {};
    var searchStr = [order.name || '', extVal, poVal, _sta.name || '', (_sta.parts || []).join(' ')].filter(Boolean).join(' ').toLowerCase();
    return '<div class="va-order-row" data-order-id="' + escHtml(id) + '"' +
      ' data-order-name="' + escHtml(order.name || '') + '"' +
      ' data-order-slug="' + escHtml(slug) + '"' +
      ' data-source="' + escHtml(order._source || '') + '"' +
      ' data-sell-to="' + escHtml(order._sellToCustomerNo || '') + '"' +
      ' data-search="' + escHtml(searchStr) + '"' +
      (isDash ? ' data-dash="1"' : '') + '>' +
      '<div class="va-order-id">' +
      '<div class="va-order-num">' + escHtml(order.name || '') + '</div>' +
      '<div class="va-order-po">' + (!isDash ? poLine : '') + (qtyLine ? '<div>' + qtyLine + '</div>' : '') + '</div></div>' +
      '<div class="va-inv-addr-cell">' +
      (_sta.name ? '<div class="va-inv-addr-name">' + escHtml(_sta.name) + '</div>' : '') +
      (_sta.parts && _sta.parts.length ? '<div class="va-inv-addr-loc">' + escHtml(_sta.parts.join(', ')) + '</div>' : '') +
      '</div>' +
      '<div class="va-order-cell">' + escHtml(fmtDate(order.createdAt)) + '</div>' +
      '<div class="va-order-cell">' + moneyStr + '</div>' +
      '<div class="va-order-status"><span class="va-status-pill ' + sc.cls + '"><span class="va-sd"></span>' + escHtml(sc.label) + '</span></div>' +
      '<div class="va-order-chev"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg></div>' +
      '</div>';
  }

  function updateOrderSubs(totalCount) {
    var ordSubEl   = document.getElementById('va-orders-page-sub');
    var metricEl   = document.getElementById('va-metric-total-orders');
    if (ordSubEl) ordSubEl.textContent = totalCount + ' total order' + (totalCount !== 1 ? 's' : '') + ' \u00b7 click a row to expand';
    if (metricEl) metricEl.textContent = totalCount;
  }

  // kept for future use
  function updateOrderMetrics(orders) {}

  function ordersApplyFilter() {
    var searchEl = document.getElementById('va-orders-search');
    var q = searchEl ? searchEl.value.toLowerCase().replace(/[,\/]/g, ' ').replace(/\s+/g, ' ').trim() : '';
    var listEl = document.getElementById('va-orders-list');
    if (!listEl) return;
    var rows = listEl.querySelectorAll('.va-order-row[data-order-id]');
    var shown = 0;
    rows.forEach(function (row) {
      var visible = !q || (row.dataset.search || '').includes(q);
      row.style.display = visible ? '' : 'none';
      if (visible) shown++;
    });
    var subEl = document.getElementById('va-orders-page-sub');
    if (subEl) {
      if (q && rows.length > 0) {
        subEl.textContent = shown + ' of ' + rows.length + ' order' + (rows.length !== 1 ? 's' : '') + ' on this page';
      } else {
        updateOrderSubs(orderState.totalCount);
      }
    }
  }

  // ── Order detail renderer ────────────────────────────────
  function renderOrderDetailHtml(order) {
    var isMs   = (order.customAttributes || []).some(function (a) { return a.key === '_order' && a.value; });
    var html   = '<div class="va-od">';

    // Status + meta
    var sc = odStatusClass(order);
    html += '<div class="va-od-meta">';
    html += '<span class="va-status-pill ' + sc.cls + '"><span class="va-sd"></span>' + escHtml(sc.label) + '</span>';
    var fst = (order.displayFulfillmentStatus || '').toLowerCase();
    if (fst && fst !== 'unfulfilled') {
      var fstLabelMap = { delivered: 'Shipped', partial: 'Partially shipped' };
      var fstLabel = fstLabelMap[fst] || fst.replace(/_/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
      html += '<span class="va-status-pill ' + fst + '"><span class="va-sd"></span>' + escHtml(fstLabel) + '</span>';
    }
    html += '<span class="va-od-date-chip">' + escHtml(fmtDate(order.createdAt, true)) + '</span>';
    var po = (order.customAttributes || []).find(function (a) { return a.key === 'po_number' || a.key === 'PO Number' || a.key === 'PO #'; });
    if (po && po.value) html += '<span class="va-od-date-chip">PO#: ' + escHtml(po.value) + '</span>';
    html += '</div>';

    // Pay section for orders awaiting credit card authorization
    //if (order.orderStatus === 'ORDER_ON_CREDIT_HOLD' && vaMarketHandle === 'CRICKET-WIRELESS') {
    if (order.authorizationCode === '' && order.paymentMethodCode === 'CLOVER') {
      html += '<div class="va-od-pay-section"'
            + ' data-order-id="'   + escHtml(order.id   || '') + '"'
            + ' data-order-name="' + escHtml(order.name || '') + '">';
      html += '<div class="va-od-pay-notice"><strong>Action required:</strong>'
            + ' This order is awaiting payment authorization.</div>';
      // Method row: card display on left, action buttons on right
      html += '<div class="va-od-pay-method-row">'
            + '<div class="va-od-pay-method-info"><span class="va-od-pay-empty">Loading\u2026</span></div>'
            + '<div class="va-od-pay-actions">'
            + '<button class="va-od-pay-choose-btn" hidden>Change \u25be</button>'
            + '<button class="va-od-cc-authorize" disabled>Authorize payment</button>'
            + '</div></div>';
      // Expandable account chooser list
      html += '<div class="va-od-pay-list" hidden></div>';
      // Manual form kept hidden for future use
      html += '<div class="va-od-cc-form" hidden>';
      html += '<div class="va-od-cc-form-consent">'
            + 'By entering your credit card you authorize Valor Communication, Inc. to charge this card for the order total.'
            + '<p><input type="checkbox" name="od_cc_consent">&nbsp;&nbsp;I understand and agree</p></div>';
      html += '<div class="va-od-cc-form-row">'
            + '<input name="od_cc_number" placeholder="Card number" autocomplete="cc-number" inputmode="numeric" maxlength="19">'
            + '</div>';
      html += '<div class="va-od-cc-form-row">'
            + '<input name="od_cc_holder" placeholder="Cardholder name" autocomplete="cc-name">'
            + '<input name="od_cc_expiry" placeholder="MM/YY" autocomplete="cc-exp" maxlength="5" style="max-width:90px;">'
            + '<input name="od_cc_cvv" placeholder="CVV" type="password" autocomplete="cc-csc" maxlength="4" style="max-width:80px;">'
            + '<input name="od_cc_zip" placeholder="ZIP" maxlength="10" style="max-width:110px;">'
            + '</div>';
      html += '<div class="va-od-cc-form-actions">'
            + '<button class="va-od-cc-cancel-auth" type="button">Cancel</button>'
            + '</div>';
      html += '</div>';
      html += '<div class="va-od-cc-form-err" hidden></div>';
      html += '</div>';
    }

    // Multiship distribution
    var orderAttr = (order.customAttributes || []).find(function (a) { return a.key === '_order'; });
    if (orderAttr && orderAttr.value) {
      var liMap = odBuildLiMap(order.lineItems ? order.lineItems.nodes : []);
      html += '<div class="va-od-section"><div class="va-od-section-title">Multiship distribution</div>';
      html += '<div class="va-multiship-detail" data-order="' + escHtml(orderAttr.value).replace(/"/g, '&quot;') + '" data-lineitems="' + escHtml(JSON.stringify(liMap)).replace(/"/g, '&quot;') + '">';
      html += '<div class="va-od-loading-inline">Loading\u2026</div></div></div>';
    }

    // Line items
    var nodes = (order.lineItems ? order.lineItems.nodes : []) || [];
    var itemCount = nodes.filter(function (n) { return (n.type || '').toLowerCase() !== 'comment'; }).length;
    html += '<div class="va-od-section"><div class="va-od-section-title">';
    html += isMs ? 'All items (' + itemCount + ')' : 'Order items';
    html += '</div><div class="va-od-lineitems">';
    nodes.forEach(function (li) {
      if ((li.type || '').toLowerCase() === 'comment') {
        var note = li.comment != null ? li.comment : '';
        if (!note || !note.trim()) return;
        html += '<div class="va-od-li va-od-li-note">'
          + '<div class="va-od-li-img"></div>'
          + '<div class="va-od-li-info"><div class="va-od-li-name" style="font-style:italic;color:var(--va-steel);white-space:pre-line">' + escHtml(note) + '</div></div>'
          + '<div class="va-od-li-right"></div></div>';
        return;
      }
      var imgUrl  = li.image ? li.image.url + '?width=100' : null;
      var zoomUrl = li.image ? li.image.url + '?width=800' : null;
      var handle  = li.variant && li.variant.product ? li.variant.product.handle : null;
      var prodUrl = handle ? '/products/' + handle : null;
      var money   = li.originalUnitPriceSet ? li.originalUnitPriceSet.shopMoney : null;
      html += '<div class="va-od-li">';
      html += '<div class="va-od-li-img">';
      if (imgUrl) html += '<img src="' + escHtml(imgUrl) + '" data-zoom="' + escHtml(zoomUrl) + '" alt="' + escHtml(li.title) + '" loading="lazy" width="56" height="56" class="va-zoomable">';
      html += '</div><div class="va-od-li-info">';
      var nm = prodUrl ? '<a href="' + escHtml(prodUrl) + '" class="va-product-link">' + escHtml(li.title) + '</a>' : escHtml(li.title);
      html += '<div class="va-od-li-name">' + nm + '</div>';
      var metaHtml = escHtml(li.meta || '');
      if (li.variantTitle && li.variantTitle !== 'Default Title') {
        if (metaHtml) metaHtml += ' \u00b7 ';
        metaHtml += escHtml(li.variantTitle);
      }
      html += '<div class="va-od-li-meta">' + metaHtml + '</div>';
      html += '</div><div class="va-od-li-right">';
      html += '<div class="va-od-li-qty">\u00d7 ' + li.quantity + '</div>';
      if (money) html += '<div class="va-od-li-price">' + escHtml(odFmtMoney(money.amount, money.currencyCode)) + '</div>';
      html += '</div></div>';
    });
    html += '</div></div>';

    // Bottom: addresses + totals
    html += '<div class="va-od-bottom"><div class="va-od-addresses">';
    if (!isMs && order.shippingAddress) {
      html += '<div class="va-od-addr-block"><div class="va-od-section-title">Ship to</div>' + odRenderAddr(order.shippingAddress) + '</div>';
    }
    if (order.billingAddress) {
      html += '<div class="va-od-addr-block"><div class="va-od-section-title">Bill to</div>' + odRenderAddr(order.billingAddress) + '</div>';
    }
    var pmTxns = (order.transactions || []).filter(function (t) {
      return (t.kind === 'SALE' || t.kind === 'AUTHORIZATION') && t.status === 'SUCCESS';
    });
    if (pmTxns.length || (order.paymentGatewayNames || []).length) {
      html += '<div class="va-od-addr-block"><div class="va-od-section-title">Payment method</div>';
      if (pmTxns.length) {
        pmTxns.forEach(function (t) {
          var d = t.paymentDetails;
          html += '<div class="va-od-payment-method">';
          if (d && d.company) {
            html += escHtml(d.company);
            if (d.number) html += '<span class="va-od-payment-digits"> ' + escHtml(d.number) + '</span>';
          } else {
            html += escHtml(t.formattedGateway || t.gateway || '');
          }
          html += '</div>';
        });
      } else {
        var pmNames = (order.paymentGatewayNames || []).map(function (n) {
          return n.replace(/_/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
        });
        html += '<div class="va-od-payment-method">' + escHtml(pmNames.join(', ')) + '</div>';
      }
      html += '</div>';
    }
    html += '</div><div class="va-od-totals">';
    function trow(label, money, extraCls) {
      if (!money) return '';
      return '<div class="va-od-trow' + (extraCls ? ' ' + extraCls : '') + '"><span>' + escHtml(label) + '</span><span>' + escHtml(odFmtMoney(money.amount, money.currencyCode)) + '</span></div>';
    }
    html += trow('Subtotal', order.subtotalPriceSet ? order.subtotalPriceSet.shopMoney : null);
    var ship = order.totalShippingPriceSet ? order.totalShippingPriceSet.shopMoney : null;
    if (ship && parseFloat(ship.amount) > 0) html += trow('Shipping', ship);
    var tax = order.totalTaxSet ? order.totalTaxSet.shopMoney : null;
    if (tax && parseFloat(tax.amount) > 0) html += trow('Tax', tax);
    (order.discountApplications ? order.discountApplications.nodes : []).forEach(function (d) {
      var lbl = 'Discount' + (d.code ? ' (' + d.code + ')' : d.title ? ' (' + d.title + ')' : '');
      var val = d.value;
      var amt = val && val.amount ? '\u2212' + odFmtMoney(val.amount, val.currencyCode) : val && val.percentage ? '\u2212' + val.percentage + '%' : '';
      if (amt) html += '<div class="va-od-trow va-od-trow--discount"><span>' + escHtml(lbl) + '</span><span>' + escHtml(amt) + '</span></div>';
    });
    html += trow('Total', order.totalPriceSet ? order.totalPriceSet.shopMoney : null, 'va-od-trow--grand');
    html += '</div></div>';

    // Tracking
    var fulfillments = order.fulfillments || [];
    var hasTracking = fulfillments.some(function (f) { return (f.trackingInfo || []).length > 0; });
    if (hasTracking) {
      var truckIcon = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
      html += '<div class="va-od-section"><div class="va-od-section-title">Tracking</div><div class="va-od-tracking-list">';
      fulfillments.forEach(function (f) {
        (f.trackingInfo || []).forEach(function (t) {
          if (!t.number) return;
          var lbl = escHtml((t.company || 'Carrier') + ': ' + t.number);
          html += '<div class="va-od-tracking">' + truckIcon;
          html += t.url ? '<a href="' + escHtml(t.url) + '" target="_blank" rel="noopener" class="va-od-tracking-link">' + lbl + '</a>' : lbl;
          html += '</div>';
        });
      });
      html += '</div></div>';
    }

    // Note
    if (order.note) {
      html += '<div class="va-od-section"><div class="va-od-section-title">Order note</div>';
      html += '<div class="va-od-note">' + escHtml(order.note) + '</div></div>';
    }
    html += '</div>';
    return html;
  }

  function odStatusClass(order) {
    if (order.cancelledAt) return { cls: 'cancelled', label: 'Cancelled' };
    if (order.authorizationCode === '' && order.paymentMethodCode === 'CLOVER') return { cls: 'auth-hold', label: 'Awaiting authorization' };
    var fs = order.displayFulfillmentStatus || '';
    if (fs === 'FULFILLED') return { cls: 'delivered', label: 'Shipped' };
    if (fs === 'PARTIAL')   return { cls: 'shipped',   label: 'Partially shipped' };
    return { cls: 'processing', label: 'Processing' };
  }

  function odBuildLiMap(nodes) {
    var map = {};
    (nodes || []).forEach(function (li) {
      if (!li.variant) return;
      var variantId = li.variant.id.replace('gid://shopify/ProductVariant/', '');
      var money = li.originalUnitPriceSet ? li.originalUnitPriceSet.shopMoney : {};
      var handle = li.variant.product ? li.variant.product.handle : null;
      map[variantId] = {
        title:   li.title,
        variant: li.variantTitle || '',
        sku:     li.sku || '',
        qty:     li.quantity,
        price:   money.amount ? odFmtMoney(money.amount, money.currencyCode) : '',
        img:     li.image ? li.image.url + '?width=60'  : null,
        zoom:    li.image ? li.image.url + '?width=800' : null,
        url:     handle ? '/products/' + handle : null
      };
    });
    return map;
  }

  function odFmtMoney(amount, currency) {
    var n = parseFloat(amount);
    if (isNaN(n)) return String(amount);
    var sym = (!currency || currency === 'USD') ? '$' : currency + '\u00a0';
    return sym + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }


  function odRenderAddr(a) {
    var parts = [a.name, a.address1, a.address2, [a.city, a.provinceCode].filter(Boolean).join(', ') + (a.zip ? ' ' + a.zip : ''), a.countryCode].filter(Boolean);
    return '<address class="va-od-addr">' + parts.map(function (p) { return '<div>' + escHtml(p) + '</div>'; }).join('') + '</address>';
  }

  // ── Multiship renderer ──────────────────────────────────
  function renderMultiship(container, orderData, liMap) {
    if (!Array.isArray(orderData) || orderData.length === 0) {
      container.innerHTML = '<div class="va-empty"><p>No distribution data.</p></div>';
      return;
    }
    var html = '';
    orderData.forEach(function (entry) {
      var items      = entry.items || {};
      var totalUnits = Object.keys(items).reduce(function (s, k) { return s + (items[k] || 0); }, 0);
      var addrLabel  = entry.addr || entry.id || 'Address';
      html += '<div class="va-ms-group">';
      html += '<div class="va-ms-group-head">';
      html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>';
      html += '<span>' + escHtml(addrLabel) + '</span>';
      html += '<span class="va-ms-badge">' + totalUnits + ' unit' + (totalUnits !== 1 ? 's' : '') + '</span>';
      html += '</div>';
      if (entry.bc_ship_to) {
        html += '<div class="va-ms-addr-sub">Ship-to: ' + escHtml(entry.bc_ship_to);
        if (entry.bc_customer) html += ' &middot; Customer: ' + escHtml(entry.bc_customer);
        html += '</div>';
      }
      html += '<div class="va-ms-items">';
      Object.keys(items).forEach(function (variantId) {
        var qty  = items[variantId];
        var li   = liMap[variantId] || {};
        var name = li.title || ('Variant ' + variantId);
        if (li.variant && li.variant !== '' && li.variant !== 'Default Title') name += ' \u2014 ' + li.variant;
        var imgHtml;
        if (li.img) {
          imgHtml = '<div class="va-ms-item-img"><img src="' + escHtml(li.img) + '"' + (li.zoom ? ' data-zoom="' + escHtml(li.zoom) + '"' : '') + ' alt="' + escHtml(name) + '" loading="lazy" width="60" height="60" class="va-zoomable"></div>';
        } else {
          imgHtml = '<div class="va-ms-item-img va-ms-item-img--empty"></div>';
        }
        var nameHtml = li.url
          ? '<a href="' + escHtml(li.url) + '" class="va-ms-item-title-link">' + escHtml(name) + '</a>'
          : escHtml(name);
        html += '<div class="va-ms-item">';
        html += imgHtml;
        html += '<span class="va-ms-item-name">' + nameHtml + '</span>';
        html += '<span class="va-ms-item-qty">\u00d7 ' + qty + '</span>';
        html += '</div>';
      });
      html += '</div></div>';
    });
    container.innerHTML = html;
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // Reusable in-page confirm dialog (replaces browser confirm())
  // vaConfirm({ msg, okLabel, danger }) returns a Promise<boolean>
  function vaConfirm(opts) {
    var dlg    = document.getElementById('va-confirm-dialog');
    var msgEl  = document.getElementById('va-confirm-msg');
    var okBtn  = document.getElementById('va-confirm-ok');
    var canBtn = document.getElementById('va-confirm-cancel');
    if (!dlg) return Promise.resolve(window.confirm(opts.msg || ''));
    msgEl.textContent = opts.msg || '';
    okBtn.textContent = opts.okLabel || 'OK';
    okBtn.classList.toggle('danger', !!opts.danger);
    dlg.showModal();
    return new Promise(function (resolve) {
      function cleanup() { dlg.close(); okBtn.removeEventListener('click', onOk); canBtn.removeEventListener('click', onCancel); dlg.removeEventListener('cancel', onCancel); }
      function onOk()     { cleanup(); resolve(true);  }
      function onCancel() { cleanup(); resolve(false); }
      okBtn.addEventListener('click',  onOk);
      canBtn.addEventListener('click', onCancel);
      dlg.addEventListener('cancel',   onCancel);
    });
  }

  // vaCcAgree() returns Promise<boolean> — the Credit Card or Bank Account
  // Authorization Agreement gate. Resolves true only after the box is ticked
  // and confirmed.
  // Fails closed if the dialog markup is missing: an authorization must never
  // be recorded without an explicit, visible agreement.
  function vaCcAgree() {
    var dlg    = document.getElementById('va-cc-agree-dialog');
    var chk    = document.getElementById('va-cc-agree-check');
    var okBtn  = document.getElementById('va-cc-agree-ok');
    var canBtn = document.getElementById('va-cc-agree-cancel');
    if (!dlg || !chk || !okBtn || !canBtn) return Promise.resolve(false);
    chk.checked = false;
    okBtn.disabled = true;
    dlg.showModal();
    return new Promise(function (resolve) {
      function cleanup() {
        dlg.close();
        chk.removeEventListener('change', onToggle);
        okBtn.removeEventListener('click', onOk);
        canBtn.removeEventListener('click', onCancel);
        dlg.removeEventListener('cancel', onCancel);
      }
      function onToggle() { okBtn.disabled = !chk.checked; }
      function onOk()     { if (!chk.checked) return; cleanup(); resolve(true); }
      function onCancel() { cleanup(); resolve(false); }
      chk.addEventListener('change', onToggle);
      okBtn.addEventListener('click', onOk);
      canBtn.addEventListener('click', onCancel);
      dlg.addEventListener('cancel', onCancel);
    });
  }

  function fmtDate(str, withTime) {
    if (!str) return '';
    var d = new Date(str.includes('T') || str.includes('Z') ? str : str + 'T00:00:00');
    if (isNaN(d)) return '';
    var opts = { month: 'short', day: 'numeric', year: 'numeric' };
    if (withTime) { opts.hour = 'numeric'; opts.minute = '2-digit'; opts.hour12 = true; }
    return withTime ? d.toLocaleString('en-US', opts) : d.toLocaleDateString('en-US', opts);
  }

  // ── Image zoom lightbox ──────────────────────────────────
  (function () {
    var lb    = document.getElementById('va-lightbox');
    var lbImg = lb && lb.querySelector('.va-lightbox-img');
    if (!lb || !lbImg) return;

    function open(src, alt) {
      lbImg.src = src;
      lbImg.alt = alt || '';
      lb.classList.add('va-lightbox--open');
      lb.setAttribute('aria-hidden', 'false');
      document.addEventListener('keydown', onKey);
    }
    function close() {
      lb.classList.remove('va-lightbox--open');
      lb.setAttribute('aria-hidden', 'true');
      lbImg.src = '';
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }

    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.closest('.va-lightbox-close')) close();
    });

    document.addEventListener('click', function (e) {
      var img = e.target.closest ? e.target.closest('.va-zoomable') : null;
      if (!img) return;
      e.preventDefault();
      open(img.dataset.zoom || img.src, img.alt);
    });
  }());

  // ── Customer bulk order import ────────────────────────────
  (function () {
    var panel = document.getElementById('va-tab-bulk');
    if (!panel) return;

    var root       = panel.querySelector('.va-bulk-panel');
    var fileInput  = panel.querySelector('.va-bulk-file');
    var achSelect  = panel.querySelector('.va-bulk-ach');
    var resetBtn   = panel.querySelector('.va-bulk-reset');
    var importBtn  = panel.querySelector('.va-bulk-import');
    var importCountEl = panel.querySelector('.va-bulk-import-count');
    var templateLink = panel.querySelector('.va-bulk-template-download');
    var addressDownloadLink = panel.querySelector('.va-bulk-address-download');
    var rulesBtn   = panel.querySelector('.va-bulk-rules');
    var rulesDlg   = panel.querySelector('.va-bulk-rules-dialog');
    var rulesSave  = panel.querySelector('.va-bulk-rules-save');
    var rulesCancelButtons = panel.querySelectorAll('.va-bulk-rules-cancel');
    var rulesGridHead = panel.querySelector('.va-bulk-rules-grid-head');
    var rulesGridBody = panel.querySelector('.va-bulk-rules-grid-body');
    var rulesGridWrap = panel.querySelector('.va-bulk-rules-grid-wrap');
    var rulesEmpty = panel.querySelector('.va-bulk-rules-empty');
    var rulesCount = panel.querySelector('.va-bulk-rules-count');
    var rulesPriorityCount = panel.querySelector('.va-bulk-rules-priority-count');
    var rulesFilter = panel.querySelector('.va-bulk-rules-filter');
    var rulesAdd = panel.querySelector('.va-bulk-rules-add');
    var rulesAddPriority = panel.querySelector('.va-bulk-rules-add-priority');
    var rulesCsvImport = panel.querySelector('.va-bulk-rules-csv-import');
    var rulesCsvFile = panel.querySelector('.va-bulk-rules-csv-file');
    var rulesCsvExport = panel.querySelector('.va-bulk-rules-csv-export');
    var rulesFeedback = panel.querySelector('.va-bulk-rules-feedback');
    var statusEl   = panel.querySelector('.va-bulk-status');
    var summaryEl  = panel.querySelector('.va-bulk-summary-cards');
    var progressEl = panel.querySelector('.va-bulk-progress');
    var previewEl  = panel.querySelector('.va-bulk-preview');
    var resultsEl  = panel.querySelector('.va-bulk-results');
    var importedOrdersPanel = panel.querySelector('#va-bulk-orders-list-panel');
    var importedOrdersList = panel.querySelector('.va-bulk-orders-list');
    var importedOrdersSub = panel.querySelector('.va-bulk-orders-list-sub');
    var busyOverlay = panel.querySelector('.va-bulk-busy-overlay');
    var busyTitle = panel.querySelector('.va-bulk-busy-title');
    var busyDetail = panel.querySelector('.va-bulk-busy-detail');
    var apiBase    = (root.dataset.apiBase || '').replace(/\/$/, '');
    var state = {
      contextLoaded: false,
      loadingContext: false,
      contextUnavailable: false,
      fileName: '',
      csv: '',
      canImport: false,
      busy: false,
      busyMode: '',
      jobId: '',
      jobToken: '',
      pollTimer: null,
      activeFilter: 'all',
      orderCount: 0,
      templateLocations: [],
      addressRecords: [],
      addressIssues: [],
      lineOverrides: {},
      productSearchTimers: {},
      productSearchSequence: {},
      productSearchResults: {},
      collapsedLocations: {}
    };
    var fileReadSequence = 0;
    var xlsxLibraryPromise = null;
    var originalProductCache = Object.create(null);
    var originalProductRequests = Object.create(null);
    var originalProductQueue = [];
    var activeOriginalProductLookups = 0;
    var originalProductObserver = null;
    var originalProductHydrationSequence = 0;
    var rulesState = {
      rows: [],
      priorityCount: 3,
      nextRowId: 1,
      filter: '',
      loading: false,
      searchTimers: {},
      searchSequence: {},
      searchResults: {}
    };

    function setStatus(message, kind, allowHtml) {
      statusEl.className = 'va-bulk-status' + (kind ? ' va-bulk-status--' + kind : '');
      if (allowHtml) statusEl.innerHTML = message;
      else statusEl.textContent = message;
    }

    function refreshButtons() {
      resetBtn.disabled = state.busy || !state.csv;
      importBtn.disabled = state.busy || !state.canImport || !achSelect.value;
      importCountEl.textContent = String(state.orderCount || 0);
      rulesBtn.disabled = state.busy || state.loadingContext || state.contextUnavailable || !state.contextLoaded;
      fileInput.disabled = state.busy || state.loadingContext || state.contextUnavailable;
      achSelect.disabled = state.busy || state.loadingContext || state.contextUnavailable ||
        !state.contextLoaded || achSelect.options.length <= 1;
    }

    function updateBusyMessage(title, detail) {
      if (busyTitle && title) busyTitle.textContent = title;
      if (busyDetail && detail) busyDetail.textContent = detail;
    }

    function setBusy(isBusy, title, detail, showOverlay) {
      state.busy = isBusy === true;
      state.busyMode = state.busy ? (showOverlay === false ? 'inline' : 'modal') : '';
      root.setAttribute('aria-busy', state.busy ? 'true' : 'false');
      document.documentElement.classList.toggle('va-bulk-page-busy', state.busy);
      if (busyOverlay) busyOverlay.hidden = !state.busy || state.busyMode === 'inline';
      if (state.busy) updateBusyMessage(title, detail);
      refreshButtons();
    }

    function allowBrowserRefresh(event) {
      var key = String(event.key || '').toLowerCase();
      return key === 'f5' || ((event.ctrlKey || event.metaKey) && key === 'r');
    }

    function blockBusyInteraction(event) {
      if (!state.busy || allowBrowserRefresh(event)) return;
      if (state.busyMode === 'inline' && event.type !== 'click' && event.type !== 'keydown') return;
      if (state.busyMode === 'inline' && event.type === 'keydown' &&
          ['arrowup', 'arrowdown', 'pageup', 'pagedown', 'home', 'end'].includes(String(event.key || '').toLowerCase())) {
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    ['click', 'pointerdown', 'mousedown', 'touchstart', 'wheel', 'keydown'].forEach(function (eventName) {
      document.addEventListener(eventName, blockBusyInteraction, { capture: true, passive: false });
    });

    function basePayload() {
      var auth = window.__vaAuth || {};
      var info = window.__vaCustomerInfoData || {};
      return {
        shop: Shopify.shop,
        customer_id: auth.customer_id,
        customer_no: info.No || info.no || '',
        market_handle: vaMarketHandle || info.shopifyMarketHandle || '',
        ts: auth.ts,
        token: auth.token
      };
    }

    function filePayload() {
      return Object.assign(basePayload(), {
        file_name: state.fileName,
        csv_content: state.csv,
        ach_account_system_id: achSelect.value || '',
        line_overrides: Object.keys(state.lineOverrides).map(function (rowNumber) {
          var item = state.lineOverrides[rowNumber];
          return { row_number: Number(rowNumber), action: item.action || '', sku: item.sku || '' };
        })
      });
    }

    function post(path, payload) {
      if (!apiBase) return Promise.reject(new Error('Bulk order API URL is not configured.'));
      return fetch(apiBase + '/' + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (response) {
        return response.text().then(function (text) {
          var data;
          try { data = text ? JSON.parse(text) : {}; }
          catch (_) { data = { error: text || ('HTTP ' + response.status) }; }
          if (!response.ok || data.ok === false) {
            var details = (data.errors || []).join(' ');
            throw new Error([data.error || 'Bulk order request failed.', details].filter(Boolean).join(' '));
          }
          return data;
        });
      });
    }

    function csvCell(value) {
      var text = String(value == null ? '' : value);
      return /[",\r\n]/.test(text) ? '"' + text.replace(/"/g, '""') + '"' : text;
    }

    function downloadCsv(filename, lines) {
      var blob = new Blob(['\uFEFF' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8' });
      var url = URL.createObjectURL(blob);
      var download = document.createElement('a');
      download.href = url;
      download.download = filename;
      document.body.appendChild(download);
      download.click();
      download.remove();
      setTimeout(function () { URL.revokeObjectURL(url); }, 0);
    }

    function isExcelWorkbook(bytes) {
      var isZip = bytes.length >= 4 &&
        bytes[0] === 0x50 && bytes[1] === 0x4B &&
        (bytes[2] === 0x03 || bytes[2] === 0x05 || bytes[2] === 0x07) &&
        (bytes[3] === 0x04 || bytes[3] === 0x06 || bytes[3] === 0x08);
      var isCompoundFile = bytes.length >= 8 &&
        bytes[0] === 0xD0 && bytes[1] === 0xCF && bytes[2] === 0x11 && bytes[3] === 0xE0 &&
        bytes[4] === 0xA1 && bytes[5] === 0xB1 && bytes[6] === 0x1A && bytes[7] === 0xE1;
      return isZip || isCompoundFile;
    }

    function loadXlsxLibrary() {
      if (window.XLSX) return Promise.resolve(window.XLSX);
      if (xlsxLibraryPromise) return xlsxLibraryPromise;

      xlsxLibraryPromise = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = 'https://cdn.sheetjs.com/xlsx-0.20.3/package/dist/xlsx.full.min.js';
        script.onload = function () {
          if (window.XLSX) resolve(window.XLSX);
          else reject(new Error('Spreadsheet reader did not initialize.'));
        };
        script.onerror = function () {
          reject(new Error('Spreadsheet reader could not be loaded.'));
        };
        document.head.appendChild(script);
      }).catch(function (err) {
        xlsxLibraryPromise = null;
        throw err;
      });

      return xlsxLibraryPromise;
    }

    function fileBufferToCsv(buffer, fileName) {
      var bytes = new Uint8Array(buffer);
      var hasExcelExtension = /\.(xls|xlsx)$/i.test(String(fileName || ''));
      if (!isExcelWorkbook(bytes) && !hasExcelExtension) {
        return Promise.resolve(new TextDecoder('utf-8').decode(bytes));
      }

      return loadXlsxLibrary().then(function (XL) {
        var workbook = XL.read(bytes, { type: 'array' });
        var sheetName = workbook.SheetNames && workbook.SheetNames[0];
        if (!sheetName || !workbook.Sheets[sheetName]) {
          throw new Error('The selected file does not contain a worksheet.');
        }
        return XL.utils.sheet_to_csv(workbook.Sheets[sheetName], { FS: ',', RS: '\r\n' });
      });
    }

    function downloadCustomerTemplate(event) {
      event.preventDefault();
      if (!state.contextLoaded || !state.templateLocations.length) return;

      var lines = ['SFID or BC Customer Location ID,SKU,Quantity'];
      state.templateLocations.forEach(function (identifier, index) {
        var sku = 'SKU' + String(index + 1).padStart(3, '0');
        lines.push(csvCell(identifier) + ',' + sku + ',5');
      });
      downloadCsv('valor-bulk-order-template.csv', lines);
    }

    function downloadAddressRecords(event) {
      event.preventDefault();
      if (!state.contextLoaded || (!state.addressRecords.length && !state.addressIssues.length)) return;

      var lines = ['Parent Customer No.,Customer No.,SFID or BC Customer Location ID,Address 1,Address 2,City,State,ZIP Code'];
      state.addressRecords.forEach(function (record) {
        lines.push([
          record.parentCustomerNo,
          record.customerNo,
          record.identifier,
          record.address1,
          record.address2,
          record.city,
          record.state,
          record.zipCode
        ].map(csvCell).join(','));
      });
      if (state.addressIssues.length) {
        lines.push('');
        lines.push('Parent Customer No.,Customer No.,SFID or BC Customer Location ID,validation_status');
        state.addressIssues.forEach(function (issue) {
          lines.push([
            issue.parentCustomerNo,
            issue.customerNo,
            issue.identifier,
            issue.validationStatus
          ].map(csvCell).join(','));
        });
      }
      downloadCsv('valor-customer-address-records.csv', lines);
    }

    function bulkContextUnavailableMessage(missingAch) {
      var title = missingAch
        ? 'Bulk ordering is not set up for this account.'
        : 'Bulk ordering is unavailable for this account right now.';
      var detail = missingAch
        ? 'An active ACH payment method is required before bulk orders can be uploaded.'
        : 'We could not confirm the account and active ACH payment settings required for bulk ordering.';
      return '<strong class="va-bulk-status-title">' + title + '</strong>'
        + '<span class="va-bulk-status-detail">' + detail
        + ' <a href="#payment">Review Payment &amp; Terms</a> or '
        + '<a href="/pages/contact">contact customer support</a> if you need this feature.</span>';
    }

    function setBulkContextUnavailable(missingAch) {
      state.contextUnavailable = true;
      state.canImport = false;
      achSelect.innerHTML = '<option value="">'
        + (missingAch ? 'No active ACH account' : 'ACH account unavailable') + '</option>';
      setStatus(bulkContextUnavailableMessage(missingAch), 'setup', true);
      refreshButtons();
    }

    function loadContext() {
      if (state.contextLoaded || state.loadingContext) return;
      state.loadingContext = true;
      state.contextUnavailable = false;
      setStatus('Loading your customer and payment information…');
      refreshButtons();
      window.__vaCustomerInfo.then(function (info) {
        window.__vaCustomerInfoData = info || {};
        return post('context', basePayload());
      }).then(function (data) {
        state.contextLoaded = true;
        state.templateLocations = (data.templateLocations || []).map(function (identifier) {
          return String(identifier || '').trim();
        }).filter(function (identifier, index, all) {
          return identifier && all.findIndex(function (item) {
            return item.toLowerCase() === identifier.toLowerCase();
          }) === index;
        });
        state.addressRecords = Array.isArray(data.addressRecords) ? data.addressRecords : [];
        state.addressIssues = Array.isArray(data.addressIssues) ? data.addressIssues : [];
        if (templateLink) {
          templateLink.setAttribute('aria-disabled', state.templateLocations.length ? 'false' : 'true');
          templateLink.title = state.templateLocations.length
            ? 'Download ' + state.templateLocations.length + ' authorized location rows'
            : 'No usable SFID or BC Location ID is available';
        }
        if (addressDownloadLink) {
          var addressRowCount = state.addressRecords.length + state.addressIssues.length;
          addressDownloadLink.setAttribute('aria-disabled', addressRowCount ? 'false' : 'true');
          addressDownloadLink.title = addressRowCount
            ? 'Download ' + state.addressRecords.length + ' valid address rows and ' +
              state.addressIssues.length + ' validation issue rows'
            : 'No child location address records are available';
        }
        var usableAchAccounts = (data.accounts || []).filter(function (account) {
          return account && account.id;
        });
        achSelect.innerHTML = '<option value="" disabled>Select an ACH account</option>';
        usableAchAccounts.forEach(function (account) {
          var option = document.createElement('option');
          option.value = account.id;
          option.textContent = [account.nickName || account.bankName || 'Bank account', account.last4 ? '•••• ' + account.last4 : 'ACH'].filter(Boolean).join(' · ');
          achSelect.appendChild(option);
        });
        if (usableAchAccounts.length) {
          achSelect.value = usableAchAccounts[0].id;
        }
        if (!usableAchAccounts.length) {
          setBulkContextUnavailable(true);
        } else {
          state.contextUnavailable = false;
          setStatus('Customer ' + (data.customerNo || '') + ' is ready. Choose a CSV to begin validation.');
        }
        refreshButtons();
        if (state.csv && !state.contextUnavailable) validateFile();
      }).catch(function (err) {
        console.error('[bulk orders] Could not load customer payment context.', err);
        setBulkContextUnavailable(false);
      }).finally(function () {
        state.loadingContext = false;
        refreshButtons();
      });
    }

    function money(value) {
      return value == null ? '' : Number(value).toFixed(2);
    }

    function setRulesFeedback(message, kind) {
      if (!rulesFeedback) return;
      rulesFeedback.className = 'va-bulk-rules-feedback' + (kind ? ' va-bulk-rules-feedback--' + kind : '');
      rulesFeedback.textContent = message || '';
    }

    function parseCsvTable(value) {
      var text = String(value || '').replace(/^\uFEFF/, '');
      var rows = [];
      var row = [];
      var cell = '';
      var quoted = false;

      for (var index = 0; index < text.length; index += 1) {
        var character = text[index];
        if (quoted) {
          if (character === '"' && text[index + 1] === '"') {
            cell += '"';
            index += 1;
          } else if (character === '"') {
            quoted = false;
          } else {
            cell += character;
          }
          continue;
        }

        if (character === '"' && !cell) {
          quoted = true;
        } else if (character === ',') {
          row.push(cell);
          cell = '';
        } else if (character === '\r' || character === '\n') {
          row.push(cell);
          rows.push(row);
          row = [];
          cell = '';
          if (character === '\r' && text[index + 1] === '\n') index += 1;
        } else {
          cell += character;
        }
      }

      if (quoted) throw new Error('The CSV contains an unclosed quoted value.');
      if (cell || row.length) {
        row.push(cell);
        rows.push(row);
      }
      return rows;
    }

    function normalizedRuleHeader(value) {
      return String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '');
    }

    function isPriorityHeader(value) {
      var normalized = normalizedRuleHeader(value);
      return /^priority\d+(sku)?$/.test(normalized) || /^sku\d+$/.test(normalized);
    }

    function parseRulesCsv(value) {
      var rows = parseCsvTable(value).filter(function (row) {
        return row.some(function (cell) { return String(cell || '').trim(); });
      });
      if (!rows.length) {
        throw new Error('The CSV is empty. Use the header Note,Priority 1,Priority 2.');
      }

      var header = rows.shift();
      var firstHeader = normalizedRuleHeader(header[0]);
      var legacyFormat = firstHeader === 'device' && normalizedRuleHeader(header[1]) === 'product';
      var priorityStart = legacyFormat ? 2 : 1;
      if (!legacyFormat && firstHeader !== 'note') {
        throw new Error('The first CSV column must be Note. Legacy Device,Product CSV files are also supported.');
      }

      var priorityHeaders = header.slice(priorityStart).filter(function (cell) {
        return String(cell || '').trim();
      });
      if (!priorityHeaders.length || !priorityHeaders.every(isPriorityHeader)) {
        throw new Error('Use priority headers such as Priority 1, Priority 2, and Priority 3.');
      }

      var importedRows = [];
      var ignoredRows = 0;
      var priorityCount = priorityHeaders.length;
      rows.forEach(function (cells) {
        var note = legacyFormat
          ? [cells[0], cells[1]].map(function (cell) { return String(cell || '').trim(); }).filter(Boolean).join(' ')
          : String(cells[0] || '').trim();
        var skuValues = cells.slice(priorityStart).map(function (cell) {
          return String(cell || '').trim().toUpperCase();
        });
        if (!skuValues.some(Boolean)) {
          ignoredRows += 1;
          return;
        }
        priorityCount = Math.max(priorityCount, skuValues.length);
        importedRows.push({
          id: importedRows.length + 1,
          note: note,
          skus: skuValues.map(function (sku, skuIndex) {
            return makeRuleSlot(sku, skuIndex + 1);
          })
        });
      });

      return {
        rows: importedRows,
        ignoredRows: ignoredRows,
        priorityCount: Math.max(3, priorityCount),
        legacyFormat: legacyFormat
      };
    }

    function exportRulesCsv() {
      var header = ['Note'];
      for (var priority = 1; priority <= rulesState.priorityCount; priority += 1) {
        header.push('Priority ' + priority);
      }
      var exportRows = rulesState.rows.filter(function (row) {
        return row.skus.some(function (slot) { return Boolean(String(slot.sku || '').trim()); });
      });
      var lines = [header.map(csvCell).join(',')];
      exportRows.forEach(function (row) {
        var cells = [String(row.note || '').trim()];
        for (var index = 0; index < rulesState.priorityCount; index += 1) {
          cells.push(String(row.skus[index] && row.skus[index].sku || '').trim().toUpperCase());
        }
        lines.push(cells.map(csvCell).join(','));
      });
      downloadCsv('valor-substitution-rule-profiles.csv', lines);
      setRulesFeedback(
        exportRows.length
          ? 'Exported ' + exportRows.length + ' rule profiles without product or inventory details.'
          : 'Exported an empty CSV template with the current priority columns.',
        'success'
      );
    }

    function importRulesCsv(file) {
      if (!file || rulesState.loading) return;
      if (file.size > 5 * 1024 * 1024) {
        setRulesFeedback('The rule-profile CSV exceeds the 5 MB limit.', 'error');
        if (rulesCsvFile) rulesCsvFile.value = '';
        return;
      }

      var reader = new FileReader();
      reader.onload = function () {
        try {
          var imported = parseRulesCsv(reader.result);
          clearRulesSearchState();
          rulesState.rows = imported.rows;
          rulesState.priorityCount = imported.priorityCount;
          rulesState.nextRowId = imported.rows.length + 1;
          rulesState.filter = '';
          if (rulesFilter) rulesFilter.value = '';
          rulesState.rows.forEach(padRuleRow);
          renderRulesGrid();
          var message = 'Imported ' + imported.rows.length + ' rule profile'
            + (imported.rows.length === 1 ? '' : 's')
            + '; current editor rows were replaced. Save rule profiles to update the shared rules.';
          if (imported.ignoredRows) {
            message += ' ' + imported.ignoredRows + ' row'
              + (imported.ignoredRows === 1 ? '' : 's') + ' without a SKU were ignored.';
          }
          if (imported.legacyFormat) {
            message += ' Legacy Device and Product values were combined into Note.';
          }
          setRulesFeedback(message, 'success');
        } catch (error) {
          setRulesFeedback('Could not import CSV: ' + error.message, 'error');
        } finally {
          if (rulesCsvFile) rulesCsvFile.value = '';
        }
      };
      reader.onerror = function () {
        setRulesFeedback('Could not read the selected CSV.', 'error');
        if (rulesCsvFile) rulesCsvFile.value = '';
      };
      reader.readAsText(file);
    }

    function rulesCellKey(rowId, priority) {
      return String(rowId) + '-' + String(priority);
    }

    function clearRulesSearchState() {
      Object.keys(rulesState.searchTimers).forEach(function (key) {
        clearTimeout(rulesState.searchTimers[key]);
      });
      rulesState.searchTimers = {};
      rulesState.searchSequence = {};
      rulesState.searchResults = {};
      panel.querySelectorAll('.va-bulk-rule-search-results').forEach(function (results) {
        results.hidden = true;
      });
    }

    function makeRuleSlot(sku, priority) {
      var normalized = String(sku || '').trim().toUpperCase();
      return {
        priority: priority,
        sku: normalized,
        originalSku: normalized,
        product: null,
        validated: Boolean(normalized)
      };
    }

    function makeRuleRow(group) {
      var device = String(group && group.device || '').trim();
      var product = String(group && group.product || '').trim();
      var skus = (group && group.skus || []).slice().sort(function (a, b) {
        return Number(a.sortOrder || 0) - Number(b.sortOrder || 0);
      });
      return {
        id: rulesState.nextRowId++,
        note: [device, product].filter(Boolean).join(' '),
        skus: skus.map(function (item, index) { return makeRuleSlot(item.sku, index + 1); })
      };
    }

    function padRuleRow(row) {
      while (row.skus.length < rulesState.priorityCount) {
        row.skus.push(makeRuleSlot('', row.skus.length + 1));
      }
      return row;
    }

    function ruleRowMatches(row) {
      var query = String(rulesState.filter || '').trim().toUpperCase();
      if (!query) return true;
      if (String(row.note || '').toUpperCase().indexOf(query) >= 0) return true;
      return row.skus.some(function (slot) {
        return String(slot.sku || '').toUpperCase().indexOf(query) >= 0;
      });
    }

    function ruleSelectedProductHtml(slot) {
      if (slot.product) {
        var product = slot.product;
        var title = product.productTitle || product.displayName || product.sku || '';
        var available = product.availableForSale === true;
        return '<div class="va-bulk-rule-product">'
          + (product.imageUrl
            ? '<img src="' + escHtml(product.imageUrl) + '" alt="' + escHtml(product.imageAlt || title) + '" loading="lazy">'
            : '<span class="va-bulk-product-image-placeholder" aria-hidden="true">SKU</span>')
          + '<span class="va-bulk-rule-product-copy"><small>' + escHtml(title) + '</small>'
          + '<strong class="' + (available ? 'is-available' : 'is-unavailable') + '">' + escHtml(shopifyStockLabel(product)) + '</strong></span>'
          + '</div>';
      }
      if (slot.sku) {
        return '<div class="va-bulk-rule-product va-bulk-rule-product--pending">'
          + '<span class="va-bulk-rule-product-copy"><small>Saved SKU</small><strong>Focus to refresh Shopify stock</strong></span>'
          + '</div>';
      }
      return '<div class="va-bulk-rule-product va-bulk-rule-product--hint">Choose a Shopify product to set this priority.</div>';
    }

    function ruleSkuCellHtml(row, slot, priority) {
      return '<td class="va-bulk-rule-sku-cell">'
        + '<div class="va-bulk-rule-sku-editor" data-rule-row-id="' + row.id + '" data-rule-priority="' + priority + '">'
        + '<label><span class="visually-hidden">Priority ' + priority + ' SKU</span>'
        + '<input type="search" class="va-bulk-rule-sku-input" value="' + escHtml(slot.sku || '') + '" '
        + 'placeholder="Search partial SKU..." autocomplete="off" spellcheck="false"></label>'
        + '<span class="va-bulk-rule-search-state" aria-live="polite"></span>'
        + '<div class="va-bulk-rule-search-results" role="listbox" hidden></div>'
        + ruleSelectedProductHtml(slot)
        + '</div></td>';
    }

    function renderRulesGrid() {
      if (!rulesGridHead || !rulesGridBody) return;
      var scrollTop = rulesGridWrap ? rulesGridWrap.scrollTop : 0;
      var scrollLeft = rulesGridWrap ? rulesGridWrap.scrollLeft : 0;
      var priorityHeaders = '';
      for (var priority = 1; priority <= rulesState.priorityCount; priority += 1) {
        priorityHeaders += '<th scope="col"><span>Priority ' + priority + '</span><small>Shopify product &amp; live stock</small></th>';
      }
      rulesGridHead.innerHTML = '<tr><th scope="col" class="va-bulk-rule-number-head">#</th>'
        + '<th scope="col" class="va-bulk-rule-note-head"><span>Note</span><small>Optional customer reference</small></th>'
        + priorityHeaders
        + '<th scope="col" class="va-bulk-rule-actions-head">Actions</th></tr>';

      var visibleRows = rulesState.rows.filter(ruleRowMatches);
      rulesGridBody.innerHTML = visibleRows.map(function (row) {
        padRuleRow(row);
        var cells = '';
        for (var index = 0; index < rulesState.priorityCount; index += 1) {
          cells += ruleSkuCellHtml(row, row.skus[index], index + 1);
        }
        var rowNumber = rulesState.rows.indexOf(row) + 1;
        return '<tr data-rule-row="' + row.id + '">'
          + '<th scope="row" class="va-bulk-rule-number">' + rowNumber + '</th>'
          + '<td class="va-bulk-rule-note-cell"><label><span class="visually-hidden">Optional note</span>'
          + '<input type="text" class="va-bulk-rule-note" value="' + escHtml(row.note || '') + '" '
          + 'placeholder="Optional note, e.g. iPhone case group"></label></td>'
          + cells
          + '<td class="va-bulk-rule-row-actions"><button type="button" class="va-bulk-rule-delete" '
          + 'data-rule-delete="' + row.id + '" aria-label="Delete rule group ' + rowNumber + '">Delete</button></td>'
          + '</tr>';
      }).join('');

      if (rulesEmpty) {
        rulesEmpty.hidden = visibleRows.length > 0;
        rulesEmpty.textContent = rulesState.rows.length
          ? 'No rule profiles match this filter.'
          : 'No rule profiles yet. Add a rule group or import a CSV to begin.';
      }
      if (rulesCount) rulesCount.textContent = rulesState.rows.length + ' rule group' + (rulesState.rows.length === 1 ? '' : 's');
      if (rulesPriorityCount) rulesPriorityCount.textContent = rulesState.priorityCount + ' priority column' + (rulesState.priorityCount === 1 ? '' : 's');
      if (rulesGridWrap) {
        rulesGridWrap.scrollTop = scrollTop;
        rulesGridWrap.scrollLeft = scrollLeft;
      }
    }

    function closeRules() {
      clearRulesSearchState();
      if (rulesDlg && rulesDlg.open) rulesDlg.close();
    }

    function openRules() {
      if (!state.contextLoaded || state.contextUnavailable || state.busy) return;
      if (!rulesDlg.open) rulesDlg.showModal();
      document.documentElement.classList.add('va-bulk-rules-open');
      rulesState.loading = true;
      rulesState.rows = [];
      rulesState.priorityCount = 3;
      rulesState.filter = '';
      if (rulesFilter) rulesFilter.value = '';
      if (rulesGridBody) rulesGridBody.innerHTML = '<tr><td class="va-bulk-rules-loading" colspan="5">Loading customer-group substitution rules...</td></tr>';
      setRulesFeedback('Loading rule profiles...');
      rulesBtn.disabled = true;
      if (rulesCsvImport) rulesCsvImport.disabled = true;
      if (rulesCsvExport) rulesCsvExport.disabled = true;
      post('rules/get', basePayload()).then(function (data) {
        var groups = data.groups || [];
        rulesState.rows = groups.map(makeRuleRow);
        rulesState.priorityCount = Math.max(3, groups.reduce(function (maximum, group) {
          return Math.max(maximum, (group.skus || []).length);
        }, 0));
        rulesState.rows.forEach(padRuleRow);
        renderRulesGrid();
        setRulesFeedback('Loaded ' + rulesState.rows.length + ' customer-group rule profiles.', 'success');
      }).catch(function (err) {
        rulesState.rows = [];
        renderRulesGrid();
        setRulesFeedback('Could not load substitution rules: ' + err.message, 'error');
      }).finally(function () {
        rulesState.loading = false;
        rulesBtn.disabled = false;
        if (rulesCsvImport) rulesCsvImport.disabled = false;
        if (rulesCsvExport) rulesCsvExport.disabled = false;
      });
    }

    function saveRules() {
      var invalidSlot = null;
      rulesState.rows.some(function (row) {
        return row.skus.some(function (slot, index) {
          if (slot.sku && !slot.validated) {
            invalidSlot = { row: row, priority: index + 1 };
            return true;
          }
          return false;
        });
      });
      if (invalidSlot) {
        setRulesFeedback('Choose a Shopify search result for rule ' + (rulesState.rows.indexOf(invalidSlot.row) + 1)
          + ', Priority ' + invalidSlot.priority + ' before saving.', 'error');
        var invalidInput = rulesGridBody.querySelector('[data-rule-row-id="' + invalidSlot.row.id
          + '"][data-rule-priority="' + invalidSlot.priority + '"] .va-bulk-rule-sku-input');
        if (invalidInput) invalidInput.focus();
        return;
      }

      var groups = rulesState.rows.map(function (row, index) {
        var skus = row.skus.filter(function (slot) { return Boolean(slot.sku); }).map(function (slot, skuIndex) {
          return { sku: String(slot.sku).trim().toUpperCase(), sortOrder: skuIndex + 1 };
        });
        return {
          device: String(row.note || '').trim(),
          product: '',
          sortOrder: index + 1,
          skus: skus
        };
      }).filter(function (group) { return group.skus.length; });
      rulesSave.disabled = true;
      setRulesFeedback('Saving ' + groups.length + ' rule profiles...');
      post('rules/save', Object.assign(basePayload(), { groups: groups })).then(function () {
        closeRules();
        setStatus('Substitution rules saved for this customer group.', 'success');
        if (state.csv) validateFile();
      }).catch(function (err) {
        setRulesFeedback('Could not save substitution rules: ' + err.message, 'error');
      }).finally(function () { rulesSave.disabled = false; });
    }

    function findRuleRow(rowId) {
      return rulesState.rows.find(function (row) { return row.id === Number(rowId); });
    }

    function placeRuleSearchResults(editor) {
      var results = editor && editor.querySelector('.va-bulk-rule-search-results');
      var input = editor && editor.querySelector('.va-bulk-rule-sku-input');
      if (!results || !input || results.hidden) return;
      var rect = input.getBoundingClientRect();
      var viewportGap = 12;
      var width = Math.max(360, rect.width);
      width = Math.min(width, window.innerWidth - viewportGap * 2);
      var left = Math.min(Math.max(viewportGap, rect.left), window.innerWidth - width - viewportGap);
      results.style.left = left + 'px';
      results.style.width = width + 'px';
      results.style.top = Math.min(rect.bottom + 5, window.innerHeight - Math.min(360, results.offsetHeight) - viewportGap) + 'px';
    }

    function renderRuleSearchResults(editor, key, products, query) {
      var results = editor && editor.querySelector('.va-bulk-rule-search-results');
      var stateText = editor && editor.querySelector('.va-bulk-rule-search-state');
      if (!results) return;
      rulesState.searchResults[key] = products || [];
      if (!products || !products.length) {
        results.innerHTML = '<div class="va-bulk-rule-search-empty">No public Shopify products found for "' + escHtml(query) + '".</div>';
        results.hidden = false;
        if (stateText) stateText.textContent = '';
        placeRuleSearchResults(editor);
        return;
      }
      results.innerHTML = products.map(function (product, index) {
        var title = product.productTitle || product.displayName || product.sku || '';
        var available = product.availableForSale === true;
        return '<button type="button" class="va-bulk-rule-search-result" role="option" data-rule-result-index="' + index + '">'
          + (product.imageUrl
            ? '<img src="' + escHtml(product.imageUrl) + '" alt="' + escHtml(product.imageAlt || title) + '" loading="lazy">'
            : '<span class="va-bulk-product-image-placeholder" aria-hidden="true">SKU</span>')
          + '<span class="va-bulk-rule-result-copy"><strong>' + escHtml(product.sku || '') + '</strong>'
          + '<small>' + escHtml(title) + '</small>'
          + (product.barcode ? '<small>Barcode: ' + escHtml(product.barcode) + '</small>' : '')
          + '</span><span class="va-bulk-product-stock ' + (available ? 'is-available' : 'is-unavailable') + '">'
          + escHtml(shopifyStockLabel(product)) + '</span></button>';
      }).join('');
      results.hidden = false;
      if (stateText) stateText.textContent = products.length + ' result' + (products.length === 1 ? '' : 's');
      placeRuleSearchResults(editor);
    }

    function searchProductsForRule(input, immediate) {
      var editor = input && input.closest('.va-bulk-rule-sku-editor');
      if (!editor) return;
      var row = findRuleRow(editor.dataset.ruleRowId);
      var priority = Number(editor.dataset.rulePriority || 0);
      var slot = row && row.skus[priority - 1];
      if (!slot) return;
      var key = rulesCellKey(row.id, priority);
      var query = String(input.value || '').trim().toUpperCase();
      var results = editor.querySelector('.va-bulk-rule-search-results');
      var stateText = editor.querySelector('.va-bulk-rule-search-state');
      clearTimeout(rulesState.searchTimers[key]);
      rulesState.searchSequence[key] = Number(rulesState.searchSequence[key] || 0) + 1;
      var sequence = rulesState.searchSequence[key];

      if (query.length < 2) {
        rulesState.searchResults[key] = [];
        results.hidden = true;
        results.innerHTML = '';
        stateText.textContent = query ? 'Enter at least 2 characters' : '';
        return;
      }

      stateText.textContent = 'Searching Shopify...';
      rulesState.searchTimers[key] = setTimeout(function () {
        post('product-search', Object.assign(basePayload(), { query: query, limit: 10 }))
          .then(function (data) {
            if (sequence !== rulesState.searchSequence[key] || !input.isConnected) return;
            var products = data.results || [];
            var exact = products.find(function (product) {
              return String(product.sku || '').trim().toUpperCase() === query;
            });
            if (exact && slot.sku === query) {
              slot.product = exact;
              var productCard = editor.querySelector('.va-bulk-rule-product');
              if (productCard) productCard.outerHTML = ruleSelectedProductHtml(slot);
            }
            renderRuleSearchResults(editor, key, products, query);
          })
          .catch(function (err) {
            if (sequence !== rulesState.searchSequence[key] || !input.isConnected) return;
            rulesState.searchResults[key] = [];
            results.innerHTML = '<div class="va-bulk-rule-search-empty va-bulk-rule-search-empty--error">' + escHtml(err.message) + '</div>';
            results.hidden = false;
            stateText.textContent = 'Search unavailable';
            placeRuleSearchResults(editor);
          });
      }, immediate ? 0 : 300);
    }

    function chooseRuleProduct(editor, resultIndex) {
      var row = findRuleRow(editor.dataset.ruleRowId);
      var priority = Number(editor.dataset.rulePriority || 0);
      var key = rulesCellKey(row && row.id, priority);
      var product = (rulesState.searchResults[key] || [])[Number(resultIndex || 0)];
      var slot = row && row.skus[priority - 1];
      if (!slot || !product || !product.sku) return;
      slot.sku = String(product.sku).trim().toUpperCase();
      slot.originalSku = slot.sku;
      slot.product = product;
      slot.validated = true;
      var input = editor.querySelector('.va-bulk-rule-sku-input');
      var results = editor.querySelector('.va-bulk-rule-search-results');
      var stateText = editor.querySelector('.va-bulk-rule-search-state');
      if (input) input.value = slot.sku;
      if (results) results.hidden = true;
      if (stateText) stateText.textContent = 'Selected from Shopify';
      var productCard = editor.querySelector('.va-bulk-rule-product');
      if (productCard) productCard.outerHTML = ruleSelectedProductHtml(slot);
    }

    function summaryIcon(type) {
      if (type === 'ready') return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg>';
      if (type === 'subbed') return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M16 3l4 4-4 4M20 7H8a4 4 0 0 0-4 4M8 21l-4-4 4-4M4 17h12a4 4 0 0 0 4-4"></path></svg>';
      if (type === 'short') return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M12 7v6M12 17h.01"></path></svg>';
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><path d="M8 13h8M8 17h6"></path></svg>';
    }

    function summaryCard(filter, label, value, description, deltaClass) {
      var selected = filter === state.activeFilter;
      return '<button type="button" class="va-bulk-summary-card' + (selected ? ' is-active' : '') + '" data-bulk-filter="' + filter + '" aria-pressed="' + (selected ? 'true' : 'false') + '">'
        + '<span class="va-bulk-summary-head"><span class="va-bulk-summary-label">' + label + '</span><span class="va-bulk-summary-icon">' + summaryIcon(filter) + '</span></span>'
        + '<span class="va-bulk-summary-value">' + Number(value || 0).toLocaleString('en-US') + '</span>'
        + '<span class="va-bulk-summary-delta' + (deltaClass ? ' va-bulk-summary-delta--' + deltaClass : '') + '">' + description + '</span></button>';
    }

    function applyBulkFilter(filter) {
      var selected = filter || 'all';
      state.activeFilter = selected;
      summaryEl.querySelectorAll('[data-bulk-filter]').forEach(function (card) {
        var active = card.dataset.bulkFilter === selected;
        card.classList.toggle('is-active', active);
        card.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      var visibleRows = 0;
      previewEl.querySelectorAll('.va-bulk-location').forEach(function (location) {
        var locationVisible = 0;
        location.querySelectorAll('tbody tr[data-bulk-status]').forEach(function (row) {
          var show = selected === 'all' || row.dataset.bulkStatus === selected;
          row.hidden = !show;
          if (show) { locationVisible += 1; visibleRows += 1; }
        });
        location.hidden = locationVisible === 0;
      });
      var empty = previewEl.querySelector('.va-bulk-filter-empty');
      if (empty) empty.hidden = visibleRows !== 0;
    }

    function rowDisplayStatus(row) {
      if ((row.errors || []).length) return { key: 'blocked', label: 'Invalid' };
      if (Number(row.importQuantity || 0) <= 0) return { key: 'short', label: 'Out of Stock' };
      if (row.wasReplaced) return { key: 'subbed', label: 'Substituted' };
      return { key: 'ready', label: 'Ready' };
    }

    function availableReplacementCandidates(row) {
      return (row.replacementCandidates || []).filter(function (candidate) {
        return !candidate.isOriginal && candidate.sku;
      });
    }

    function shopifyStockLabel(product) {
      var quantity = Math.max(0, Number(product && product.sellableOnlineQuantity || 0));
      if (quantity > 0) return quantity + ' available to order';
      if (product && product.availableForSale) return 'Available for backorder';
      return 'Out of stock';
    }

    function originalProductFallbackTitle(row) {
      var sku = String(row && row.originalSku || '').trim();
      var description = String(row && (row.itemDescription || row.itemNo) || '').trim();
      return description && description.toUpperCase() !== sku.toUpperCase() ? description : '';
    }

    function pumpOriginalProductQueue() {
      while (activeOriginalProductLookups < 4 && originalProductQueue.length) {
        (function (task) {
          activeOriginalProductLookups += 1;
          post('product-search', Object.assign(basePayload(), { query: task.sku, limit: 20 }))
            .then(function (data) {
              return (data.results || []).find(function (product) {
                return String(product.sku || '').trim().toUpperCase() === task.sku;
              }) || null;
            }, function () {
              return null;
            })
            .then(function (product) {
              originalProductCache[task.sku] = product;
              delete originalProductRequests[task.sku];
              task.resolve(product);
            })
            .finally(function () {
              activeOriginalProductLookups -= 1;
              pumpOriginalProductQueue();
            });
        }(originalProductQueue.shift()));
      }
    }

    function loadOriginalProduct(sku) {
      var key = String(sku || '').trim().toUpperCase();
      if (!key) return Promise.resolve(null);
      if (Object.prototype.hasOwnProperty.call(originalProductCache, key)) {
        return Promise.resolve(originalProductCache[key]);
      }
      if (originalProductRequests[key]) return originalProductRequests[key];

      var resolveRequest;
      originalProductRequests[key] = new Promise(function (resolve) {
        resolveRequest = resolve;
      });
      originalProductQueue.push({ sku: key, resolve: resolveRequest });
      pumpOriginalProductQueue();
      return originalProductRequests[key];
    }

    function originalProductImageUrl(url) {
      var value = String(url || '').trim();
      if (!value) return '';
      return value + (value.indexOf('?') >= 0 ? '&' : '?') + 'width=96';
    }

    function applyOriginalProduct(rowElement, product) {
      if (!rowElement || !rowElement.isConnected) return;
      var titleElement = rowElement.querySelector('.va-bulk-original-title');
      var imageElement = rowElement.querySelector('.va-bulk-original-image');
      if (!titleElement || !imageElement) return;

      var fallbackTitle = titleElement.dataset.fallbackTitle || '';
      var title = product
        ? String(product.productTitle || product.displayName || fallbackTitle || product.sku || '').trim()
        : fallbackTitle;
      if (!title) title = 'Product details unavailable';
      titleElement.textContent = title;
      titleElement.title = title;

      var imageUrl = product ? originalProductImageUrl(product.imageUrl) : '';
      if (imageUrl) {
        imageElement.innerHTML = '<img src="' + escHtml(imageUrl) + '" alt="'
          + escHtml(product.imageAlt || title) + '" loading="lazy" width="44" height="44">';
      } else {
        imageElement.innerHTML = '<span class="va-bulk-original-image-placeholder" aria-hidden="true">SKU</span>';
      }
    }

    function hydrateOriginalProducts(sequence) {
      if (sequence !== originalProductHydrationSequence) return;
      if (originalProductObserver) originalProductObserver.disconnect();
      originalProductObserver = null;

      var rows = previewEl.querySelectorAll('tr[data-original-sku]');
      function hydrateRow(rowElement) {
        if (originalProductObserver) originalProductObserver.unobserve(rowElement);
        var sku = String(rowElement.dataset.originalSku || '').trim().toUpperCase();
        loadOriginalProduct(sku).then(function (product) {
          if (sequence !== originalProductHydrationSequence) return;
          applyOriginalProduct(rowElement, product);
        });
      }

      if ('IntersectionObserver' in window) {
        originalProductObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) hydrateRow(entry.target);
          });
        }, { rootMargin: '320px 0px' });
        rows.forEach(function (rowElement) {
          var sku = String(rowElement.dataset.originalSku || '').trim().toUpperCase();
          if (Object.prototype.hasOwnProperty.call(originalProductCache, sku)) {
            applyOriginalProduct(rowElement, originalProductCache[sku]);
          } else {
            originalProductObserver.observe(rowElement);
          }
        });
      } else {
        rows.forEach(hydrateRow);
      }
    }

    function scheduleOriginalProductHydration() {
      var sequence = ++originalProductHydrationSequence;
      setTimeout(function () {
        hydrateOriginalProducts(sequence);
      }, 0);
    }

    function renderOverrideControl(row, status) {
      if (status.key === 'ready' || status.key === 'blocked') {
        if (status.key === 'blocked') {
          return (row.errors || []).map(function (message) {
            return '<div class="va-bulk-row-msg va-bulk-row-msg--error">' + escHtml(message) + '</div>';
          }).join('');
        }
        return '<button type="button" class="va-bulk-line-locked" disabled>Line Locked</button>';
      }

      var rowNumber = Number(row.rowNumber || 0);
      var saved = state.lineOverrides[rowNumber] || {};
      var candidates = availableReplacementCandidates(row);
      if (saved.manual) {
        candidates = candidates.filter(function (candidate) {
          return String(candidate.sku || '').toUpperCase() !== String(saved.sku || '').toUpperCase();
        });
      }
      var selectedSku = saved.action === 'use' && !saved.manual ? saved.sku : (!saved.action && status.key === 'subbed' ? row.actualSku : '');
      var manualSelected = saved.action === 'use' && saved.manual;
      var skipSelected = saved.action === 'skip' || (!saved.action && status.key === 'short');
      var options = candidates.map(function (candidate, index) {
        var available = Number(candidate.availableQuantity || 0);
        var enough = available >= Number(row.quantity || 0);
        var selected = selectedSku && String(candidate.sku).toUpperCase() === String(selectedSku).toUpperCase();
        return '<option value="use|' + escHtml(candidate.sku) + '"' + (selected ? ' selected' : '') + (enough ? '' : ' disabled') + '>'
          + 'Use Priority ' + (index + 1) + ' Match (' + escHtml(candidate.sku) + ')'
          + (enough ? '' : ' — unavailable') + '</option>';
      }).join('');

      var feedback = row.overrideValidationStatus || '';
      var feedbackKind = feedback === 'Available' ? 'success' : (feedback && feedback !== 'Skipped by customer' ? 'error' : '');
      var selectedProduct = saved.productTitle
        ? '<div class="va-bulk-product-selected">'
          + (saved.imageUrl ? '<img src="' + escHtml(saved.imageUrl) + '" alt="" loading="lazy">' : '<span class="va-bulk-product-image-placeholder" aria-hidden="true">📦</span>')
          + '<span><strong>' + escHtml(saved.sku || '') + '</strong>'
          + '<small>' + escHtml(saved.productTitle) + '</small>'
          + '<small class="' + (saved.availableForSale ? 'is-available' : 'is-unavailable') + '">' + escHtml(saved.stockLabel || '') + '</small></span></div>'
        : '';
      return '<select class="va-bulk-override-select' + (status.key === 'short' ? ' va-bulk-override-select--required' : '') + '" data-row-number="' + rowNumber + '">'
        + options
        + '<option value="skip"' + (skipSelected ? ' selected' : '') + '>Skip this line on submit</option>'
        + '<option value="manual"' + (manualSelected ? ' selected' : '') + '>Search for another substitute…</option>'
        + '</select>'
        + '<div class="va-bulk-manual va-bulk-product-search' + (manualSelected ? ' is-visible' : '') + '" data-manual-row="' + rowNumber + '">'
        + '<input type="search" class="va-bulk-product-search-input" value="' + escHtml(saved.sku || '') + '" placeholder="Search by partial SKU" aria-label="Search replacement SKU for line ' + rowNumber + '" autocomplete="off">'
        + '<span class="va-bulk-product-search-state" aria-live="polite"></span>'
        + '<div class="va-bulk-product-search-results" role="listbox" hidden></div>'
        + selectedProduct
        + '</div>'
        + (feedback ? '<div class="va-bulk-override-feedback' + (feedbackKind ? ' va-bulk-override-feedback--' + feedbackKind : '') + '">' + escHtml(feedback) + '</div>' : '');
    }

    function renderProductSearchResults(searchBox, rowNumber, products, query) {
      var results = searchBox && searchBox.querySelector('.va-bulk-product-search-results');
      var stateText = searchBox && searchBox.querySelector('.va-bulk-product-search-state');
      if (!results) return;

      state.productSearchResults[rowNumber] = products || [];
      if (!products || !products.length) {
        results.innerHTML = '<div class="va-bulk-product-search-empty">No public Shopify products found for “' + escHtml(query) + '”.</div>';
        results.hidden = false;
        if (stateText) stateText.textContent = '';
        return;
      }

      results.innerHTML = products.map(function (product, index) {
        var available = product.availableForSale === true;
        var title = product.productTitle || product.displayName || product.sku || '';
        return '<button type="button" class="va-bulk-product-search-result" role="option" data-row-number="' + rowNumber + '" data-result-index="' + index + '"' + (available ? '' : ' disabled') + '>'
          + (product.imageUrl
            ? '<img src="' + escHtml(product.imageUrl) + '" alt="' + escHtml(product.imageAlt || title) + '" loading="lazy">'
            : '<span class="va-bulk-product-image-placeholder" aria-hidden="true">📦</span>')
          + '<span class="va-bulk-product-result-info"><strong>' + escHtml(product.sku || '') + '</strong><small>' + escHtml(title) + '</small>'
          + (product.barcode ? '<small>Barcode: ' + escHtml(product.barcode) + '</small>' : '') + '</span>'
          + '<span class="va-bulk-product-stock ' + (available ? 'is-available' : 'is-unavailable') + '">' + escHtml(shopifyStockLabel(product)) + '</span>'
          + '</button>';
      }).join('');
      results.hidden = false;
      if (stateText) stateText.textContent = products.length + ' result' + (products.length === 1 ? '' : 's');
    }

    function searchProductsForRow(rowNumber, input) {
      var searchBox = input && input.closest('.va-bulk-product-search');
      if (!searchBox) return;
      var results = searchBox.querySelector('.va-bulk-product-search-results');
      var stateText = searchBox.querySelector('.va-bulk-product-search-state');
      var query = String(input.value || '').trim().toUpperCase();
      clearTimeout(state.productSearchTimers[rowNumber]);
      state.productSearchSequence[rowNumber] = Number(state.productSearchSequence[rowNumber] || 0) + 1;
      var sequence = state.productSearchSequence[rowNumber];

      if (query.length < 2) {
        state.productSearchResults[rowNumber] = [];
        if (results) {
          results.hidden = true;
          results.innerHTML = '';
        }
        if (stateText) stateText.textContent = query ? 'Enter at least 2 characters' : '';
        return;
      }

      if (stateText) stateText.textContent = 'Searching Shopify…';
      state.productSearchTimers[rowNumber] = setTimeout(function () {
        post('product-search', Object.assign(basePayload(), { query: query, limit: 10 }))
          .then(function (data) {
            if (sequence !== state.productSearchSequence[rowNumber] || !input.isConnected) return;
            renderProductSearchResults(searchBox, rowNumber, data.results || [], query);
          })
          .catch(function (err) {
            if (sequence !== state.productSearchSequence[rowNumber] || !input.isConnected) return;
            state.productSearchResults[rowNumber] = [];
            if (results) {
              results.innerHTML = '<div class="va-bulk-product-search-empty va-bulk-product-search-empty--error">' + escHtml(err.message) + '</div>';
              results.hidden = false;
            }
            if (stateText) stateText.textContent = 'Search unavailable';
          });
      }, 300);
    }

    function resetProductSearchState() {
      Object.keys(state.productSearchTimers).forEach(function (rowNumber) {
        clearTimeout(state.productSearchTimers[rowNumber]);
      });
      state.productSearchTimers = {};
      state.productSearchSequence = {};
      state.productSearchResults = {};
    }

    function fulfillmentCell(row, status) {
      if (status.key === 'short') {
        return '<strong class="va-bulk-fulfillment va-bulk-fulfillment--short">Unallocated Position</strong><div class="va-bulk-row-msg">No available substitute selected</div>';
      }
      if (status.key === 'blocked') {
        return '<strong class="va-bulk-fulfillment va-bulk-fulfillment--short">Validation required</strong>';
      }
      if (status.key === 'subbed') {
        var candidates = availableReplacementCandidates(row);
        var priority = candidates.findIndex(function (candidate) {
          return String(candidate.sku || '').toUpperCase() === String(row.actualSku || '').toUpperCase();
        });
        var saved = state.lineOverrides[Number(row.rowNumber || 0)] || {};
        var detail = saved.manual ? 'Manual SKU override' : (priority >= 0 ? 'Mapped to Priority ' + (priority + 1) : 'Mapped from customer-group rules');
        return '<strong class="va-bulk-fulfillment va-bulk-fulfillment--subbed">' + escHtml(row.actualSku || '') + '</strong><div class="va-bulk-row-msg">' + escHtml(detail) + '</div>';
      }
      return '<strong class="va-bulk-fulfillment">' + escHtml(row.actualSku || row.originalSku || '') + '</strong><div class="va-bulk-row-msg">Original Request Allocated</div>';
    }

    function shipToAddressText(row) {
      var shipTo = row && row.shipTo ? row.shipTo : {};
      var statePostal = [shipTo.stateProvince, shipTo.postalCode].filter(Boolean).join(' ');
      var locality = [shipTo.city, statePostal].filter(Boolean).join(', ');
      var country = String(shipTo.countryCode || '').trim();
      return [
        shipTo.addressLine1,
        shipTo.addressLine2,
        locality,
        country && country.toUpperCase() !== 'US' ? country : ''
      ].filter(Boolean).join(', ');
    }

    function renderValidation(data) {
      var rows = data.rows || [];
      var errors = data.errors || [];
      state.orderCount = Number(data.orderCount || 0);
      importCountEl.textContent = String(state.orderCount);
      summaryEl.innerHTML = ''
        + summaryCard('all', 'Uploaded items', data.rowCount == null ? rows.length : data.rowCount, 'Total spreadsheet rows from ' + state.orderCount + ' ' + (state.orderCount === 1 ? 'order' : 'orders'), '')
        + summaryCard('ready', 'Ready to ship', data.readyCount || 0, '✅ 100% Core stock allocated', 'success')
        + summaryCard('subbed', 'Substitutions run', data.substitutionCount || 0, '⚠️ Swapped with rules list', 'alert')
        + summaryCard('short', 'Action required', data.actionRequiredCount || 0, '❌ Completely out of stock', 'danger');
      summaryEl.hidden = false;

      var html = '';
      if (errors.length) {
        html += '<div class="va-bulk-status va-bulk-status--error" style="margin-top:10px;">'
          + errors.map(function (error) { return '<div>' + escHtml(error) + '</div>'; }).join('') + '</div>';
      }

      var groups = {};
      rows.forEach(function (row) {
        var key = row.addressCode || 'Unknown location';
        (groups[key] || (groups[key] = [])).push(row);
      });
      Object.keys(groups).forEach(function (location) {
        var groupRows = groups[location];
        var first = groupRows[0] || {};
        var resolvedLocation = first.shipToCode || location;
        var shipToAddress = shipToAddressText(first);
        var collapsed = state.collapsedLocations[location] === true;
        html += '<section class="va-bulk-location' + (collapsed ? ' is-collapsed' : '') + '" data-bulk-location="' + escHtml(location) + '">'
          + '<button type="button" class="va-bulk-location-head" data-location-toggle aria-expanded="' + (collapsed ? 'false' : 'true') + '">'
          + '<span class="va-bulk-location-title"><span aria-hidden="true">📍</span> Location Code: <strong>' + escHtml(resolvedLocation) + '</strong>'
          + (shipToAddress ? '<span class="va-bulk-location-address"> — ' + escHtml(shipToAddress) + '</span>' : '') + '</span>'
          + '<span class="va-bulk-location-meta"><span class="va-bulk-location-count">' + groupRows.length + ' Lines Processed</span>'
          + '<svg class="va-bulk-location-chevron" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M5 7.5l5 5 5-5"></path></svg></span></button>'
          + '<div class="va-bulk-table-wrap"><table class="va-bulk-table"><thead><tr>'
          + '<th>Line #</th><th class="va-bulk-original-image-head">Product</th><th>Original SKU</th><th class="va-bulk-number">Req Qty</th><th>Match Status</th><th>Fulfillment SKU</th><th>Actions / Alternates Override</th>'
          + '</tr></thead><tbody>';
        groupRows.forEach(function (row) {
          var status = rowDisplayStatus(row);
          var originalSku = String(row.originalSku || '').trim();
          var fallbackTitle = originalProductFallbackTitle(row);
          var initialTitle = fallbackTitle || 'Loading product details…';
          html += '<tr data-bulk-status="' + status.key + '" data-row-number="' + escHtml(row.rowNumber) + '" data-original-sku="' + escHtml(originalSku) + '"' + (status.key === 'blocked' ? ' class="has-error"' : '') + '>'
            + '<td>#' + escHtml(row.rowNumber) + '</td>'
            + '<td class="va-bulk-original-image-cell"><span class="va-bulk-original-image"><span class="va-bulk-original-image-placeholder is-loading" aria-hidden="true"></span></span></td>'
            + '<td class="va-bulk-original-cell"><strong>' + escHtml(originalSku) + '</strong><div class="va-bulk-row-msg va-bulk-original-title" data-fallback-title="' + escHtml(fallbackTitle) + '" title="' + escHtml(initialTitle) + '">' + escHtml(initialTitle) + '</div></td>'
            + '<td class="va-bulk-number">' + escHtml(row.quantity == null ? '' : row.quantity) + '</td>'
            + '<td><span class="va-bulk-badge va-bulk-badge--' + status.key + '"><span class="va-bulk-badge-dot"></span>' + escHtml(status.label) + '</span></td>'
            + '<td>' + fulfillmentCell(row, status) + '</td>'
            + '<td>' + renderOverrideControl(row, status) + '</td></tr>';
        });
        html += '</tbody></table></div></section>';
      });
      html += '<div class="va-bulk-filter-empty" hidden>No rows match this filter.</div>';
      previewEl.innerHTML = html;
      previewEl.hidden = false;
      applyBulkFilter(state.activeFilter);
      scheduleOriginalProductHydration();
    }

    function resetImportedOrdersPanel() {
      if (importedOrdersPanel) importedOrdersPanel.hidden = true;
      if (importedOrdersList) importedOrdersList.innerHTML = '';
      if (importedOrdersSub) {
        importedOrdersSub.textContent = "This bulk upload's successful orders, refreshed from Business Central.";
      }
    }

    function renderImportedOrders(orders, emptyMessage) {
      if (!importedOrdersPanel || !importedOrdersList) return;
      if (!orders || !orders.length) {
        importedOrdersList.innerHTML = '<div class="va-empty">'
          + escHtml(emptyMessage || 'The created orders are still becoming available in Business Central.')
          + '</div>';
        importedOrdersPanel.hidden = false;
        return;
      }
      importedOrdersList.innerHTML = orders.map(function (order) {
        return renderOrderRowHtml(order, false);
      }).join('');
      importedOrdersPanel.hidden = false;
    }

    function loadImportedOrders(job) {
      var successful = (job.results || []).filter(function (result) {
        return result.status === 'Success';
      });
      if (!successful.length || !state.jobId || !state.jobToken) {
        resetImportedOrdersPanel();
        return;
      }

      var requestedJobId = state.jobId;
      importedOrdersPanel.hidden = false;
      importedOrdersList.innerHTML = '<div class="va-empty">Refreshing the new orders from Business Central...</div>';
      if (importedOrdersSub) {
        importedOrdersSub.textContent = successful.length + ' successful order'
          + (successful.length === 1 ? '' : 's') + ' from this bulk upload.';
      }

      fetch(apiBase + '/jobs/' + encodeURIComponent(requestedJobId) + '/orders?token=' + encodeURIComponent(state.jobToken))
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data.error || 'Could not refresh imported orders.');
            return data;
          });
        })
        .then(function (data) {
          if (requestedJobId !== state.jobId) return;
          renderImportedOrders(data.orders || [], data.warning);
          if (importedOrdersSub) {
            importedOrdersSub.textContent = data.warning
              ? successful.length + ' successful order' + (successful.length === 1 ? '' : 's')
                + '. ' + data.warning
              : successful.length + ' successful order' + (successful.length === 1 ? '' : 's')
                + ', refreshed from Business Central.';
          }
        })
        .catch(function (err) {
          if (requestedJobId !== state.jobId) return;
          importedOrdersList.innerHTML = '<div class="va-empty">The orders were created, but their BC details could not be refreshed: '
            + escHtml(err.message) + '</div>';
          if (importedOrdersSub) importedOrdersSub.textContent = successful.length + ' successful order'
            + (successful.length === 1 ? '' : 's') + ' from this bulk upload.';
        });
    }

    function resetDraft() {
      if (state.busy) return;
      fileReadSequence += 1;
      originalProductHydrationSequence += 1;
      if (originalProductObserver) originalProductObserver.disconnect();
      originalProductObserver = null;
      clearTimeout(state.pollTimer);
      state.fileName = '';
      state.csv = '';
      state.canImport = false;
      state.jobId = '';
      state.jobToken = '';
      state.activeFilter = 'all';
      state.orderCount = 0;
      state.lineOverrides = {};
      resetProductSearchState();
      state.collapsedLocations = {};
      fileInput.value = '';
      progressEl.hidden = true;
      summaryEl.hidden = true;
      previewEl.hidden = true;
      resultsEl.hidden = true;
      resetImportedOrdersPanel();
      summaryEl.innerHTML = '';
      previewEl.innerHTML = '';
      resultsEl.innerHTML = '';
      setStatus('Draft workspace reset. Choose a CSV to begin validation.');
      refreshButtons();
    }

    function validateFile() {
      if (!state.csv || !state.contextLoaded || state.contextUnavailable || state.busy) return;
      state.canImport = false;
      resultsEl.hidden = true;
      setStatus('Checking every SFID, SKU, inventory quantity, price, and ACH account…');
      setBusy(
        true,
        'Validating CSV…',
        'Checking every location, SKU, inventory quantity, price, and ACH payment method.'
      );
      post('validate', filePayload()).then(function (data) {
        state.canImport = data.canImport === true;
        renderValidation(data);
        setStatus(
          state.canImport ? 'File checked successfully. Ready to import bulk orders.' : 'File checked. Resolve the highlighted items before importing.',
          state.canImport ? 'success' : 'error'
        );
      }).catch(function (err) {
        setStatus('Validation failed: ' + err.message, 'error');
      }).finally(function () {
        setBusy(false);
      });
    }

    function importOrders() {
      if (!state.canImport || state.busy) return;
      summaryEl.hidden = true;
      previewEl.hidden = true;
      resultsEl.hidden = true;
      resultsEl.innerHTML = '';
      resetImportedOrdersPanel();
      progressEl.hidden = false;
      progressEl.querySelector('.va-bulk-progress-label').textContent = 'Queueing orders';
      progressEl.querySelector('.va-bulk-progress-count').textContent = '0 / ' + (state.orderCount || 0) + ' locations';
      progressEl.querySelector('.va-bulk-progress-bar').style.width = '0%';
      window.requestAnimationFrame(function () {
        progressEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      setStatus('Queueing validated location orders for Business Central...');
      setBusy(
        true,
        'Submitting bulk orders…',
        'Queueing the validated location orders for Business Central.',
        false
      );
      post('import', filePayload()).then(function (data) {
        state.jobId = data.jobId || '';
        state.jobToken = data.jobToken || '';
        if (!state.jobId || !state.jobToken) throw new Error('The API did not return a queue job.');
        progressEl.hidden = false;
        setStatus('Order job queued. You can keep this page open while locations are processed.');
        pollJob(data.pollAfterMs || 1500);
      }).catch(function (err) {
        setStatus('Import failed: ' + err.message, 'error');
        setBusy(false);
        progressEl.hidden = true;
        summaryEl.hidden = false;
        previewEl.hidden = false;
      });
    }

    function bulkResultDetails(result, failed) {
      var details = String(result && result.details || "").trim();
      if (!failed || !details) return details;

      var propertyMatch = details.match(/property\s+['"]([^'"]+)['"]\s+does not exist/i);
      var correlationMatch = details.match(/CorrelationId:\s*([0-9a-f-]{36})/i);
      var reference = correlationMatch ? " Reference: " + correlationMatch[1] + "." : "";

      if (propertyMatch) {
        return "Business Central could not create this order because its order API does not support the field “"
          + propertyMatch[1] + "”. Please contact customer support." + reference;
      }
      if (/invalid sales order data|BC API call|BadRequest/i.test(details)) {
        return "Business Central rejected the sales order data. Please contact customer support." + reference;
      }
      return details;
    }

    function renderJob(job) {
      var complete = Number(job.completedGroups || 0);
      var total = Number(job.totalGroups || 0);
      var percent = Math.max(0, Math.min(100, Number(job.percentComplete || 0)));
      progressEl.querySelector('.va-bulk-progress-label').textContent = job.status + (job.currentLocation ? ' · ' + job.currentLocation : '');
      progressEl.querySelector('.va-bulk-progress-count').textContent = complete + ' / ' + total + ' locations';
      progressEl.querySelector('.va-bulk-progress-bar').style.width = percent + '%';
      var results = job.results || [];
      resultsEl.innerHTML = results.map(function (result) {
        var failed = result.status !== 'Success' && result.status !== 'Skipped';
        var details = bulkResultDetails(result, failed);
        return '<div class="va-bulk-result' + (failed ? ' va-bulk-result--failed' : '') + '">'
          + '<strong>' + escHtml(result.addressCode || '') + '</strong>'
          + '<span>' + escHtml(result.salesOrderNo || result.status || '') + '</span>'
          + '<span>' + escHtml(details) + '</span></div>';
      }).join('');
      resultsEl.hidden = !results.length;
    }

    function pollJob(delay) {
      clearTimeout(state.pollTimer);
      state.pollTimer = setTimeout(function () {
        fetch(apiBase + '/jobs/' + encodeURIComponent(state.jobId) + '?token=' + encodeURIComponent(state.jobToken))
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) throw new Error(data.error || 'Could not read job status.');
              return data;
            });
          })
          .then(function (data) {
            var job = data.job || {};
            renderJob(job);
            var terminal = job.status === 'Completed' || job.status === 'CompletedWithErrors' || job.status === 'Failed';
            if (!terminal) { pollJob(1500); return; }
            state.canImport = false;
            setBusy(false);
            setStatus(
              job.status === 'Completed'
                ? 'All ' + (job.totalGroups || 0) + ' location orders were processed.'
                : (job.failedGroups || 0) + ' location order(s) need review. Successful locations were still submitted.',
              job.status === 'Completed' ? 'success' : 'error'
            );
            loadImportedOrders(job);
          }).catch(function (err) {
            setStatus('Progress check failed; retrying: ' + err.message, 'error');
            pollJob(3000);
          });
      }, delay || 1500);
    }

    if (templateLink) templateLink.addEventListener('click', downloadCustomerTemplate);
    if (addressDownloadLink) addressDownloadLink.addEventListener('click', downloadAddressRecords);

    fileInput.addEventListener('change', function () {
      var file = fileInput.files && fileInput.files[0];
      var readSequence = ++fileReadSequence;
      state.fileName = '';
      state.csv = '';
      state.canImport = false;
      clearTimeout(state.pollTimer);
      state.jobId = '';
      state.jobToken = '';
      state.activeFilter = 'all';
      state.orderCount = 0;
      state.lineOverrides = {};
      resetProductSearchState();
      state.collapsedLocations = {};
      progressEl.hidden = true;
      summaryEl.hidden = true;
      previewEl.hidden = true;
      resultsEl.hidden = true;
      resetImportedOrdersPanel();
      if (!file) { refreshButtons(); return; }
      if (file.size > 25 * 1024 * 1024) {
        setStatus('CSV file exceeds the 25 MB limit.', 'error');
        refreshButtons();
        return;
      }
      var reader = new FileReader();
      reader.onload = function () {
        fileBufferToCsv(reader.result, file.name).then(function (csv) {
          if (readSequence !== fileReadSequence) return;
          state.fileName = file.name;
          state.csv = csv;
          refreshButtons();
          if (state.contextLoaded) validateFile();
          else loadContext();
        }).catch(function () {
          if (readSequence !== fileReadSequence) return;
          setStatus('Could not read the selected CSV.', 'error');
          refreshButtons();
        });
      };
      reader.onerror = function () {
        if (readSequence !== fileReadSequence) return;
        setStatus('Could not read the selected CSV.', 'error');
      };
      reader.readAsArrayBuffer(file);
    });

    achSelect.addEventListener('change', function () {
      state.canImport = false;
      refreshButtons();
      if (state.csv) validateFile();
    });
    summaryEl.addEventListener('click', function (event) {
      var card = event.target.closest('[data-bulk-filter]');
      if (card && summaryEl.contains(card)) applyBulkFilter(card.dataset.bulkFilter);
    });
    previewEl.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-location-toggle]');
      if (toggle) {
        var location = toggle.closest('.va-bulk-location');
        var collapsed = !location.classList.contains('is-collapsed');
        location.classList.toggle('is-collapsed', collapsed);
        toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        state.collapsedLocations[location.dataset.bulkLocation] = collapsed;
        return;
      }

      var resultButton = event.target.closest('.va-bulk-product-search-result');
      if (!resultButton || resultButton.disabled || state.busy) return;
      var rowNumber = Number(resultButton.dataset.rowNumber || 0);
      var resultIndex = Number(resultButton.dataset.resultIndex || 0);
      var product = (state.productSearchResults[rowNumber] || [])[resultIndex];
      if (!product || !product.sku) return;
      state.lineOverrides[rowNumber] = {
        action: 'use',
        sku: String(product.sku).trim().toUpperCase(),
        manual: true,
        productTitle: product.productTitle || product.displayName || '',
        imageUrl: product.imageUrl || '',
        availableForSale: product.availableForSale === true,
        sellableOnlineQuantity: Math.max(0, Number(product.sellableOnlineQuantity || 0)),
        stockLabel: shopifyStockLabel(product)
      };
      validateFile();
    });
    previewEl.addEventListener('input', function (event) {
      var input = event.target.closest('.va-bulk-product-search-input');
      if (!input || state.busy) return;
      var manual = input.closest('[data-manual-row]');
      searchProductsForRow(Number(manual && manual.dataset.manualRow || 0), input);
    });
    previewEl.addEventListener('change', function (event) {
      var select = event.target.closest('.va-bulk-override-select');
      if (!select || state.busy) return;
      var rowNumber = Number(select.dataset.rowNumber || 0);
      var manual = previewEl.querySelector('[data-manual-row="' + rowNumber + '"]');
      if (select.value === 'manual') {
        if (manual) {
          manual.classList.add('is-visible');
          var input = manual.querySelector('input');
          if (input) input.focus();
        }
        return;
      }
      if (manual) manual.classList.remove('is-visible');
      state.productSearchResults[rowNumber] = [];
      state.productSearchSequence[rowNumber] = Number(state.productSearchSequence[rowNumber] || 0) + 1;
      if (select.value === 'skip') {
        state.lineOverrides[rowNumber] = { action: 'skip', sku: '', manual: false };
      } else if (select.value.indexOf('use|') === 0) {
        state.lineOverrides[rowNumber] = { action: 'use', sku: select.value.slice(4), manual: false };
      }
      validateFile();
    });
    previewEl.addEventListener('keydown', function (event) {
      var input = event.target.closest('.va-bulk-product-search-input');
      if (!input) return;
      var results = input.closest('.va-bulk-product-search').querySelector('.va-bulk-product-search-results');
      if (event.key === 'Escape') {
        results.hidden = true;
        return;
      }
      if (event.key !== 'Enter') return;
      var firstResult = results.querySelector('.va-bulk-product-search-result:not(:disabled)');
      if (!firstResult) return;
      event.preventDefault();
      firstResult.click();
    });
    resetBtn.addEventListener('click', resetDraft);
    importBtn.addEventListener('click', importOrders);
    rulesBtn.addEventListener('click', openRules);
    rulesCancelButtons.forEach(function (button) {
      button.addEventListener('click', closeRules);
    });
    rulesSave.addEventListener('click', saveRules);
    if (rulesCsvImport && rulesCsvFile) {
      rulesCsvImport.addEventListener('click', function () {
        if (!rulesState.loading) rulesCsvFile.click();
      });
      rulesCsvFile.addEventListener('change', function () {
        importRulesCsv(rulesCsvFile.files && rulesCsvFile.files[0]);
      });
    }
    if (rulesCsvExport) rulesCsvExport.addEventListener('click', exportRulesCsv);
    rulesDlg.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeRules();
    });
    rulesDlg.addEventListener('close', function () {
      document.documentElement.classList.remove('va-bulk-rules-open');
      clearRulesSearchState();
    });
    rulesFilter.addEventListener('input', function () {
      rulesState.filter = rulesFilter.value || '';
      clearRulesSearchState();
      renderRulesGrid();
    });
    rulesAdd.addEventListener('click', function () {
      var row = {
        id: rulesState.nextRowId++,
        note: '',
        skus: []
      };
      rulesState.rows.push(padRuleRow(row));
      rulesState.filter = '';
      rulesFilter.value = '';
      renderRulesGrid();
      var noteInput = rulesGridBody.querySelector('[data-rule-row="' + row.id + '"] .va-bulk-rule-note');
      if (noteInput) noteInput.focus();
    });
    rulesAddPriority.addEventListener('click', function () {
      rulesState.priorityCount += 1;
      rulesState.rows.forEach(padRuleRow);
      clearRulesSearchState();
      renderRulesGrid();
      if (rulesGridWrap) rulesGridWrap.scrollLeft = rulesGridWrap.scrollWidth;
    });
    rulesGridBody.addEventListener('input', function (event) {
      var rowElement = event.target.closest('[data-rule-row]');
      var row = findRuleRow(rowElement && rowElement.dataset.ruleRow);
      if (!row) return;
      if (event.target.classList.contains('va-bulk-rule-note')) {
        row.note = event.target.value;
        return;
      }
      var input = event.target.closest('.va-bulk-rule-sku-input');
      if (!input) return;
      var editor = input.closest('.va-bulk-rule-sku-editor');
      var priority = Number(editor.dataset.rulePriority || 0);
      var slot = row.skus[priority - 1];
      var sku = String(input.value || '').trim().toUpperCase();
      slot.sku = sku;
      slot.product = null;
      slot.validated = !sku || sku === slot.originalSku;
      var productCard = editor.querySelector('.va-bulk-rule-product');
      if (productCard) productCard.outerHTML = ruleSelectedProductHtml(slot);
      searchProductsForRule(input, false);
    });
    rulesGridBody.addEventListener('focusin', function (event) {
      var input = event.target.closest('.va-bulk-rule-sku-input');
      if (!input || String(input.value || '').trim().length < 2) return;
      searchProductsForRule(input, true);
    });
    rulesGridBody.addEventListener('click', function (event) {
      var result = event.target.closest('.va-bulk-rule-search-result');
      if (result) {
        chooseRuleProduct(result.closest('.va-bulk-rule-sku-editor'), result.dataset.ruleResultIndex);
        return;
      }
      var remove = event.target.closest('[data-rule-delete]');
      if (!remove) return;
      var rowId = Number(remove.dataset.ruleDelete || 0);
      rulesState.rows = rulesState.rows.filter(function (row) { return row.id !== rowId; });
      clearRulesSearchState();
      renderRulesGrid();
      setRulesFeedback('Rule group removed. Save profiles to apply this change.');
    });
    rulesGridBody.addEventListener('keydown', function (event) {
      var input = event.target.closest('.va-bulk-rule-sku-input');
      if (!input) return;
      var editor = input.closest('.va-bulk-rule-sku-editor');
      var results = editor.querySelector('.va-bulk-rule-search-results');
      if (event.key === 'Escape') {
        results.hidden = true;
        return;
      }
      if (event.key !== 'Enter' || results.hidden) return;
      var firstResult = results.querySelector('.va-bulk-rule-search-result');
      if (!firstResult) return;
      event.preventDefault();
      firstResult.click();
    });
    rulesGridWrap.addEventListener('scroll', function () {
      panel.querySelectorAll('.va-bulk-rule-search-results').forEach(function (results) {
        results.hidden = true;
      });
    });

    new MutationObserver(function () {
      if (panel.classList.contains('va-tab--active')) loadContext();
    }).observe(panel, { attributes: true, attributeFilter: ['class'] });
    if (panel.classList.contains('va-tab--active')) loadContext();
  }());

  // ── ACH accounts + Credit cards (Payment tab) ────────────
  (function () {
    var panel = document.getElementById('va-tab-payment');
    if (!panel) return;
    var $ = function (s) { return panel.querySelector(s); };

    var isCricket = true; //show cc to all customers now.
    // Auto pay feeds the Cricket ABO ordering flow, so the entry stays Cricket-only
    // even though the credit-card panel itself is shown to every customer.
    // Resolved in vaMarketReady.then below, before any achRender() can run.
    var isAutoPayMarket = false;
    var achState  = { loaded: false, accounts: [] };
    var listWrap  = $('.va-ach-accounts');
    var ccWrap    = $('.va-cc-accounts');
    var ccPanel   = $('.va-cc-panel');
    var ccAddForm = $('.va-cc-add-form');
    var ccFormErr = $('.va-cc-form-err');
    var achForm   = $('.va-ach-add-form');
    var achFormErr = $('.va-ach-form-err');

    // ── Admin check: hide the controls that change a saved account ─
    // Anyone on the account can add a bank account or card, so a non-admin who
    // sees a past-due balance can still pay it. Removing an account, setting
    // which locations may use it, and auto pay stay admin-only.
    var isAdmin = false; // default-deny until confirmed
    var currentEmail = ((window.__vaAuth || {}).customer_email || '').trim().toLowerCase();
    achProxy({ action: 'user-admin' }, function (d) {
      var me = (d.users || []).find(function (u) { return (u.email || '').trim().toLowerCase() === currentEmail; });
      isAdmin = me ? !!me.isAdmin : false;
      applyAdminVisibility();
    }, function () {
      isAdmin = false;
      applyAdminVisibility();
    });

    function applyAdminVisibility() {
      panel.querySelectorAll('.va-ach-remove-btn, .va-set-perm-btn, .va-autopay').forEach(function (el) { el.hidden = !isAdmin; });
    }

    function achProxy(payload, onOk, onErr) {
      var auth = window.__vaAuth || {};
      fetch(auth.proxy || '', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign({ customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop }, payload))
      }).then(function (r) { return r.json(); }).then(function (d) {
        if (!d.ok) throw new Error(d.error || 'Error');
        onOk(d);
      }).catch(onErr);
    }

    var bankIcon = '<div class="va-pay-icon"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></svg></div>';

    function detectBrand(n) {
      if (/^4/.test(n))              return 'visa';
      if (/^(5[1-5]|2[2-7])/.test(n)) return 'mastercard';
      if (/^3[47]/.test(n))          return 'amex';
      if (/^(6011|65|64[4-9]|622)/.test(n)) return 'discover';
      return '';
    }
    // Format expiration date → "MM/YY"
    // Accepts BC format (YYYY-MM-DD) or user-input format (MM/YY)
    function fmtExpiry(s) {
      if (!s) return '';
      var m = String(s).match(/^(\d{4})-(\d{2})/);       // BC: YYYY-MM-DD
      if (m) return m[2] + '/' + m[1].slice(2);
      m = String(s).match(/^(\d{1,2})\/(\d{2})$/);        // user: MM/YY
      if (m) return (m[1].length < 2 ? '0' + m[1] : m[1]) + '/' + m[2];
      return '';
    }

    // Auto pay is one switch per saved account: on = this account funds the ABO
    // orders, off = nothing does. Only one can be on, so flipping one on clears
    // the others server-side and the re-render reflects that.
    function autoPaySwitch(a) {
      var id = escHtml(a.id);
      return '<label class="va-autopay" for="va-autopay-' + id + '"'
        + ' title="Charge ABO purchase orders to this account automatically">'
        + '<input type="checkbox" class="va-autopay-input" id="va-autopay-' + id + '" data-id="' + id + '"'
        + (a.autoPayForABO ? ' checked' : '') + '>'
        + '<span class="va-autopay-sw" aria-hidden="true"></span>'
        + '<span class="va-autopay-text">Use for auto pay</span>'
        + '</label>';
    }

    function achRender() {
      var ccAccs  = achState.accounts.filter(function (a) { return a.accountType === 'CreditCard'; });
      var achAccs = achState.accounts.filter(function (a) { return a.accountType !== 'CreditCard'; });

      // Credit card section (visibility controlled by ccPanel.hidden — see vaMarketReady.then)
      if (ccWrap) {
        if (!ccAccs.length) {
          ccWrap.innerHTML = '<div class="va-pay-empty">No credit cards on file.</div>';
        } else {
          var ccHtml = '<div class="va-pay-list">';
          ccAccs.forEach(function (a) {
            var name    = escHtml(a.cardHolderName || a.bankName || 'Credit card');
            var cardNum = a.last4 ? '\u2022\u2022\u2022\u2022\u00a0\u2022\u2022\u2022\u2022\u00a0\u2022\u2022\u2022\u2022\u00a0' + escHtml(a.last4) : '';
            var expiry  = fmtExpiry(a.expirationDate);
            ccHtml += '<div class="va-pay-item">' + brandIcon(a.brand || '', 52, 34)
              + '<div class="va-pay-item-info">'
              + '<span class="va-pay-item-name">' + name + '</span>'
              + (cardNum ? '<span class="va-pay-item-sep">&middot;</span><span class="va-pay-item-sub">' + cardNum + '</span>' : '')
              + (expiry ? '<span class="va-pay-item-sep">&middot;</span><span class="va-pay-item-sub">Exp.\u00a0' + escHtml(expiry) + '</span>' : '')
              + (a.zip ? '<span class="va-pay-item-sep">&middot;</span><span class="va-pay-item-sub">' + escHtml(a.zip) + '</span>' : '')
              + '</div>'
              + (vaHasChildren ? '<button class="va-set-perm-btn" data-id="' + escHtml(a.id) + '">Set permission</button>' : '')
              + (isAutoPayMarket ? autoPaySwitch(a) : '')
              + '<button class="va-ach-remove-btn" data-id="' + escHtml(a.id) + '">Remove</button>'
              + '</div>';
          });
          ccWrap.innerHTML = ccHtml + '</div>';
        }
      }

      // ACH section
      if (!listWrap) return;
      if (!achAccs.length) {
        listWrap.innerHTML = '<div class="va-pay-empty">No saved bank accounts.</div>';
        applyAdminVisibility();
        return;
      }
      var html = '<div class="va-pay-list">';
      achAccs.forEach(function (a) {
        var sub = a.last4 ? '\u2022\u2022\u2022\u2022\u00a0' + escHtml(a.last4) : 'ACH';
        html += '<div class="va-pay-item">' + bankIcon
          + '<div class="va-pay-item-info">'
          + '<span class="va-pay-item-name">' + escHtml(a.bankName || 'Bank account') + '</span>'
          + '<span class="va-pay-item-sep">&middot;</span>'
          + '<span class="va-pay-item-sub">' + sub + '</span>'
          + (a.nickName ? '<span class="va-pay-item-sep">&middot;</span><span class="va-pay-item-sub">' + escHtml(a.nickName) + '</span>' : '')
          + '</div>'
          + (vaHasChildren ? '<button class="va-set-perm-btn" data-id="' + escHtml(a.id) + '">Set permission</button>' : '')
          + (isAutoPayMarket ? autoPaySwitch(a) : '')
          + '<button class="va-ach-remove-btn" data-id="' + escHtml(a.id) + '">Remove</button></div>';
      });
      listWrap.innerHTML = html + '</div>';
      applyAdminVisibility();
    }

    function achLoad() {
      if (listWrap) listWrap.innerHTML = '<div class="va-pay-loading">Loading accounts\u2026</div>';
      if (ccWrap) ccWrap.innerHTML = '<div class="va-pay-loading">Loading\u2026</div>';
      achProxy({ action: 'ach-list' }, function (d) {
        achState.accounts = d.accounts || [];
        achState.loaded = true;
        achRender();
      }, function (err) {
        if (listWrap) listWrap.innerHTML = '<div class="va-pay-error">' + escHtml('Could not load accounts: ' + err.message) + '</div>';
      });
    }

    function achDelete(id, btn) {
      vaConfirm({ msg: 'Remove this bank account?', okLabel: 'Remove', danger: true }).then(function (ok) { if (ok) _achDelete(id, btn); });
    }
    function _achDelete(id, btn) {
      btn.disabled = true; btn.textContent = 'Removing\u2026';
      achProxy({ action: 'ach-delete', system_id: id }, function () {
        achState.accounts = achState.accounts.filter(function (a) { return a.id !== id; });
        achRender();
      }, function (err) {
        btn.disabled = false; btn.textContent = 'Remove';
        if (listWrap) listWrap.insertAdjacentHTML('afterend', '<div class="va-pay-error">' + escHtml(err.message) + '</div>');
      });
    }

    function autoPayError(msg) {
      var prev = panel.querySelector('.va-autopay-err');
      if (prev) prev.remove();
      if (!msg) return;
      panel.insertAdjacentHTML('afterbegin', '<div class="va-pay-error va-autopay-err" style="margin:12px 22px;">' + escHtml(msg) + '</div>');
    }

    function ccToggleAutoPay(id, input) {
      var on = input.checked;
      autoPayError('');
      // Turning it on records an authorization, so it keeps the agreement gate.
      // Turning it off only withdraws one, and needs no agreement — but it does
      // stop ABO orders from being paid, which is worth one confirmation.
      var gate = on
        ? vaCcAgree()
        : vaConfirm({ msg: 'Turn off auto pay for this account? ABO orders will no longer be charged to it automatically.', okLabel: 'Turn off' });
      gate.then(function (ok) {
        if (!ok) { input.checked = !on; return; }   // :checked drives the visuals
        _ccSetAutoPay(id, input, on);
      });
    }

    function _ccSetAutoPay(id, input, on) {
      var label = input.closest('.va-autopay');
      input.disabled = true;
      if (label) label.classList.add('is-saving');
      achProxy({ action: 'cc-set-default', system_id: id, enabled: on }, function () {
        // Server-side, switching one on clears every other account.
        achState.accounts.forEach(function (a) {
          a.autoPayForABO = on ? (a.id === id) : (a.autoPayForABO && a.id !== id);
        });
        achRender();
      }, function (err) {
        input.disabled = false;
        input.checked  = !on;
        if (label) label.classList.remove('is-saving');
        autoPayError(err.message);
      });
    }

    function ccShowAddForm(show) {
      if (ccAddForm) ccAddForm.hidden = !show;
      var openBtn = $('.va-cc-open-add');
      if (openBtn) openBtn.hidden = show;
      if (ccFormErr) { ccFormErr.hidden = true; ccFormErr.textContent = ''; }
      if (show && ccAddForm) { var first = ccAddForm.querySelector('input'); if (first) first.focus(); }
    }

    function ccSave() {
      var f       = ccAddForm;
      var holder  = (f && f.querySelector('[name=cc_holder]')  || {value:''}).value.trim();
      var cardNum = (f && f.querySelector('[name=cc_number]')  || {value:''}).value.replace(/\D/g,'');
      var expiry  = (f && f.querySelector('[name=cc_expiry]')  || {value:''}).value.trim();
      var cvv     = (f && f.querySelector('[name=cc_cvv]')     || {value:''}).value.trim(); // forwarded to ERP via NoSeries
      var zip     = (f && f.querySelector('[name=cc_zip]')     || {value:''}).value.trim();
      var street  = (f && f.querySelector('[name=cc_street]')  || {value:''}).value.trim();
      var city    = (f && f.querySelector('[name=cc_city]')    || {value:''}).value.trim();
      var state   = (f && f.querySelector('[name=cc_state]')   || {value:''}).value.trim();
      var consent = f && f.querySelector('[name=cc_consent]');
      function showErr(msg) { if (ccFormErr) { ccFormErr.textContent = msg; ccFormErr.hidden = false; } }
      if (!holder)                              { showErr('Cardholder name is required.'); return; }
      if (cardNum.length < 13)                  { showErr('Please enter a valid card number.'); return; }
      if (!/^\d{2}\/\d{2}$/.test(expiry))      { showErr('Please enter expiry as MM/YY.'); return; }
      if (!cvv || cvv.length < 3)              { showErr('Please enter the CVV.'); return; }
      if (!zip)                                 { showErr('Billing ZIP is required.'); return; }
      if (!consent || !consent.checked)         { showErr('Please agree to the authorization terms to continue.'); return; }
      if (ccFormErr) ccFormErr.hidden = true;
      var saveBtn = ccPanel && ccPanel.querySelector('.va-cc-save');
      if (saveBtn) { saveBtn.disabled = true; saveBtn.textContent = 'Saving\u2026'; }
      var last4 = cardNum.slice(-4);
      achProxy({ action: 'cc-create', holder: holder, card_number: cardNum, last4: last4, expiry: expiry, cvv: cvv, zip: zip, street: street, city: city, state: state },
        function (d) {
          achState.accounts.push({ id: d.bc_system_id, code: d.code, bankName: d.bankName || '', last4: last4, accountType: 'CreditCard', autoPayForABO: false, cardHolderName: holder, brand: detectBrand(cardNum), zip: zip, expirationDate: expiry });
          achRender();
          ccShowAddForm(false);
          if (f) { f.querySelectorAll('input[type=text],input[type=checkbox]').forEach(function(i){ if(i.type==='checkbox') i.checked=false; else i.value=''; }); }
          if (saveBtn) { saveBtn.disabled = false; saveBtn.textContent = 'Save card'; }
        },
        function (err) {
          if (ccFormErr) { ccFormErr.textContent = err.message; ccFormErr.hidden = false; }
          if (saveBtn) { saveBtn.disabled = false; saveBtn.textContent = 'Save card'; }
        }
      );
    }

    function achShowForm(show) {
      if (achForm) achForm.hidden = !show;
      var openBtn = $('.va-ach-open');
      if (openBtn) openBtn.hidden = show;
      if (achFormErr) { achFormErr.hidden = true; achFormErr.textContent = ''; }
      if (show) { var first = achForm && achForm.querySelector('input'); if (first) first.focus(); }
    }

    function achSave() {
      var holder   = (achForm.querySelector('[name=holder]')   || {}).value || '';
      var routing  = (achForm.querySelector('[name=routing]')  || {}).value || '';
      var account  = (achForm.querySelector('[name=account]')  || {}).value || '';
      var nickName = (achForm.querySelector('[name=nickName]') || {}).value || '';
      if (!holder.trim() || !routing.trim() || !account.trim()) {
        if (achFormErr) { achFormErr.textContent = 'Please fill in all fields.'; achFormErr.hidden = false; }
        return;
      }
      if (achFormErr) achFormErr.hidden = true;
      var saveBtn = $('.va-ach-save');
      if (saveBtn) { saveBtn.disabled = true; saveBtn.textContent = 'Saving\u2026'; }
      achProxy({ action: 'ach-create', holder: holder.trim(), routing: routing.trim(), account: account.trim(), nick_name: nickName.trim() },
        function (d) {
          achState.accounts.push({ id: d.bc_system_id, code: d.code || '', bankName: d.bankName || 'Bank account', last4: d.last4 || null, accountType: 'ACH', autoPayForABO: false, nickName: d.nickName || '' });
          achRender();
          achShowForm(false);
          achForm.querySelectorAll('input').forEach(function (i) { i.value = ''; });
          if (saveBtn) { saveBtn.disabled = false; saveBtn.textContent = 'Save bank account'; }
        },
        function (err) {
          if (achFormErr) { achFormErr.textContent = err.message; achFormErr.hidden = false; }
          if (saveBtn) { saveBtn.disabled = false; saveBtn.textContent = 'Save bank account'; }
        }
      );
    }

    // Permission popup
    var permModal = document.getElementById('va-perm-modal');
    var permState = { account: null, maps: [], children: [] };

    function permUpdateAllChk() {
      var btn = permModal.querySelector('.va-perm-select-all-btn');
      if (!btn) return;
      var visible = Array.from(permModal.querySelectorAll('.va-perm-item')).filter(function (el) { return el.style.display !== 'none'; });
      var allChecked = visible.length > 0 && visible.every(function (el) { return el.querySelector('input[type=checkbox]').checked; });
      btn.textContent = allChecked ? 'Unselect all' : 'Select all';
    }

    function permApplyFilter() {
      var searchEl  = permModal.querySelector('.va-perm-search');
      var searchWrap = searchEl && searchEl.closest('.va-perm-search-wrap');
      var q = searchEl ? searchEl.value.toLowerCase().trim() : '';
      if (searchWrap) searchWrap.classList.toggle('has-value', q.length > 0);
      permModal.querySelectorAll('.va-perm-item').forEach(function (el) {
        var text = el.textContent.toLowerCase();
        el.style.display = (!q || text.includes(q)) ? '' : 'none';
      });
      permUpdateAllChk();
    }

    function achPermOpen(account) {
      permState.account  = account;
      permState.maps     = [];
      permState.children = [];
      var listEl   = permModal.querySelector('.va-perm-list');
      var subEl    = permModal.querySelector('.va-perm-sub');
      var errEl    = permModal.querySelector('.va-perm-error');
      var searchEl = permModal.querySelector('.va-perm-search');
      var searchWrap = searchEl && searchEl.closest('.va-perm-search-wrap');
      if (searchEl)  { searchEl.value = ''; }
      if (searchWrap) searchWrap.classList.remove('has-value');
      var _sub = account.last4 ? '\u2022\u2022\u2022\u2022\u00a0' + account.last4 : 'ACH';
      var _subParts = [account.bankName || 'Bank account', _sub];
      if (account.nickName) _subParts.push(account.nickName);
      subEl.textContent  = _subParts.join(' \u00b7 ');
      listEl.innerHTML   = '<div class="va-pay-loading">Loading\u2026</div>';
      errEl.hidden       = true;
      var defaultNote = permModal.querySelector('.va-perm-default-note');
      if (defaultNote) defaultNote.hidden = true;
      permModal.hidden   = false;
      achProxy({ action: 'ach-perm-list', bank_account_system_id: account.id }, function (d) {
        permState.maps     = d.maps     || [];
        permState.children = d.children || [];
        if (!permState.children.length) {
          listEl.innerHTML = '<div class="va-pay-empty">No child companies found.</div>';
          return;
        }
        var enabledNos = {};
        permState.maps.forEach(function (m) { if (m.customerNo !== 'C0000105') enabledNos[m.customerNo] = true; });
        if (defaultNote) defaultNote.hidden = permState.maps.length > 0;
        var html = '';
        permState.children.forEach(function (c) {
          var chk = enabledNos[c.customerNo] ? ' checked' : '';
          html += '<label class="va-perm-item">'
            + '<input type="checkbox" value="' + escHtml(c.customerNo) + '"' + chk + '>'
            + '<span class="va-perm-item-name">' + escHtml(c.name || c.customerNo) + '</span>'
            + '<span class="va-perm-item-no">' + escHtml(c.customerNo) + '</span>'
            + '</label>';
        });
        listEl.innerHTML = html;
        permUpdateAllChk();
      }, function (err) {
        listEl.innerHTML = '<div class="va-pay-error">' + escHtml(err.message) + '</div>';
      });
    }

    function achPermSave(btn) {
      var listEl = permModal.querySelector('.va-perm-list');
      var errEl  = permModal.querySelector('.va-perm-error');
      var checkedNos = {};
      listEl.querySelectorAll('input[type=checkbox]:checked').forEach(function (el) { checkedNos[el.value] = true; });
      var prevByNo = {};
      permState.maps.forEach(function (m) { if (m.customerNo !== 'C0000105') prevByNo[m.customerNo] = m.systemId; });
      var toAdd = [], toDelete = [];
      Object.keys(checkedNos).forEach(function (no) { if (!prevByNo[no]) toAdd.push(no); });
      Object.keys(prevByNo).forEach(function (no)  { if (!checkedNos[no]) toDelete.push(prevByNo[no]); });
      if (!toAdd.length && !toDelete.length) { permModal.hidden = true; return; }
      btn.disabled = true; btn.textContent = 'Saving\u2026';
      errEl.hidden = true;
      achProxy({
        action: 'ach-perm-save',
        bank_account_system_id: permState.account.id,
        to_add:    toAdd,
        to_delete: toDelete,
      }, function () {
        btn.disabled = false; btn.textContent = 'Save';
        permModal.hidden = true;
      }, function (err) {
        btn.disabled = false; btn.textContent = 'Save';
        errEl.textContent = err.message; errEl.hidden = false;
      });
    }

    // Single event listener via delegation
    panel.addEventListener('click', function (e) {
      if (e.target.closest('.va-ach-open'))     { achShowForm(true);  return; }
      if (e.target.closest('.va-ach-cancel'))   { achShowForm(false); return; }
      if (e.target.closest('.va-ach-save'))     { achSave();          return; }
      if (e.target.closest('.va-cc-open-add'))  { ccShowAddForm(true);  return; }
      if (e.target.closest('.va-cc-cancel-add')){ ccShowAddForm(false); return; }
      if (e.target.closest('.va-cc-save'))      { ccSave();             return; }
      var permBtn = e.target.closest('.va-set-perm-btn');
      if (permBtn) {
        var acct = achState.accounts.find(function (a) { return a.id === permBtn.dataset.id; });
        if (acct) achPermOpen(acct);
        return;
      }
      if (e.target.closest('.va-perm-save'))   { achPermSave(e.target.closest('.va-perm-save')); return; }
      if (e.target.closest('.va-perm-cancel') || e.target.closest('.va-perm-close')) { permModal.hidden = true; return; }
      var rb = e.target.closest('.va-ach-remove-btn');
      if (rb) achDelete(rb.dataset.id, rb);
    });
    // Close permission modal on backdrop click
    permModal.addEventListener('click', function (e) { if (e.target === permModal) permModal.hidden = true; });

    // Perm modal: filter input
    var permSearchEl = permModal.querySelector('.va-perm-search');
    if (permSearchEl) {
      permSearchEl.addEventListener('input', permApplyFilter);
    }
    // Perm modal: clear filter button
    var permClearBtn = permModal.querySelector('.va-perm-search-clear');
    if (permClearBtn) {
      permClearBtn.addEventListener('click', function () {
        if (permSearchEl) { permSearchEl.value = ''; permSearchEl.focus(); }
        permApplyFilter();
      });
    }
    // Perm modal: select-all / unselect-all button
    permModal.addEventListener('click', function (e) {
      var btn = e.target.closest('.va-perm-select-all-btn');
      if (!btn) return;
      var visible = Array.from(permModal.querySelectorAll('.va-perm-item')).filter(function (el) { return el.style.display !== 'none'; });
      var allChecked = visible.every(function (el) { return el.querySelector('input[type=checkbox]').checked; });
      visible.forEach(function (el) { el.querySelector('input[type=checkbox]').checked = !allChecked; });
      permUpdateAllChk();
    });
    // Auto-pay switches (credit cards + bank accounts)
    panel.addEventListener('change', function (e) {
      var sw = e.target.closest('.va-autopay-input');
      if (sw) ccToggleAutoPay(sw.dataset.id, sw);
    });

    // Perm modal: individual checkbox → update select-all button label
    permModal.addEventListener('change', function (e) {
      if (e.target.matches('.va-perm-item input[type=checkbox]')) permUpdateAllChk();
    });

    // Load accounts when tab becomes active
    vaMarketReady.then(function () {
      //isCricket = (vaMarketHandle === 'CRICKET-WIRELESS'); //show cc to all customers now.
      isAutoPayMarket = (vaMarketHandle === 'CRICKET-WIRELESS');
      if (isCricket && ccPanel) ccPanel.hidden = false;
      if (panel.classList.contains('va-tab--active')) achLoad();
      new MutationObserver(function () {
        if (panel.classList.contains('va-tab--active') && !achState.loaded) achLoad();
      }).observe(panel, { attributes: true, attributeFilter: ['class'] });
    });
  }());

  // ── ERP addresses (Address tab) ─────────────────────────
  (function () {
    var addrTab = document.getElementById('va-tab-addresses');
    if (!addrTab) return;
    var listEl    = addrTab.querySelector('.va-erp-addr-list');
    var actionsEl = addrTab.querySelector('.va-erp-addr-actions');
    if (!listEl) return;

    var addrState = { loaded: false, addresses: [], editing: null, adding: false, page: 0, q: '' };
    var ADDR_PAGE_SIZE = 40;
    var addrIsAdmin = false;
    var locIcon = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>';

    function addrProxy(payload, onOk, onErr) {
      var auth = window.__vaAuth || {};
      fetch(auth.proxy || '', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign({ customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop }, payload))
      }).then(function (r) { return r.json(); }).then(function (d) {
        if (!d.ok) throw new Error(d.error || 'Error');
        onOk(d);
      }).catch(onErr);
    }

    var addrCurrentEmail = ((window.__vaAuth || {}).customer_email || '').trim().toLowerCase();
    addrProxy({ action: 'user-admin' }, function (d) {
      var me = (d.users || []).find(function (u) { return (u.email || '').trim().toLowerCase() === addrCurrentEmail; });
      addrIsAdmin = me ? !!me.isAdmin : false;
      if (addrState.loaded) addrRender();
    }, function () {
      addrIsAdmin = false;
      if (addrState.loaded) addrRender();
    });

    function fmtAddr(a) {
      var line1 = [a.address, a.address2].filter(Boolean).join(', ');
      var line2 = [a.city, a.county].filter(Boolean).join(', ') + (a.postCode ? ' ' + a.postCode : '');
      return [line1, line2, a.countryRegionCode].filter(Boolean).join(', ');
    }

    // Client-side filter across every field shown on the card
    function addrFiltered() {
      var q = (addrState.q || '').trim().toLowerCase();
      if (!q) return addrState.addresses;
      return addrState.addresses.filter(function (a) {
        return [a.name, a.contact, a.code, a.address, a.address2, a.city, a.county,
                a.postCode, a.countryRegionCode, a.phoneNo, a.salesForceId]
          .filter(Boolean).join(' ').toLowerCase().indexOf(q) !== -1;
      });
    }

    var ADDR_COUNTRIES = [
      ['US','United States'],['CA','Canada'],['MX','Mexico'],['GB','United Kingdom'],
      ['AU','Australia'],['NZ','New Zealand'],['JP','Japan'],['CN','China'],['IN','India'],
      ['SG','Singapore'],['HK','Hong Kong'],['TW','Taiwan'],['KR','South Korea'],
      ['MY','Malaysia'],['PH','Philippines'],['ID','Indonesia'],['TH','Thailand'],
      ['VN','Vietnam'],['IL','Israel'],['AE','United Arab Emirates'],['SA','Saudi Arabia'],
      ['DE','Germany'],['FR','France'],['IT','Italy'],['ES','Spain'],['NL','Netherlands'],
      ['BE','Belgium'],['SE','Sweden'],['NO','Norway'],['DK','Denmark'],['CH','Switzerland'],
      ['AT','Austria'],['PL','Poland'],['PT','Portugal'],['IE','Ireland'],
      ['BR','Brazil'],['AR','Argentina'],['CL','Chile'],['CO','Colombia'],['PE','Peru'],
      ['GT','Guatemala'],['CR','Costa Rica'],['DO','Dominican Republic'],['PR','Puerto Rico'],
    ];
    function countrySelectHtml(name, selectedCode) {
      var sel = '<select name="' + name + '" required aria-required="true">';
      sel += '<option value="">— Select country —</option>';
      ADDR_COUNTRIES.forEach(function(c) {
        var code = c[0], label = c[1];
        sel += '<option value="' + code + '"' + (code === (selectedCode || '') ? ' selected' : '') + '>' + label + '</option>';
      });
      sel += '</select>';
      return '<label class="va-field">' + 'Country *' + sel + '</label>';
    }

    // Shopify's zoneCode only accepts these codes, but Business Central stores
    // State / Province as free text — an unrecognized value made Shopify reject
    // the whole address at checkout ("Zone code is invalid"). A select here is
    // what the registration popup and cart already use for this field.
    var ADDR_ZONES = {
      US: [
        ['AL','Alabama'],['AK','Alaska'],['AZ','Arizona'],['AR','Arkansas'],
        ['CA','California'],['CO','Colorado'],['CT','Connecticut'],['DE','Delaware'],
        ['DC','District of Columbia'],['FL','Florida'],['GA','Georgia'],['HI','Hawaii'],
        ['ID','Idaho'],['IL','Illinois'],['IN','Indiana'],['IA','Iowa'],
        ['KS','Kansas'],['KY','Kentucky'],['LA','Louisiana'],['ME','Maine'],
        ['MD','Maryland'],['MA','Massachusetts'],['MI','Michigan'],['MN','Minnesota'],
        ['MS','Mississippi'],['MO','Missouri'],['MT','Montana'],['NE','Nebraska'],
        ['NV','Nevada'],['NH','New Hampshire'],['NJ','New Jersey'],['NM','New Mexico'],
        ['NY','New York'],['NC','North Carolina'],['ND','North Dakota'],['OH','Ohio'],
        ['OK','Oklahoma'],['OR','Oregon'],['PA','Pennsylvania'],['RI','Rhode Island'],
        ['SC','South Carolina'],['SD','South Dakota'],['TN','Tennessee'],['TX','Texas'],
        ['UT','Utah'],['VT','Vermont'],['VA','Virginia'],['WA','Washington'],
        ['WV','West Virginia'],['WI','Wisconsin'],['WY','Wyoming'],
        ['PR','Puerto Rico'],['VI','Virgin Islands'],['GU','Guam'],
        ['AS','American Samoa'],['MP','Northern Mariana Islands'],
        ['AA','Armed Forces Americas'],['AE','Armed Forces Europe'],['AP','Armed Forces Pacific']
      ],
      CA: [
        ['AB','Alberta'],['BC','British Columbia'],['MB','Manitoba'],['NB','New Brunswick'],
        ['NL','Newfoundland and Labrador'],['NS','Nova Scotia'],['NT','Northwest Territories'],
        ['NU','Nunavut'],['ON','Ontario'],['PE','Prince Edward Island'],['QC','Quebec'],
        ['SK','Saskatchewan'],['YT','Yukon']
      ]
    };

    // Mirrors toZoneCode() in proxy.php. Returns '' when the stored value can't be
    // resolved, so the required field makes the buyer pick instead of carrying a
    // value Shopify will refuse. BC leaves the domestic country blank, and the
    // cart has always read that as the US, so do the same here.
    function zoneCountry(code) { return String(code || 'US').toUpperCase(); }

    function normZone(state, countryCode) {
      var list = ADDR_ZONES[zoneCountry(countryCode)];
      var raw  = String(state == null ? '' : state).replace(/\s+/g, ' ').trim();
      if (!list) return raw;
      var key = raw.replace(/\./g, '').replace(/\s+/g, ' ').trim().toUpperCase();
      if (!key) return '';
      var alias = {
        'WASHINGTON DC': 'DC', 'WASHINGTON, DC': 'DC', 'US VIRGIN ISLANDS': 'VI',
        'NEWFOUNDLAND': 'NL', 'YUKON TERRITORY': 'YT'
      };
      if (alias[key]) return alias[key];
      for (var i = 0; i < list.length; i++) {
        if (list[i][0] === key || list[i][1].toUpperCase() === key) return list[i][0];
      }
      return '';
    }

    function zoneFieldHtml(state, countryCode) {
      var cc   = zoneCountry(countryCode);
      var list = ADDR_ZONES[cc];
      var head = '<label class="va-field va-erp-zone">State / Province *';
      if (!list) {
        return head + '<input type="text" name="county" value="' + escHtml(state || '')
          + '" required aria-required="true"></label>';
      }
      var cur = normZone(state, cc);
      var sel = '<select name="county" required aria-required="true">';
      sel += '<option value="">— —</option>';
      list.forEach(function (z) {
        sel += '<option value="' + z[0] + '"' + (z[0] === cur ? ' selected' : '') + '>' + z[1] + '</option>';
      });
      sel += '</select>';
      return head + sel + '</label>';
    }

    function editFormHtml(a) {
      function f(name, label, val, optional, full) {
        var required = optional ? '' : ' required aria-required="true"';
        return '<label class="va-field' + (full ? ' va-erp-full' : '') + '">' + label + (optional ? '' : ' *')
          + '<input type="text" name="' + name + '" value="' + escHtml(val || '') + '"' + required + '></label>';
      }
      return '<div class="va-erp-edit" data-edit="' + escHtml(a.code) + '">'
        + '<div class="va-erp-edit-grid">'
        + f('name',              'Name',            a.name, false)
        + f('contact',           'Contact',         a.contact, false)
        + f('address',           'Address',         a.address, false)
        + f('address2',          'Suite / Unit',    a.address2, true)
        + f('city',              'City',            a.city, false)
        + zoneFieldHtml(a.county, a.countryRegionCode)
        + f('postCode',          'Zip code',     	a.postCode, false)
        + countrySelectHtml('countryRegionCode',    a.countryRegionCode)
        + f('phoneNo',           'Phone',           a.phoneNo, true)
        + '</div>'
        + '<div class="va-pay-actions">'
        + '<button class="va-btn va-btn--primary va-erp-save" data-code="' + escHtml(a.code) + '">Save changes</button>'
        + '<button class="va-btn va-erp-cancel" data-code="' + escHtml(a.code) + '">Cancel</button>'
        + '</div>'
        + '<div class="va-erp-form-err va-pay-error" hidden></div>'
        + '</div>';
    }

    function newAddrFormHtml() {
      function f(name, label, optional, full) {
        var required = optional ? '' : ' required aria-required="true"';
        return '<label class="va-field' + (full ? ' va-erp-full' : '') + '">' + label + (optional ? '' : ' *')
          + '<input type="text" name="' + name + '" value=""' + required + '></label>';
      }
      return '<div class="va-erp-edit va-erp-new-form">'
        + '<div class="va-erp-edit-grid">'
        + f('name',              'Name', false)
        + f('contact',           'Contact', false)
        + f('address',           'Address', false)
        + f('address2',          'Suite / Unit', true)
        + f('city',              'City', false)
        + zoneFieldHtml('', 'US')
        + f('postCode',          'Zip code', false)
        + countrySelectHtml('countryRegionCode', 'US')
        + f('phoneNo',           'Phone', true)
        + '</div>'
        + '<div class="va-pay-actions">'
        + '<button class="va-btn va-btn--primary va-erp-create">Add address</button>'
        + '<button class="va-btn va-erp-new-cancel">Cancel</button>'
        + '</div>'
        + '<div class="va-erp-form-err va-pay-error" hidden></div>'
        + '</div>';
    }

    function addrRender() {
      if (actionsEl) {
        if (vaMarketHandle !== 'BOOST-MOBILE' && addrIsAdmin) {
          actionsEl.innerHTML = addrState.adding
            ? newAddrFormHtml()
            : '<button class="va-btn va-btn--ghost va-erp-add-btn">&#43; Add address</button>';
        } else {
          actionsEl.innerHTML = '';
        }
      }
      var rows      = addrFiltered();
      var total     = rows.length;
      var totalPages = Math.ceil(total / ADDR_PAGE_SIZE) || 1;
      if (addrState.page >= totalPages) addrState.page = Math.max(0, totalPages - 1);
      var pageStart = addrState.page * ADDR_PAGE_SIZE;
      var pageAddrs = rows.slice(pageStart, pageStart + ADDR_PAGE_SIZE);

      var html = '';
      if (!total && !addrState.adding) {
        html += addrState.q
          ? '<div class="va-pay-empty">No locations match &ldquo;' + escHtml(addrState.q) + '&rdquo;.</div>'
          : '<div class="va-pay-empty">No ship-to addresses on file.</div>';
      }
      pageAddrs.forEach(function (a) {
        html += '<div class="va-erp-item">'
          + '<div class="va-erp-row">'
          + '<div class="va-erp-icon">' + locIcon + '</div>'
          + '<div class="va-erp-info">'
          + '<div class="va-erp-name">' + escHtml(a.name || a.code) + '</div>'
          + (a.contact ? '<div class="va-erp-contact">Contact: ' + escHtml(a.contact) + '</div>' : '')
          + '<div class="va-erp-addr">' + fmtAddr(a) + '</div>'
          + (a.phoneNo ? '<div class="va-erp-phone">' + escHtml(a.phoneNo) + '</div>' : '')
          + '<div class="va-erp-code">' + escHtml(a.code) + (a.salesForceId ? ' &middot; ' + escHtml(a.salesForceId) : '') + '</div>'
          + '</div>'
          + (vaMarketHandle === 'BOOST-MOBILE' || !addrIsAdmin ? '' :
            '<div class="va-erp-actions">'
            + '<button class="va-erp-btn va-erp-edit-btn" data-code="' + escHtml(a.code) + '">'
            + (addrState.editing === a.code ? 'Cancel' : 'Edit') + '</button>'
            + '<button class="va-erp-btn danger va-erp-del-btn" data-code="' + escHtml(a.code) + '" data-system-id="' + escHtml(a.systemId || a.SystemId || '') + '">Remove</button>'
            + '</div>')
          + '</div>'
          + (addrState.editing === a.code ? editFormHtml(a) : '')
          + '</div>';
      });
      if (totalPages > 1) {
        html += '<div class="va-inv-pager">'
          + '<button class="va-inv-pager-btn va-addr-pager-prev"' + (addrState.page === 0 ? ' disabled' : '') + '>\u2190 Prev</button>'
          + '<span class="va-inv-pager-info">Page ' + (addrState.page + 1) + ' of ' + totalPages + '</span>'
          + '<button class="va-inv-pager-btn va-addr-pager-next"' + (addrState.page >= totalPages - 1 ? ' disabled' : '') + '>Next \u2192</button>'
          + '</div>';
      }
      listEl.innerHTML = html;
    }

    function addrLoad() {
      listEl.innerHTML = '<div class="va-pay-loading">Loading addresses\u2026</div>';
      vaMarketReady.then(function () {
        addrProxy({ action: 'address-list', include_children: true }, function (d) {
          addrState.addresses = d.addresses || [];
          addrState.loaded = true;
          addrRender();
          var cnt = addrState.addresses.length;
          var metricEl = document.getElementById('va-metric-addr-count');
          var subEl    = document.getElementById('va-dash-addr-sub');
          var listEl   = document.getElementById('va-dash-addr-list');
          if (metricEl) metricEl.textContent = cnt;
          if (subEl)    subEl.textContent    = cnt + ' saved location' + (cnt !== 1 ? 's' : '');
          if (listEl) {
            if (cnt === 0) {
              listEl.innerHTML = '<div class="va-empty">No addresses saved.</div>';
            } else {
              listEl.innerHTML = addrState.addresses.slice(0, 4).map(function (a) {
                return '<div class="va-list-item">'
                  + '<div class="va-list-item-icon" style="background:var(--va-parchment);color:var(--va-steel);">'
                  + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>'
                  + '</div>'
                  + '<div class="va-list-info">'
                  + '<div class="va-list-name">' + escHtml(a.name || '') + '</div>'
                  + '<div class="va-list-meta">' + escHtml([a.city, a.state].filter(Boolean).join(', ')) + '</div>'
                  + '</div></div>';
              }).join('');
            }
          }
        }, function (err) {
          listEl.innerHTML = '<div class="va-pay-error">' + escHtml('Could not load: ' + err.message) + '</div>';
        });
      });
    }

    function addrValidate(form) {
      var missing = [];
      var labels = {
        name: 'Name',
        contact: 'Contact',
        address: 'Address',
        city: 'City',
        county: 'State / Province',
        postCode: 'Zip code',
        countryRegionCode: 'Country',
        phoneNo: 'Phone'
      };
      form.querySelectorAll('[required]').forEach(function (field) {
        var empty = !String(field.value || '').trim();
        field.setAttribute('aria-invalid', empty ? 'true' : 'false');
        if (empty) missing.push(labels[field.name] || field.name);
      });
      var errEl = form.querySelector('.va-erp-form-err');
      if (!missing.length) {
        if (errEl) errEl.hidden = true;
        return true;
      }
      if (errEl) {
        errEl.textContent = 'Please complete the required fields: ' + missing.join(', ') + '.';
        errEl.hidden = false;
      }
      var firstMissing = form.querySelector('[aria-invalid="true"]');
      if (firstMissing) firstMissing.focus();
      return false;
    }

    function addrSave(code) {
      var form = listEl.querySelector('[data-edit="' + code + '"]');
      if (!form) return;
      if (!addrValidate(form)) return;
      var addrMeta = addrState.addresses.find(function (x) { return x.code === code; });
      var payload = { action: 'address-update', code: code, system_id: addrMeta?.systemId || addrMeta?.SystemId || '', bc_customer_no: addrMeta?.customerNo || '' };
      form.querySelectorAll('input[name], select[name]').forEach(function (i) { payload[i.name] = i.value.trim(); });
      var saveBtn = form.querySelector('.va-erp-save');
      if (saveBtn) { saveBtn.disabled = true; saveBtn.textContent = 'Saving\u2026'; }
      addrProxy(payload, function (resp) {
        var a = addrState.addresses.find(function (x) { return x.code === code; });
        // Show what the server stored, not what was typed: it rewrites the phone to
        // E.164, so echoing the typed value left the row showing 9092223330 while
        // BC held +19092223330. Falls back to the payload for older responses.
        var stored = (resp && resp.fields) || {};
        if (a) ['name','contact','address','address2','city','county','postCode','countryRegionCode','phoneNo'].forEach(function (k) {
          if (k in stored)       a[k] = stored[k];
          else if (k in payload) a[k] = payload[k];
        });
        addrState.editing = null;
        addrRender();
      }, function (err) {
        if (saveBtn) { saveBtn.disabled = false; saveBtn.textContent = 'Save changes'; }
        var errEl = form.querySelector('.va-erp-form-err');
        if (errEl) { errEl.textContent = err.message; errEl.hidden = false; }
      });
    }

    function addrDelete(code, systemId, btn) {
      vaConfirm({ msg: 'Remove this ship-to address from ERP?', okLabel: 'Remove', danger: true }).then(function (ok) { if (ok) _addrDelete(code, systemId, btn); });
    }
    function _addrDelete(code, systemId, btn) {
      btn.disabled = true; btn.textContent = 'Removing\u2026';
      addrProxy({ action: 'address-delete', system_id: systemId }, function () {
        addrState.addresses = addrState.addresses.filter(function (a) { return a.code !== code; });
        if (addrState.editing === code) addrState.editing = null;
        addrRender();
      }, function (err) {
        btn.disabled = false; btn.textContent = 'Remove';
        listEl.insertAdjacentHTML('afterbegin', '<div class="va-pay-error">' + escHtml(err.message) + '</div>');
      });
    }

    function addrCreate() {
      var form = actionsEl.querySelector('.va-erp-new-form');
      if (!form) return;
      if (!addrValidate(form)) return;
      var payload = { action: 'address-create' };
      form.querySelectorAll('input[name], select[name]').forEach(function (i) { payload[i.name] = i.value.trim(); });
      var saveBtn = form.querySelector('.va-erp-create');
      if (saveBtn) { saveBtn.disabled = true; saveBtn.textContent = 'Adding\u2026'; }
      addrProxy(payload, function () {
        addrState.adding = false;
        addrState.loaded = false;
        addrLoad();
      }, function (err) {
        if (saveBtn) { saveBtn.disabled = false; saveBtn.textContent = 'Add address'; }
        var errEl = form.querySelector('.va-erp-form-err');
        if (errEl) { errEl.textContent = err.message; errEl.hidden = false; }
      });
    }

    function addrHandleClick(e) {
      var eb = e.target.closest('.va-erp-edit-btn');
      if (eb) { addrState.editing = addrState.editing === eb.dataset.code ? null : eb.dataset.code; addrRender(); return; }
      var db = e.target.closest('.va-erp-del-btn');
      if (db) { addrDelete(db.dataset.code, db.dataset.systemId, db); return; }
      var sb = e.target.closest('.va-erp-save');
      if (sb) { addrSave(sb.dataset.code); return; }
      var cb = e.target.closest('.va-erp-cancel');
      if (cb) { addrState.editing = null; addrRender(); return; }
      var ab = e.target.closest('.va-erp-add-btn');
      if (ab) { addrState.adding = true; addrState.editing = null; addrRender(); return; }
      var nc = e.target.closest('.va-erp-new-cancel');
      if (nc) { addrState.adding = false; addrRender(); return; }
      var cr = e.target.closest('.va-erp-create');
      if (cr) { addrCreate(); return; }
      var pp = e.target.closest('.va-addr-pager-prev');
      if (pp && addrState.page > 0) { addrState.page--; addrState.editing = null; addrRender(); return; }
      var pn = e.target.closest('.va-addr-pager-next');
      if (pn) { addrState.page++; addrState.editing = null; addrRender(); return; }
    }
    listEl.addEventListener('click', addrHandleClick);
    if (actionsEl) actionsEl.addEventListener('click', addrHandleClick);

    // Country decides which zone control the form needs, so swap it on change and
    // carry the current entry across so correcting the country doesn't blank it.
    function addrHandleChange(e) {
      var cs = e.target.closest && e.target.closest('select[name="countryRegionCode"]');
      if (!cs) return;
      var form = cs.closest('.va-erp-edit');
      if (!form) return;
      var zone = form.querySelector('.va-erp-zone');
      if (!zone) return;
      var cur = zone.querySelector('[name="county"]');
      zone.outerHTML = zoneFieldHtml(cur ? cur.value : '', cs.value);
    }
    listEl.addEventListener('change', addrHandleChange);
    if (actionsEl) actionsEl.addEventListener('change', addrHandleChange);

    // Filter input (static HTML, set up once)
    ;(function () {
      var searchEl    = document.getElementById('va-erp-addr-search');
      var searchWrap  = searchEl && searchEl.closest('.va-inv-search-wrap');
      var searchClear = document.getElementById('va-erp-addr-search-clear');
      function apply(q) {
        addrState.q = q;
        addrState.page = 0;
        addrState.editing = null;
        if (searchWrap) searchWrap.classList.toggle('has-value', q.length > 0);
        if (addrState.loaded) addrRender();
      }
      if (searchEl) searchEl.addEventListener('input', function () { apply(searchEl.value); });
      if (searchClear) searchClear.addEventListener('click', function () {
        if (searchEl) { searchEl.value = ''; searchEl.focus(); }
        apply('');
      });
    }());

    if (addrTab.classList.contains('va-tab--active')) addrLoad();
    new MutationObserver(function () {
      if (addrTab.classList.contains('va-tab--active') && !addrState.loaded) addrLoad();
    }).observe(addrTab, { attributes: true, attributeFilter: ['class'] });
  }());

  // ── Invoices ─────────────────────────────────────────────
  (function () {
    var invTab = document.getElementById('va-tab-invoices');
    if (!invTab) return;
    var listEl = document.getElementById('va-inv-list');
    if (!listEl) return;

    var invState = {
      page: 1, hasMore: false, totalPages: null, totalCount: null,
      invoices: [], loaded: false, loading: false,
      selected: new Map(), bulkBusy: false
    };
    var INV_BULK_MAX = 25;

    function invQueryParams() {
      var startEl    = document.getElementById('va-inv-date-start');
      var endEl      = document.getElementById('va-inv-date-end');
      var childrenEl = document.getElementById('va-inv-include-children');
      var s = startEl ? startEl.value : '';
      var e = endEl   ? endEl.value   : '';
      var params = {};
      if (s && e) { params.startDate = s; params.endDate = e; }
      // Default true; only false when the toggle is visible (20+ locations) and explicitly unchecked
      var toggleEl = document.getElementById('va-inv-children-toggle');
      params.includeChildren = !(toggleEl && !toggleEl.hidden && childrenEl && !childrenEl.checked);
      return params;
    }

    // Set default date range: last 3 months
    ;(function () {
      var fmt = function (d) { return d.toISOString().slice(0, 10); };
      var end = new Date(), start = new Date();
      start.setMonth(start.getMonth() - 3);
      var startEl = document.getElementById('va-inv-date-start');
      var endEl   = document.getElementById('va-inv-date-end');
      if (startEl) startEl.value = fmt(start);
      if (endEl)   endEl.value   = fmt(end);
    }());

    // Filter bar wiring (inputs are in static HTML, set up once)
    ;(function () {
      var searchEl  = document.getElementById('va-inv-search');
      var searchWrap = searchEl && searchEl.closest('.va-inv-search-wrap');
      var searchClear = document.getElementById('va-inv-search-clear');
      var minEl    = document.getElementById('va-inv-min');
      var maxEl    = document.getElementById('va-inv-max');
      if (searchEl) searchEl.addEventListener('input', function () {
        if (searchWrap) searchWrap.classList.toggle('has-value', searchEl.value.length > 0);
        invApplyFilter();
      });
      if (searchClear) searchClear.addEventListener('click', function () {
        if (searchEl) { searchEl.value = ''; searchEl.focus(); }
        if (searchWrap) searchWrap.classList.remove('has-value');
        invApplyFilter();
      });
      if (minEl) minEl.addEventListener('input', invApplyFilter);
      if (maxEl) maxEl.addEventListener('input', invApplyFilter);
      var dateStartEl    = document.getElementById('va-inv-date-start');
      var dateEndEl      = document.getElementById('va-inv-date-end');
      var childrenToggle = document.getElementById('va-inv-children-toggle');
      var childrenChk    = document.getElementById('va-inv-include-children');
      var onDateChange = function () { invClearSelection(); invState.loaded = false; invLoad(1); };
      if (dateStartEl) dateStartEl.addEventListener('change', onDateChange);
      if (dateEndEl)   dateEndEl.addEventListener('change', onDateChange);
      if (childrenChk) childrenChk.addEventListener('change', onDateChange);
      // Show toggle only when customer has child locations (vaHasChildren set after customer-info loads)
      window.__vaCustomerInfo && window.__vaCustomerInfo.then(function (info) {
        if (childrenToggle && (info && (info.childCount || 0) >= 20)) childrenToggle.hidden = false;
      });
    }());

    // Statement download — reuses the invoice list From/To date range
    ;(function () {
      var pdfBtn = document.getElementById('va-statement-dl');
      var xlsBtn = document.getElementById('va-statement-xls-dl');
      if (!pdfBtn && !xlsBtn) return;
      var msgEl = document.getElementById('va-statement-msg');
      function showMsg(text) {
        if (!msgEl) { alert(text); return; }
        msgEl.textContent = text; msgEl.hidden = false;
      }
      function clearMsg() { if (msgEl) { msgEl.hidden = true; msgEl.textContent = ''; } }
      function downloadStatement(format, btn) {
        clearMsg();
        var startEl = document.getElementById('va-inv-date-start');
        var endEl   = document.getElementById('va-inv-date-end');
        var start = startEl ? startEl.value : '';
        var end   = endEl   ? endEl.value   : '';
        if (!start || !end) { showMsg('Please set both a From and To date first.'); return; }
        if (start > end)    { showMsg('The From date must be on or before the To date.'); return; }
        var origHtml = btn.innerHTML;
        if (pdfBtn) pdfBtn.disabled = true;
        if (xlsBtn) xlsBtn.disabled = true;
        btn.innerHTML = spinIcon + ' Generating…';
        invProxy(
          { action: 'customer-statement', start_date: start, end_date: end, format: format },
          function (d) {
            try {
              var bytes = atob(d.content);
              var arr = new Uint8Array(bytes.length);
              for (var i = 0; i < bytes.length; i++) arr[i] = bytes.charCodeAt(i);
              var fallbackMime = format === 'PDF'
                ? 'application/pdf'
                : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
              var fallbackExt = format === 'PDF' ? 'pdf' : 'xlsx';
              var blob = new Blob([arr], { type: d.mimeType || fallbackMime });
              var url  = URL.createObjectURL(blob);
              var a    = document.createElement('a');
              a.href = url; a.download = d.filename || ('Statement-' + start + '-to-' + end + '.' + fallbackExt);
              document.body.appendChild(a); a.click(); document.body.removeChild(a);
              setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
            } catch (e) { showMsg((format === 'PDF' ? 'PDF' : 'XLS') + ' statement download failed.'); }
            if (pdfBtn) pdfBtn.disabled = false;
            if (xlsBtn) xlsBtn.disabled = false;
            btn.innerHTML = origHtml;
          },
          function (err) {
            showMsg(err && err.message ? err.message : 'Statement download failed. Please try again.');
            if (pdfBtn) pdfBtn.disabled = false;
            if (xlsBtn) xlsBtn.disabled = false;
            btn.innerHTML = origHtml;
          }
        );
      }
      if (pdfBtn) pdfBtn.addEventListener('click', function () { downloadStatement('PDF', pdfBtn); });
      if (xlsBtn) xlsBtn.addEventListener('click', function () { downloadStatement('EXCEL', xlsBtn); });
    }());

    // Order filter bar wiring
    ;(function () {
      var searchEl    = document.getElementById('va-orders-search');
      var searchWrap  = searchEl && searchEl.closest('.va-inv-search-wrap');
      var searchClear = document.getElementById('va-orders-search-clear');
      if (searchEl) searchEl.addEventListener('input', function () {
        if (searchWrap) searchWrap.classList.toggle('has-value', searchEl.value.length > 0);
        ordersApplyFilter();
      });
      if (searchClear) searchClear.addEventListener('click', function () {
        if (searchEl) { searchEl.value = ''; searchEl.focus(); }
        if (searchWrap) searchWrap.classList.remove('has-value');
        ordersApplyFilter();
      });
    }());

    function invProxy(payload, onOk, onErr) {
      var auth = window.__vaAuth || {};
      fetch(auth.proxy || '', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign({}, { customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop }, payload))
      }).then(function (r) { return r.json(); }).then(function (d) {
        if (d.ok) onOk(d); else onErr(new Error(d.error || 'Unknown error'));
      }).catch(onErr);
    }

    function invClearSelection() {
      invState.selected.clear();
      invUpdateSelectionUi();
    }

    function invVisibleRows() {
      return Array.prototype.filter.call(listEl.querySelectorAll('.va-inv-row[data-inv-panel]'), function (row) {
        return row.style.display !== 'none';
      });
    }

    function invUpdateSelectionUi() {
      var count = invState.selected.size;
      var countEl = document.getElementById('va-inv-selected-count');
      var pdfBtn = document.getElementById('va-inv-bulk-pdf');
      var xlsBtn = document.getElementById('va-inv-bulk-xls');
      if (countEl) countEl.textContent = count + ' selected' + (count ? ' (maximum ' + INV_BULK_MAX + ')' : '');
      if (pdfBtn) pdfBtn.disabled = invState.bulkBusy || count === 0;
      if (xlsBtn) xlsBtn.disabled = invState.bulkBusy || count === 0;

      var visible = invVisibleRows();
      var selectedVisible = visible.filter(function (row) {
        return invState.selected.has(row.dataset.invNo || '');
      }).length;
      var all = document.getElementById('va-inv-select-all');
      if (all) {
        all.checked = visible.length > 0 && selectedVisible === visible.length;
        all.indeterminate = selectedVisible > 0 && selectedVisible < visible.length;
        all.disabled = invState.bulkBusy || visible.length === 0;
      }
      listEl.querySelectorAll('.va-inv-select[data-inv-no]').forEach(function (box) {
        box.checked = invState.selected.has(box.dataset.invNo || '');
        box.disabled = invState.bulkBusy;
      });
    }

    function invBulkMessage(text, isError) {
      var el = document.getElementById('va-inv-bulk-msg');
      if (!el) return;
      el.textContent = text || '';
      el.hidden = !text;
      el.classList.toggle('is-error', !!isError);
    }

    var invJsZipPromise = null;
    function invLoadJsZip() {
      if (window.JSZip) return Promise.resolve(window.JSZip);
      if (invJsZipPromise) return invJsZipPromise;
      invJsZipPromise = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/jszip@3.10.1/dist/jszip.min.js';
        script.onload = function () { window.JSZip ? resolve(window.JSZip) : reject(new Error('ZIP library did not load.')); };
        script.onerror = function () { reject(new Error('ZIP library could not be loaded.')); };
        document.head.appendChild(script);
      });
      return invJsZipPromise;
    }

    function invReport(invNo, format) {
      var inv = invState.selected.get(invNo) || invState.invoices.find(function (item) {
        return (item.no || item.number || '') === invNo;
      });
      var sellTo = inv ? (inv.sellToCustomerNo || inv.billToCustomerNo || '') : '';
      return new Promise(function (resolve, reject) {
        invProxy({ action: 'invoice-report', invoice_no: invNo, format: format, sell_to_customer_no: sellTo }, resolve, reject);
      });
    }

    function invSafeZipFilename(name, invNo, format) {
      var fallback = 'Invoice-' + invNo + (format === 'PDF' ? '.pdf' : '.xlsx');
      return String(name || fallback).replace(/[\\/:*?"<>|]+/g, '-').replace(/^\.+/, '') || fallback;
    }

    function invDownloadBlob(blob, filename) {
      var url = URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url; link.download = filename;
      document.body.appendChild(link); link.click(); document.body.removeChild(link);
      setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
    }

    function invBulkDownload(format, activeBtn) {
      if (invState.bulkBusy || !invState.selected.size) return;
      var invoiceNos = Array.from(invState.selected.keys());
      if (invoiceNos.length > INV_BULK_MAX) {
        invBulkMessage('Please select no more than ' + INV_BULK_MAX + ' invoices per ZIP.', true);
        return;
      }
      var activeBtnHtml = activeBtn ? activeBtn.innerHTML : '';
      invState.bulkBusy = true;
      invUpdateSelectionUi();
      invBulkMessage('', false);
      if (activeBtn) activeBtn.innerHTML = spinIcon + ' Preparing…';

      invLoadJsZip().then(function (JSZip) {
        var zip = new JSZip();
        var failures = [];
        var usedNames = {};
        var next = 0;
        var complete = 0;

        function worker() {
          var index = next++;
          if (index >= invoiceNos.length) return Promise.resolve();
          var invNo = invoiceNos[index];
          return invReport(invNo, format).then(function (data) {
            var filename = invSafeZipFilename(data.filename, invNo, format);
            var original = filename;
            var suffix = 2;
            while (usedNames[filename]) {
              var dot = original.lastIndexOf('.');
              filename = (dot > 0 ? original.slice(0, dot) : original) + '-' + suffix++ + (dot > 0 ? original.slice(dot) : '');
            }
            usedNames[filename] = true;
            zip.file(filename, data.content, { base64: true });
          }).catch(function (err) {
            failures.push(invNo + ': ' + (err && err.message ? err.message : 'Download failed'));
          }).then(function () {
            complete++;
            return worker();
          });
        }

        var workers = [];
        for (var i = 0; i < Math.min(3, invoiceNos.length); i++) workers.push(worker());
        return Promise.all(workers).then(function () {
          if (failures.length === invoiceNos.length) throw new Error('None of the selected invoices could be generated.');
          if (failures.length) zip.file('FAILED.txt', 'The following invoices could not be generated:\n\n' + failures.join('\n'));
          return zip.generateAsync({ type: 'blob', compression: 'STORE' }).then(function (blob) {
            var date = new Date().toISOString().slice(0, 10);
            invDownloadBlob(blob, 'Invoices-' + format + '-' + date + '.zip');
            invBulkMessage(invoiceNos.length - failures.length + ' invoice' + (invoiceNos.length - failures.length === 1 ? '' : 's') + ' downloaded'
              + (failures.length ? '; ' + failures.length + ' failed (see FAILED.txt).' : '.'), failures.length > 0);
          });
        });
      }).catch(function (err) {
        invBulkMessage(err && err.message ? err.message : 'Bulk invoice download failed. Please try again.', true);
      }).then(function () {
        invState.bulkBusy = false;
        if (activeBtn) activeBtn.innerHTML = activeBtnHtml;
        invUpdateSelectionUi();
      });
    }

    var bulkPdfBtn = document.getElementById('va-inv-bulk-pdf');
    var bulkXlsBtn = document.getElementById('va-inv-bulk-xls');
    if (bulkPdfBtn) bulkPdfBtn.addEventListener('click', function () { invBulkDownload('PDF', bulkPdfBtn); });
    if (bulkXlsBtn) bulkXlsBtn.addEventListener('click', function () { invBulkDownload('EXCEL', bulkXlsBtn); });


    var dlIcon   = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3"/></svg>';
    var pdfIcon  = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="13" y2="17"/></svg>';
    var shipIcon = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
    var spinIcon = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="animation:va-spin 1s linear infinite"><circle cx="12" cy="12" r="9" stroke-dasharray="28 57" stroke-linecap="round"/></svg>';

    function buildLinesTable(lines, cur) {
      var fmtA = function(v) {
        if (v == null) return '\u2014';
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur || 'USD' }).format(v);
      };
      var html = '<table class="va-inv-doc-lines"><thead><tr>'
        + '<th style="width:26px;text-align:center">#</th>'
        + '<th>Item / SKU</th>'
        + '<th style="width:52px;text-align:center">Qty</th>'
        + '<th style="width:90px;text-align:right">Unit Price</th>'
        + '<th style="width:90px;text-align:right">Amount</th>'
        + '</tr></thead><tbody>';
      var lineIdx = 0;
      (lines || []).forEach(function(line) {
        if ((line.type || '').toLowerCase() === 'comment') {
          var noteText = (line.comment != null ? line.comment : (line.description || ''));
          if (!noteText || !noteText.trim()) return;
          lineIdx++;
          html += '<tr>'
            + '<td style="text-align:center;color:var(--va-steel);font-size:11px">' + lineIdx + '</td>'
            + '<td colspan="4"><div class="va-inv-line-note" style="color:var(--va-steel);font-style:italic">' + escHtml(noteText).replace(/\n/g, '<br>') + '</div></td>'
            + '</tr>';
          return;
        }
        var lTitle = line.title || '';
        if (!lTitle && !line.meta) return;
        lineIdx++;
        var lQty = line.quantity   != null ? line.quantity  : '';
        var lUp  = line.unitPrice  != null ? fmtA(line.unitPrice)  : '\u2014';
        var lAmt = line.lineAmount != null ? fmtA(line.lineAmount) : (line.amount != null ? fmtA(line.amount) : '\u2014');
        var metaHtml = escHtml(line.meta || '');
        var cell = '<div class="va-inv-line-sku">' + escHtml(lTitle || 'Unknown product') + '</div>'
                 + (metaHtml ? '<div class="va-inv-line-desc">' + metaHtml + '</div>' : '');
        html += '<tr>'
          + '<td style="text-align:center;color:var(--va-steel);font-size:11px">' + lineIdx + '</td>'
          + '<td>' + cell + '</td>'
          + '<td style="text-align:center">' + escHtml(String(lQty)) + '</td>'
          + '<td style="text-align:right">' + lUp + '</td>'
          + '<td style="text-align:right;font-weight:500">' + lAmt + '</td>'
          + '</tr>';
      });
      html += '</tbody></table>';
      return lineIdx > 0 ? html : '';
    }

    function invUpdateSub() {
      var subEl = document.getElementById('va-invoices-page-sub');
      if (!subEl) return;
      var n = invState.totalCount != null ? invState.totalCount : invState.invoices.length;
      subEl.textContent = n + ' invoice' + (n !== 1 ? 's' : '') + ' \u00b7 click a row to expand';
    }

    function invApplyFilter() {
      var searchEl = document.getElementById('va-inv-search');
      var minEl    = document.getElementById('va-inv-min');
      var maxEl    = document.getElementById('va-inv-max');
      var q    = searchEl ? searchEl.value.trim().toLowerCase() : '';
      var minA = minEl && minEl.value !== '' ? parseFloat(minEl.value) : null;
      var maxA = maxEl && maxEl.value !== '' ? parseFloat(maxEl.value) : null;
      var active = !!(q || minA !== null || maxA !== null);

      var rows = listEl.querySelectorAll('.va-inv-row:not(.va-inv-head)');
      var shown = 0;
      rows.forEach(function (row) {
        var panelId = row.dataset.invPanel;
        var detail  = panelId ? document.getElementById(panelId) : null;
        var amt     = parseFloat(row.dataset.amount || '0');
        var textOk  = !q || (row.dataset.search || '').includes(q);
        var amtOk   = (minA === null || amt >= minA) && (maxA === null || amt <= maxA);
        var visible = textOk && amtOk;
        row.style.display = visible ? '' : 'none';
        if (detail) {
          if (!visible) detail.style.display = 'none';
          else detail.style.display = detail.classList.contains('open') ? 'block' : '';
        }
        if (visible) shown++;
      });

      var subEl = document.getElementById('va-invoices-page-sub');
      if (subEl) {
        if (active && rows.length > 0) {
          subEl.textContent = shown + ' of ' + rows.length + ' invoice' + (rows.length !== 1 ? 's' : '') + ' on this page';
        } else {
          invUpdateSub();
        }
      }
      invUpdateSelectionUi();
    }

    function invRender() {
      if (!invState.invoices.length) {
        listEl.innerHTML = '<div class="va-pay-empty" style="padding:20px 22px;">No invoices found.</div>';
        var subEl = document.getElementById('va-invoices-page-sub');
        if (subEl) subEl.textContent = 'No invoices found.';
        return;
      }
      var chevronIcon = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 9l6 6 6-6"/></svg>';
      var html = '<div class="va-inv-row va-inv-head">'
        + '<div class="va-inv-select-cell"><input type="checkbox" class="va-inv-select" id="va-inv-select-all" aria-label="Select all visible invoices"></div>'
        + '<div>Invoice</div><div>Ship To</div><div style="text-align:center">Date</div><div style="text-align:center">Due</div><div style="text-align:center">Amount</div><div style="text-align:center">Status</div><div></div>'
        + '</div>';
      invState.invoices.forEach(function (inv) {
        var invNo      = inv.no || inv.number || '';
        var invOrderNo = inv.orderNo || '';
        var invDate = inv.postingDate || inv.invoiceDate || inv.documentDate || '';
        var invDue  = inv.dueDate || '';
        var invPo   = inv.externalDocumentNo || inv.externalDocumentNumber || '';
        var invCustPo = String(inv.customerPoNo || '').trim();
        var panelId = 'va-inv-d-' + invNo.replace(/[^a-zA-Z0-9]/g, '-');

        // Build full invoice document
        var cur = inv.currencyCode || 'USD';
        var fmtAmt = function(v) {
          if (v == null) return '\u2014';
          return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(v);
        };
        var total     = inv.amountIncludingVAT != null ? inv.amountIncludingVAT : (inv.amount != null ? inv.amount : null);
        var subtotal  = inv.amount != null ? inv.amount : null;
        var remaining = inv.remainingAmount != null ? inv.remainingAmount : null;
        var terms     = inv.paymentTermsCode || '';
        var shipName  = inv.shipToName || '';
        var shipParts = [inv.shipToAddress, inv.shipToCity, inv.shipToCounty, inv.shipToPostCode, inv.shipToCountryRegionCode].filter(Boolean);
        var billName  = inv.billToName || inv.sellToCustomerName || '';
        var billParts = [
          inv.billToAddress  || inv.sellToAddress,
          inv.billToCity     || inv.sellToCity,
          inv.billToCounty   || inv.sellToCounty,
          inv.billToPostCode || inv.sellToPostCode,
          inv.billToCountryRegionCode || inv.sellToCountryRegionCode
        ].filter(Boolean);

        // Header summary (right side)
        var sumRows = '';
        sumRows += '<div class="va-inv-doc-sum-row"><span>Date</span><strong>' + fmtDate(invDate) + '</strong></div>';
        if (invDue) sumRows += '<div class="va-inv-doc-sum-row"><span>Due</span><strong>' + fmtDate(invDue) + '</strong></div>';
        if (terms)  sumRows += '<div class="va-inv-doc-sum-row"><span>Terms</span><strong>' + escHtml(terms) + '</strong></div>';
        if (invPo)  sumRows += '<div class="va-inv-doc-sum-row"><span>Ext. Doc No.</span><strong>' + escHtml(invPo) + '</strong></div>';
        if (invCustPo) sumRows += '<div class="va-inv-doc-sum-row"><span>PO#</span><strong>' + escHtml(invCustPo) + '</strong></div>';

        // Bill-to / Ship-to
        var addrHtml = '';
        if (billName || billParts.length) {
          addrHtml += '<div class="va-inv-doc-addr"><div class="va-inv-doc-addr-label">Bill To</div><div class="va-inv-doc-addr-body">';
          if (billName) addrHtml += '<strong>' + escHtml(billName) + '</strong><br>';
          if (billParts.length) addrHtml += escHtml(billParts.join(', '));
          addrHtml += '</div></div>';
        }
        if (shipName || shipParts.length) {
          addrHtml += '<div class="va-inv-doc-addr"><div class="va-inv-doc-addr-label">Ship To</div><div class="va-inv-doc-addr-body">';
          if (shipName) addrHtml += '<strong>' + escHtml(shipName) + '</strong><br>';
          if (shipParts.length) addrHtml += escHtml(shipParts.join(', '));
          addrHtml += '</div></div>';
        }

        // Tracking
        var trackingHtml = '';
        var trackNo = inv.packageTrackingNo || '';
        var carrier = inv.shippingAgentCode || '';
        if (trackNo) {
          var trackUrl = '';
          var c = carrier.toUpperCase();
          if (c === 'USPS')       trackUrl = 'https://tools.usps.com/go/TrackConfirmAction?tLabels=' + encodeURIComponent(trackNo);
          else if (c === 'FEDEX') trackUrl = 'https://www.fedex.com/apps/fedextrack/?tracknumbers=' + encodeURIComponent(trackNo);
          else if (c === 'UPS')   trackUrl = 'https://www.ups.com/track?tracknum=' + encodeURIComponent(trackNo);
          var truckIcon = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
          var trackLabel = escHtml((carrier || 'Carrier') + ': ' + trackNo);
          trackingHtml = '<div class="va-inv-doc-addr"><div class="va-inv-doc-addr-label">Tracking</div><div class="va-inv-doc-addr-body">'
            + '<div class="va-od-tracking">' + truckIcon
            + (trackUrl ? '<a href="' + escHtml(trackUrl) + '" target="_blank" rel="noopener" class="va-od-tracking-link">' + trackLabel + '</a>' : trackLabel)
            + '</div></div></div>';
        }

        // Line items (lazy-loaded on panel open)
        var linesHtml = '<div class="va-inv-lines-area"></div>';

        // Totals
        var totalsHtml = '';
        if (subtotal != null && total != null && Math.abs(subtotal - total) > 0.005) {
          totalsHtml += '<div class="va-inv-doc-total-row"><span>Subtotal</span><span>' + fmtAmt(subtotal) + '</span></div>';
        }
        if (total != null) {
          totalsHtml += '<div class="va-inv-doc-total-row va-inv-doc-total-grand"><span>Total</span><span>' + fmtAmt(total) + '</span></div>';
        }
        if (remaining != null && Math.abs(remaining) > 0.005) {
          totalsHtml += '<div class="va-inv-doc-total-row va-inv-doc-total-due"><span>Remaining</span><span>' + fmtAmt(remaining) + '</span></div>';
        }

        // Assemble document
        var invDocHtml = '<div class="va-inv-doc">'
          + '<div class="va-inv-doc-top">'
          + '<div><div class="va-inv-doc-company">Valor Communication, Inc.<br>18071 ARENTH AVE., CITY OF INDUSTRY, CA 91748</div><div class="va-inv-doc-title">Invoice</div><div class="va-inv-doc-num">' + escHtml(invNo) + (invOrderNo ? '<span class="va-inv-doc-order"> ·&nbsp; Order#\u00a0' + escHtml(invOrderNo) + '</span>' : '') + '</div></div>'
          + '<div class="va-inv-doc-sum">' + sumRows + '</div>'
          + '</div>'
          + (addrHtml ? '<div class="va-inv-doc-addresses">' + addrHtml + '</div>' : '')
          + (trackingHtml ? '<div class="va-inv-doc-tracking">' + trackingHtml + '</div>' : '')
          + linesHtml
          + (totalsHtml ? '<div class="va-inv-doc-totals">' + totalsHtml + '</div>' : '')
          + '</div>';

        var searchStr = [invNo, invPo, invCustPo, shipName, shipParts.join(' '), billName].filter(Boolean).join(' ').toLowerCase();
        var amtVal    = total != null ? total : 0;
        var invDateMs = invDate ? new Date(invDate).getTime() : 0;
        var isRecent  = invDateMs > 0 && (Date.now() - invDateMs) < 30 * 24 * 60 * 60 * 1000;
        html += '<div class="va-inv-row" data-inv-panel="' + panelId + '" data-inv-no="' + escHtml(invNo) + '" data-search="' + escHtml(searchStr) + '" data-amount="' + amtVal + '">'
          + '<div class="va-inv-select-cell"><input type="checkbox" class="va-inv-select" data-inv-no="' + escHtml(invNo) + '" aria-label="Select invoice ' + escHtml(invNo) + '"' + (invState.selected.has(invNo) ? ' checked' : '') + '></div>'
          + '<div class="va-inv-num">'
          + '<div class="va-order-num">' + escHtml(invNo) + '</div>'
          + (invPo ? '<div class="va-order-po">Ext. Doc No.:\u00a0' + escHtml(invPo) + '</div>' : '')
          + (invCustPo ? '<div class="va-order-po">PO#:\u00a0' + escHtml(invCustPo) + '</div>' : '')
          + '</div>'
          + '<div class="va-inv-addr-cell">'
          + (shipName ? '<div class="va-inv-addr-name">' + escHtml(shipName) + '</div>' : '')
          + (shipParts.length ? '<div class="va-inv-addr-loc">' + escHtml(shipParts.join(', ')) + '</div>' : '')
          + '</div>'
          + '<div class="va-order-cell">' + fmtDate(invDate) + '</div>'
          + '<div class="va-order-cell">' + fmtDate(invDue) + '</div>'
          + '<div class="va-inv-amt-cell">' + (total != null ? fmtAmt(total) : '\u2014') + '</div>'
          + (function () {
              var paid = inv.paidInFull !== false;
              var rem  = inv.remainingAmount;
              if (paid) {
                return '<div class="va-inv-status-cell"><span class="va-inv-status-paid">Paid in full</span></div>';
              }
              var remStr = rem != null ? fmtAmt(rem) : '\u2014';
              return '<div class="va-inv-status-cell"><span class="va-inv-status-due">' + remStr + '</span><div class="va-inv-status-date">Open</div></div>';
            }())
          + '<div class="va-inv-row-btns">'
          + (isRecent && invOrderNo ? '<button class="va-inv-dl-btn va-inv-ship-btn" data-inv-no="' + escHtml(invNo) + '" data-order-no="' + escHtml(invOrderNo) + '" title="Download shipping slip">' + shipIcon + '</button>' : '')
          + '<button class="va-inv-dl-btn va-inv-pdf-btn" data-inv-no="' + escHtml(invNo) + '" title="Download PDF">' + pdfIcon + '</button>'
          + '<button class="va-inv-dl-btn" data-inv-no="' + escHtml(invNo) + '" title="Download XLSX">' + dlIcon + '</button>'
          + '<button class="va-inv-expand-btn" data-inv-panel="' + panelId + '" title="Show details">' + chevronIcon + '</button>'
          + '</div>'
          + '</div>'
          + '<div class="va-inv-detail" id="' + panelId + '" data-inv-no="' + escHtml(invNo) + '">' + invDocHtml + '</div>';
      });

      // Pagination footer
      var pg = invState.page;
      var tp = invState.totalPages;
      var pagerNums = '';
      if (tp && tp > 1) {
        var delta = 2, pgLast = null;
        for (var pi = 1; pi <= tp; pi++) {
          if (pi === 1 || pi === tp || (pi >= pg - delta && pi <= pg + delta)) {
            if (pgLast !== null && pi - pgLast > 1) pagerNums += '<span class="va-inv-pg-ellipsis">\u2026</span>';
            pagerNums += '<button class="va-inv-pg-num' + (pi === pg ? ' va-inv-pg-num--active' : '') + '" data-inv-page="' + pi + '"' + (pi === pg ? ' disabled' : '') + '>' + pi + '</button>';
            pgLast = pi;
          }
        }
      }
      html += '<div class="va-inv-pager">'
        + '<button class="va-inv-pager-btn" id="va-inv-prev"' + (pg <= 1 ? ' disabled' : '') + '>\u2190 Prev</button>'
        + (pagerNums || '<span class="va-inv-pager-info">Page ' + pg + (tp ? ' of ' + tp : '') + '</span>')
        + '<button class="va-inv-pager-btn" id="va-inv-next"' + (!invState.hasMore ? ' disabled' : '') + '>Next \u2192</button>'
        + '</div>';

      listEl.innerHTML = html;
      var invPagerTop = document.getElementById('va-inv-pager-top');
      if (invPagerTop) {
        invPagerTop.innerHTML = '<button class="va-inv-pager-btn" id="va-inv-prev-top"' + (pg <= 1 ? ' disabled' : '') + '>\u2190 Prev</button>'
          + (pagerNums || '<span class="va-inv-pager-info">Page ' + pg + (tp ? ' of ' + tp : '') + '</span>')
          + '<button class="va-inv-pager-btn" id="va-inv-next-top"' + (!invState.hasMore ? ' disabled' : '') + '>Next \u2192</button>';
        invPagerTop.hidden = pg <= 1 && !invState.hasMore;
      }
      invUpdateSub();
      invUpdateSelectionUi();

    }

    function invLoad(pg) {
      if (invState.loading) return;
      invState.loading = true;
      pg = pg || 1;
      var progEl = document.getElementById('va-inv-progress');
      if (progEl) progEl.classList.add('is-loading');
      listEl.innerHTML = '<div class="va-pay-loading" style="padding:16px 22px;">Loading invoices\u2026</div>';
      if (progEl) listEl.insertBefore(progEl, listEl.firstChild);
      var subEl = document.getElementById('va-invoices-page-sub');
      if (subEl) subEl.textContent = 'Loading invoices\u2026';
      invProxy(Object.assign({ action: 'invoice-list', page: pg }, invQueryParams()), function (d) {
        if (progEl) progEl.classList.remove('is-loading');
        invState.loading    = false;
        invState.loaded     = true;
        invState.page       = d.page || pg;
        invState.hasMore     = !!d.hasMore;
        invState.totalPages  = d.totalPages || null;
        invState.totalCount  = d.totalCount != null ? +d.totalCount : null;
        invState.invoices    = d.invoices || [];
        invRender();
        invUpdateSub();
        invApplyFilter();
      }, function (err) {
        if (progEl) progEl.classList.remove('is-loading');
        invState.loading = false;
        listEl.innerHTML = '<div class="va-pay-error" style="margin:16px 22px;">' + escHtml('Could not load invoices: ' + err.message) + '</div>';
        if (progEl) listEl.insertBefore(progEl, listEl.firstChild);
      });
    }

    function invDownloadPdf(invNo, btn) {
      btn.disabled = true;
      btn.innerHTML = spinIcon;
      var inv = invState.invoices.find(function (i) { return (i.no || i.number || '') === invNo; });
      var sellTo = inv ? (inv.sellToCustomerNo || inv.billToCustomerNo || '') : '';
      invProxy({ action: 'invoice-report', invoice_no: invNo, format: 'PDF', sell_to_customer_no: sellTo }, function (d) {
        try {
          var bytes = atob(d.content);
          var arr = new Uint8Array(bytes.length);
          for (var i = 0; i < bytes.length; i++) arr[i] = bytes.charCodeAt(i);
          var blob = new Blob([arr], { type: d.mimeType || 'application/pdf' });
          var url  = URL.createObjectURL(blob);
          var a    = document.createElement('a');
          a.href = url; a.download = d.filename || ('Invoice-' + invNo + '.pdf');
          document.body.appendChild(a); a.click(); document.body.removeChild(a);
          setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
        } catch (e) { alert('PDF download failed.'); }
        btn.disabled = false; btn.innerHTML = pdfIcon;
      }, function (err) {
        alert('PDF generation failed: ' + err.message);
        btn.disabled = false; btn.innerHTML = pdfIcon;
      });
    }

    // Per-row XLS button. Downloads the .xlsx that BC renders from
    // /api/invoice-reports/generate — the same document the PDF button and the bulk
    // XLS button already use, so every export path reports the same figures.
    //
    // This replaced invDownload() below, which assembled the sheet in the browser from
    // the cached invoice-list payload. That builder is kept but no longer wired to any
    // button: restoring it is a one-line change at the dispatch site.
    function invDownloadXlsx(invNo, btn) {
      btn.disabled = true;
      btn.innerHTML = spinIcon;
      var inv = invState.invoices.find(function (i) { return (i.no || i.number || '') === invNo; });
      var sellTo = inv ? (inv.sellToCustomerNo || inv.billToCustomerNo || '') : '';
      invProxy({ action: 'invoice-report', invoice_no: invNo, format: 'EXCEL', sell_to_customer_no: sellTo }, function (d) {
        try {
          var bytes = atob(d.content);
          var arr = new Uint8Array(bytes.length);
          for (var i = 0; i < bytes.length; i++) arr[i] = bytes.charCodeAt(i);
          var blob = new Blob([arr], { type: d.mimeType || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          var url  = URL.createObjectURL(blob);
          var a    = document.createElement('a');
          a.href = url; a.download = d.filename || ('Invoice-' + invNo + '.xlsx');
          document.body.appendChild(a); a.click(); document.body.removeChild(a);
          setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
        } catch (e) { alert('XLSX download failed.'); }
        btn.disabled = false; btn.innerHTML = dlIcon;
      }, function (err) {
        alert('XLSX generation failed: ' + err.message);
        btn.disabled = false; btn.innerHTML = dlIcon;
      });
    }

    function invDownloadShipSlip(invNo, orderNo, btn) {
      btn.disabled = true;
      btn.innerHTML = spinIcon;
      invProxy({ action: 'invoice-report', invoice_no: invNo, order_no: orderNo, format: 'PDF', document_type: 'PostedSalesShipment' }, function (d) {
        try {
          var bytes = atob(d.content);
          var arr = new Uint8Array(bytes.length);
          for (var i = 0; i < bytes.length; i++) arr[i] = bytes.charCodeAt(i);
          var blob = new Blob([arr], { type: 'application/pdf' });
          var url  = URL.createObjectURL(blob);
          var a    = document.createElement('a');
          a.href = url; a.download = d.filename || ('ShippingSlip-' + invNo + '.pdf');
          document.body.appendChild(a); a.click(); document.body.removeChild(a);
          setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
        } catch (e) { alert('Shipping slip download failed.'); }
        btn.disabled = false; btn.innerHTML = shipIcon;
      }, function (err) {
        alert('Shipping slip not available: ' + err.message);
        btn.disabled = false; btn.innerHTML = shipIcon;
      });
    }

    function invDownload(invNo, btn) {
      var inv = invState.invoices.find(function (i) { return (i.no || i.number || '') === invNo; });
      if (!inv) { alert('Invoice data not loaded.'); return; }

      btn.disabled = true;
      btn.innerHTML = spinIcon;

      var loadXlsx = window.XLSX
        ? Promise.resolve()
        : new Promise(function (resolve, reject) {
            var s = document.createElement('script');
            s.src = 'https://cdn.sheetjs.com/xlsx-0.20.3/package/dist/xlsx.full.min.js';
            s.onload = resolve; s.onerror = reject;
            document.head.appendChild(s);
          });

      var invSellTo = inv.sellToCustomerNo || inv.billToCustomerNo || '';
      var loadLines = Array.isArray(inv._lines)
        ? Promise.resolve(inv._lines)
        : new Promise(function (res) {
            invProxy({ action: 'invoice-lines', invoice_no: invNo, sell_to_customer_no: invSellTo },
              function (d) { inv._lines = d.lines || []; res(inv._lines); },
              function ()  { inv._lines = []; res([]); }
            );
          });

      Promise.all([loadXlsx, loadLines]).then(function (results) {
        var lineItems = results[1];
        var XL    = window.XLSX;
        var cur   = inv.currencyCode || 'USD';
        var fmtNum = function (v) { return v != null ? parseFloat(v) : ''; };

        var invDate     = fmtDate(inv.postingDate || inv.invoiceDate || inv.documentDate || '');
        var invDue      = fmtDate(inv.dueDate || '');
        var invPo       = inv.externalDocumentNo || inv.externalDocumentNumber || '';
        var companyName = 'Valor Communication, Inc.';
        var total       = inv.amountIncludingVAT != null ? inv.amountIncludingVAT : inv.amount;

        // Addresses
        var billName  = inv.billToName || inv.sellToCustomerName || '';
        var billLines = [inv.billToAddress || inv.sellToAddress || '',
                         [inv.billToCity    || inv.sellToCity,
                          inv.billToCounty  || inv.sellToCounty,
                          inv.billToPostCode || inv.sellToPostCode,
                          inv.billToCountryRegionCode || inv.sellToCountryRegionCode].filter(Boolean).join(', ')
                        ].filter(Boolean);
        var shipName  = inv.shipToName || '';
        var shipLines = [inv.shipToAddress || '',
                         [inv.shipToCity, inv.shipToCounty, inv.shipToPostCode,
                          inv.shipToCountryRegionCode].filter(Boolean).join(', ')
                        ].filter(Boolean);

        var rows   = [];
        var merges = [];
        var r      = 0;

        // ── Header block ────────────────────────────────────────────────
        // A-D merged for left content; E = label, F = value
        var headerStart = r;
        rows.push(['INVOICE', '', '', '', 'Date', invDate]); merges.push({s:{r:r,c:0},e:{r:r,c:3}}); r++;
        rows.push(['#' + invNo, '', '', '', 'Due', invDue]); merges.push({s:{r:r,c:0},e:{r:r,c:3}}); r++;
        if (inv.paymentTermsCode) {
          rows.push(['', '', '', '', 'Terms', inv.paymentTermsCode]);
          merges.push({s:{r:r,c:0},e:{r:r,c:3}}); r++;
        }
        // Company name sits on the left of the PO# row; if no PO# it gets its own row
        if (invPo) {
          rows.push([companyName, '', '', '', 'PO #', invPo]);
          merges.push({s:{r:r,c:0},e:{r:r,c:3}}); r++;
        } else {
          rows.push([companyName, '', '', '', '', '']);
          merges.push({s:{r:r,c:0},e:{r:r,c:3}}); r++;
        }
        var headerEnd = r - 1;

        rows.push([]); r++;

        // ── Address block ───────────────────────────────────────────────
        // A-C = Bill To (0~2), D-F = Ship To (3~5)
        var addrStart = r;
        rows.push(['BILL TO','','','SHIP TO','','']); merges.push({s:{r:r,c:0},e:{r:r,c:2}}); merges.push({s:{r:r,c:3},e:{r:r,c:5}}); r++;
        rows.push([billName,'','',shipName,'','']);   merges.push({s:{r:r,c:0},e:{r:r,c:2}}); merges.push({s:{r:r,c:3},e:{r:r,c:5}}); r++;
        var maxAddrLines = Math.max(billLines.length, shipLines.length);
        for (var ai = 0; ai < maxAddrLines; ai++) {
          rows.push([billLines[ai]||'','','', shipLines[ai]||'','','']);
          merges.push({s:{r:r,c:0},e:{r:r,c:2}}); merges.push({s:{r:r,c:3},e:{r:r,c:5}}); r++;
        }
        var addrEnd = r - 1;

        rows.push([]); r++;

        // ── Line items block ────────────────────────────────────────────
        var linesStart = r;
        rows.push(['#', 'UPC', 'SKU', 'Qty', 'Unit Price (' + cur + ')', 'Amount (' + cur + ')']); r++;

        var lineIdx = 0;
        lineItems.forEach(function (line) {
          if ((line.type || '').toLowerCase() === 'comment') {
            var note = (line.comment != null ? line.comment : (line.description || ''));
            if (!note || !note.trim()) return;
            lineIdx++;
            rows.push([lineIdx, '', note, '', '', '']);
            r++;
            return;
          }
          // Non-item lines (G/L account charges, fees) have no UPC — their `no` is an
          // internal account code, so leave the UPC column blank and show the description.
          var upc = line.lineType ? '' : (line.itemNo || line.no || '');
          var sku = line.lineType ? (line.title || line.description || '') : (line.description || '');
          if (!upc && !sku) return;
          lineIdx++;
          rows.push([lineIdx, upc, sku,
            line.quantity != null ? line.quantity : '',
            fmtNum(line.unitPrice),
            fmtNum(line.lineAmount != null ? line.lineAmount : line.amount)]);
          r++;
        });

        rows.push([]); r++;
        // Tax and Amount Due are deliberately absent. Tax was derived here as
        // amountIncludingVAT - amount, and Amount Due printed inv.remainingAmount raw —
        // without the paidInFull gate the row cell applies, so a paid invoice could still
        // show a balance. Both figures now come from BC's own report; see invDownloadXlsx.
        if (inv.amount != null && inv.amountIncludingVAT != null && inv.amount !== inv.amountIncludingVAT) {
          rows.push(['','','','','Subtotal', fmtNum(inv.amount)]); r++;
        }
        if (total != null) { rows.push(['','','','','Total', fmtNum(total)]); r++; }
        var linesEnd = r - 1;

        // ── Build sheet ─────────────────────────────────────────────────
        var wb = XL.utils.book_new();
        var ws = XL.utils.aoa_to_sheet(rows);
        ws['!cols']   = [{wch:4},{wch:16},{wch:32},{wch:8},{wch:18},{wch:16}];
        ws['!merges'] = merges;

        XL.utils.book_append_sheet(wb, ws, 'Invoice');
        XL.writeFile(wb, 'Invoice-' + invNo + '.xls');
      }).catch(function () {
        alert('Failed to load export library.');
      }).finally(function () {
        btn.disabled = false;
        btn.innerHTML = dlIcon;
      });
    }

    listEl.addEventListener('click', function (e) {
      var selectAll = e.target.closest('#va-inv-select-all');
      if (selectAll) {
        e.stopPropagation();
        var visibleRows = invVisibleRows();
        if (selectAll.checked) {
          var room = INV_BULK_MAX - invState.selected.size;
          visibleRows.forEach(function (row) {
            var no = row.dataset.invNo || '';
            if (!no || invState.selected.has(no) || room <= 0) return;
            var inv = invState.invoices.find(function (item) { return (item.no || item.number || '') === no; });
            if (inv) { invState.selected.set(no, inv); room--; }
          });
          if (visibleRows.some(function (row) { return !invState.selected.has(row.dataset.invNo || ''); })) {
            invBulkMessage('A maximum of ' + INV_BULK_MAX + ' invoices can be included in one ZIP.', true);
          } else {
            invBulkMessage('', false);
          }
        } else {
          visibleRows.forEach(function (row) { invState.selected.delete(row.dataset.invNo || ''); });
          invBulkMessage('', false);
        }
        invUpdateSelectionUi();
        return;
      }

      var selectBox = e.target.closest('.va-inv-select[data-inv-no]');
      if (selectBox) {
        e.stopPropagation();
        var selectedNo = selectBox.dataset.invNo || '';
        if (selectBox.checked) {
          if (invState.selected.size >= INV_BULK_MAX && !invState.selected.has(selectedNo)) {
            selectBox.checked = false;
            invBulkMessage('A maximum of ' + INV_BULK_MAX + ' invoices can be included in one ZIP.', true);
          } else {
            var selectedInv = invState.invoices.find(function (item) { return (item.no || item.number || '') === selectedNo; });
            if (selectedInv) invState.selected.set(selectedNo, selectedInv);
            invBulkMessage('', false);
          }
        } else {
          invState.selected.delete(selectedNo);
          invBulkMessage('', false);
        }
        invUpdateSelectionUi();
        return;
      }

      // Shipping slip button
      var shipBtn = e.target.closest('.va-inv-ship-btn');
      if (shipBtn) { invDownloadShipSlip(shipBtn.dataset.invNo, shipBtn.dataset.orderNo, shipBtn); return; }
      // PDF download button
      var pdfBtn = e.target.closest('.va-inv-pdf-btn');
      if (pdfBtn) { invDownloadPdf(pdfBtn.dataset.invNo, pdfBtn); return; }
      // XLS download button — BC-rendered .xlsx. Swap invDownloadXlsx for
      // invDownload to go back to the client-side sheet builder.
      var dlBtn = e.target.closest('.va-inv-dl-btn');
      if (dlBtn) { invDownloadXlsx(dlBtn.dataset.invNo, dlBtn); return; }

      // Row click (includes expand button) — toggle detail panel
      var row = e.target.closest('.va-inv-row[data-inv-panel]');
      if (row) {
        var panelId = row.dataset.invPanel;
        var panel   = panelId && listEl.querySelector('#' + panelId);
        var isOpen  = panel && panel.classList.contains('open');
        listEl.querySelectorAll('.va-inv-detail.open').forEach(function (p) { p.classList.remove('open'); });
        listEl.querySelectorAll('.va-inv-expand-btn.open').forEach(function (b) { b.classList.remove('open'); });
        if (!isOpen && panel) {
          panel.classList.add('open');
          var expandBtn = row.querySelector('.va-inv-expand-btn');
          if (expandBtn) expandBtn.classList.add('open');
          // Lazy-load line items on first open
          var rowInvNo = panel.dataset.invNo;
          var rowInv = invState.invoices.find(function(i) { return (i.no || i.number || '') === rowInvNo; });
          if (rowInv && rowInv._lines === undefined) {
            var linesArea = panel.querySelector('.va-inv-lines-area');
            if (linesArea) linesArea.innerHTML = '<div style="padding:8px 0;color:var(--va-steel);font-size:13px">Loading\u2026</div>';
            rowInv._lines = null;
            var rowSellTo = rowInv ? (rowInv.sellToCustomerNo || rowInv.billToCustomerNo || '') : '';
            invProxy({ action: 'invoice-lines', invoice_no: rowInvNo, sell_to_customer_no: rowSellTo }, function(d) {
              rowInv._lines = d.lines || [];
              var tbl = buildLinesTable(rowInv._lines, rowInv.currencyCode || 'USD');
              if (linesArea) linesArea.innerHTML = tbl || '<div style="padding:8px 0;color:var(--va-steel);font-size:13px">Line items not available for this invoice.</div>';
            }, function() {
              rowInv._lines = [];
              if (linesArea) linesArea.innerHTML = '<div style="padding:8px 0;color:var(--va-steel);font-size:13px">Could not load line items.</div>';
            });
          }
        }
        return;
      }

    });

    // Update just the active page number in both pagers immediately on click.
    function invPagerSync() {
      var pg = invState.page, tp = invState.totalPages;
      [document.getElementById('va-inv-pager-top'), listEl.querySelector('.va-inv-pager')].forEach(function (el) {
        if (!el) return;
        el.querySelectorAll('[data-inv-page]').forEach(function (btn) {
          var p = parseInt(btn.dataset.invPage, 10);
          btn.classList.toggle('va-inv-pg-num--active', p === pg);
          btn.disabled = p === pg;
        });
        var info = el.querySelector('.va-inv-pager-info');
        if (info) info.textContent = 'Page ' + pg + (tp ? ' of ' + tp : '');
      });
    }

    // All pagination handled at document level (both top and bottom pagers)
    document.addEventListener('click', function (e) {
      var newPg = null;
      if ((e.target.id === 'va-inv-prev' || e.target.id === 'va-inv-prev-top') && invState.page > 1) newPg = invState.page - 1;
      else if ((e.target.id === 'va-inv-next' || e.target.id === 'va-inv-next-top') && invState.hasMore) newPg = invState.page + 1;
      else { var pgBtn = e.target.closest && e.target.closest('[data-inv-page]'); if (pgBtn && !pgBtn.disabled) newPg = parseInt(pgBtn.dataset.invPage, 10); }
      if (newPg !== null) { invState.page = newPg; invPagerSync(); invLoad(newPg); }
    });

    var invInitLoad = function () {
      if (invTab.classList.contains('va-tab--active') && !invState.loaded) invLoad(1);
    };
    (window.__vaCustomerInfo || Promise.resolve(null)).then(function () { invInitLoad(); });
    new MutationObserver(function () {
      if (invTab.classList.contains('va-tab--active') && !invState.loaded) invLoad(1);
    }).observe(invTab, { attributes: true, attributeFilter: ['class'] });
  }());

  // ── Channel theming ──────────────────────────────────────
  (function () {
    var CHANNELS = ['cricket', 'boost', 'total'];
    function getChannel() {
      var urlCh = new URLSearchParams(location.search).get('channel');
      if (urlCh && CHANNELS.indexOf(urlCh) !== -1) {
        try { localStorage.setItem('va_channel', urlCh); } catch (e) {}
        return urlCh;
      }
      try {
        var stored = localStorage.getItem('va_channel');
        if (stored && CHANNELS.indexOf(stored) !== -1) return stored;
      } catch (e) {}
      return null;
    }
    var ch = getChannel();
    if (ch) document.documentElement.setAttribute('data-channel', ch);
  })();

  // ── Saved carts tab ─────────────────────────────────────
  (function () {
    var scTab   = document.getElementById('va-tab-lists');
    if (!scTab) return;
    var listEl    = document.getElementById('va-sc-list');
    var scopeEl   = document.getElementById('va-sc-scope');
    var pagerEl   = document.getElementById('va-sc-pager');
    var pagerTopEl = document.getElementById('va-sc-pager-top');
    var searchEl  = document.getElementById('va-sc-search');
    var searchClear = document.getElementById('va-sc-search-clear');
    if (!listEl) return;
    var scope = 'mine';
    var SC_PER_PAGE = 10;
    var scState = { allCarts: [], page: 1, isParentCompany: false };

    function loadCarts() {
      listEl.innerHTML = '<div class="va-empty" style="padding:28px;">Loading\u2026</div>';
      if (pagerEl) pagerEl.hidden = true;
      if (pagerTopEl) pagerTopEl.hidden = true;
      var auth = window.__vaAuth || {};
      if (!auth.proxy || !auth.customer_id) {
        listEl.innerHTML = '<div class="va-empty" style="padding:28px;">Not available.</div>';
        return;
      }
      fetch(auth.proxy, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop, action: 'saved-carts-list', scope: scope })
      }).then(function (r) { return r.json(); }).then(function (d) {
        if (!d.ok) throw new Error(d.error || 'Failed');
        scState.allCarts = d.carts || [];
        scState.isParentCompany = !!d.is_parent_company;
        scState.page = 1;
        if (searchEl) { searchEl.value = ''; searchEl.closest('.va-inv-search-wrap').classList.remove('has-value'); }
        scRender();
      }).catch(function () {
        listEl.innerHTML = '<div class="va-empty" style="padding:28px;">Failed to load saved carts.</div>';
      });
    }

    function scFilteredCarts() {
      var q = searchEl ? searchEl.value.toLowerCase().trim() : '';
      if (!q) return scState.allCarts;
      return scState.allCarts.filter(function (c) {
        return (c.name || '').toLowerCase().includes(q)
          || (c.owner_name || '').toLowerCase().includes(q)
          || (c.saver_email || '').toLowerCase().includes(q);
      });
    }

    function scRender() {
      var filtered = scFilteredCarts();
      var total    = filtered.length;
      var pg       = scState.page;
      var pages    = Math.max(1, Math.ceil(total / SC_PER_PAGE));
      if (pg > pages) { scState.page = pg = pages; }
      var start    = (pg - 1) * SC_PER_PAGE;
      var pageCarts = filtered.slice(start, start + SC_PER_PAGE);
      renderCarts(pageCarts);

      // Build pager HTML
      var showPager = pages > 1;
      var pagerHtml = '<button class="va-inv-pager-btn" id="va-sc-prev"' + (pg <= 1 ? ' disabled' : '') + '>\u2190 Prev</button>'
        + '<span class="va-inv-pager-info">Page ' + pg + ' of ' + pages + '</span>'
        + '<button class="va-inv-pager-btn" id="va-sc-next"' + (pg >= pages ? ' disabled' : '') + '>Next \u2192</button>';
      if (pagerEl) { pagerEl.innerHTML = pagerHtml; pagerEl.hidden = !showPager; }
      if (pagerTopEl) { pagerTopEl.innerHTML = '<span class="va-inv-pager-info">Page ' + pg + ' of ' + pages + '</span>'; pagerTopEl.hidden = !showPager; }
    }

    function buildScItemsTable(items) {
      var fmtP = function(cents) {
        if (cents == null) return '\u2014';
        return '$' + (cents / 100).toFixed(2);
      };
      var html = '<div class="va-sc-items">';
      (items || []).forEach(function(item) {
        var img = item.image
          ? '<img src="' + escHtml(item.image) + '" alt="" loading="lazy">'
          : '';
        var sku = item.sku ? 'SKU: ' + escHtml(item.sku) : '';
        var handle = item.handle ? escHtml(item.handle) : '';
        html += '<div class="va-sc-item' + (handle ? ' va-sc-item--qv' : '') + '"' + (handle ? ' data-qv-handle="' + handle + '"' : '') + '>'
          + '<div class="va-sc-item-img">' + img + '</div>'
          + '<div class="va-sc-item-info">'
          +   '<div class="va-sc-item-title">' + escHtml(item.title || 'Unknown') + '</div>'
          +   (sku ? '<div class="va-sc-item-sku">' + sku + '</div>' : '')
          + '</div>'
          + '<div class="va-sc-item-right">'
          +   '<div class="va-sc-item-qty">\u00d7 ' + (item.qty || 0) + '</div>'
          +   '<div class="va-sc-item-price">' + fmtP(item.price) + '</div>'
          + '</div>'
          + '</div>';
      });
      html += '</div>';
      return html;
    }

    function renderCarts(carts) {
      if (!carts.length) {
        listEl.innerHTML = '<div class="va-empty" style="padding:28px;"><svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18M16 10a4 4 0 0 1-8 0"/></svg><p style="margin-top:12px;">No saved carts yet.<br>Use the <strong>Save cart</strong> button on the cart page.</p></div>';
        return;
      }
      var showOwner = scope === 'org' && carts.some(function (c) { return c.owner_name; });
      var ownerCls  = showOwner ? ' has-owner' : '';
      var chevronIcon = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>';
      var html = '<div class="va-sc-row-head' + ownerCls + '">'
        + '<div>Name</div>'
        + (showOwner ? '<div>Company</div>' : '')
        + '<div class="va-sc-center">Saved by</div><div class="va-sc-center">Items</div><div class="va-sc-center">Saved</div><div class="va-sc-center">Actions</div><div></div>'
        + '</div>';
      carts.forEach(function (c, idx) {
        var name     = escHtml(c.name);
        var ownerErp = escHtml(c.owner_erp_no || '');
        var isMine   = !c.owner_name;
        var panelId  = 'sc-panel-' + idx;
        var previews = (c.previews || []).map(function(src) {
          return '<img class="va-sc-preview-img" src="' + escHtml(src) + '" alt="" loading="lazy">';
        }).join('');
        html += '<div class="va-sc-row' + ownerCls + '" data-sc-panel="' + panelId + '">'
          + '<div class="va-order-id">'
          +   '<div class="va-order-num">' + name + '</div>'
          +   (previews ? '<div class="va-sc-previews">' + previews + '</div>' : '')
          + '</div>'
          + (showOwner ? '<div class="va-sc-company">' + (c.owner_name ? escHtml(c.owner_name) : '<span style="color:var(--va-steel);font-style:italic">My company</span>') + '</div>' : '')
          + '<div class="va-sc-center va-sc-email">' + (c.saver_email ? escHtml(c.saver_email) : '<span aria-label="Unknown">&mdash;</span>') + '</div>'
          + '<div class="va-sc-center">' + c.item_count + ' line item' + (c.item_count != 1 ? 's' : '') + '</div>'
          + '<div class="va-sc-center">' + new Date(c.saved_at).toLocaleDateString() + '</div>'
          + '<div class="va-sc-actions">'
          +   ((isMine || scState.isParentCompany) ? '<button class="va-erp-btn danger" data-sc-del="' + name + '" data-sc-erp="' + ownerErp + '">Delete</button>' : '')
          +   '<button class="va-erp-btn" data-sc-load="' + name + '" data-sc-erp="' + ownerErp + '">Load to cart</button>'
          + '</div>'
          + '<div><button class="va-sc-expand-btn" data-sc-expand="' + panelId + '" title="Show items">' + chevronIcon + '</button></div>'
          + '</div>'
          + '<div class="va-sc-detail" id="' + panelId + '" data-sc-name="' + name + '" data-sc-erp="' + ownerErp + '">'
          +   '<div class="va-sc-detail-inner"></div>'
          + '</div>';
      });
      listEl.innerHTML = html;
    }

    if (scopeEl) {
      scopeEl.addEventListener('click', function (e) {
        var btn = e.target.closest('.va-sc-scope-btn');
        if (!btn || btn.getAttribute('data-scope') === scope) return;
        scope = btn.getAttribute('data-scope');
        scopeEl.querySelectorAll('.va-sc-scope-btn').forEach(function (b) {
          b.classList.toggle('va-sc-scope-btn--active', b === btn);
        });
        loadCarts();
      });

      // Scope toggle is hidden by default (avoids a flash); reveal it only for companies
      // that have child locations (i.e. actually have org-wide carts to see).
      if (window.__vaCustomerInfo) {
        window.__vaCustomerInfo.then(function (info) {
          if (info && (info.childCount || 0) > 0) scopeEl.hidden = false;
        });
      }
    }

    listEl.addEventListener('click', function (e) {
      var auth      = window.__vaAuth || {};

      var qvItem = e.target.closest('[data-qv-handle]');
      if (qvItem && !e.target.closest('button')) {
        var handle = qvItem.dataset.qvHandle;
        if (handle && window.openQuickViewDialog) {
          window.openQuickViewDialog('/products/' + handle + '?view=valor-quick-add');
        }
        return;
      }

      var loadBtn   = e.target.closest('[data-sc-load]');
      var delBtn    = e.target.closest('[data-sc-del]');
      var expandBtn = e.target.closest('[data-sc-expand]');
      var row       = e.target.closest('.va-sc-row[data-sc-panel]');

      if (loadBtn) {
        var name     = loadBtn.getAttribute('data-sc-load');
        var ownerErp = loadBtn.getAttribute('data-sc-erp') || '';
        try { sessionStorage.setItem('vc_load_cart', JSON.stringify({ name: name, ownerErp: ownerErp })); } catch (_) {}
        window.location.href = '/cart';
        return;
      }

      if (delBtn) {
        var name = delBtn.getAttribute('data-sc-del');
        var ownerErp = delBtn.getAttribute('data-sc-erp') || '';
        vaConfirm({ msg: 'Delete saved cart "' + name + '"?', okLabel: 'Delete', danger: true }).then(function (ok) {
          if (!ok) return;
          delBtn.disabled = true;
          fetch(auth.proxy, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop, action: 'saved-carts-delete', name: name, owner_erp_no: ownerErp })
          }).then(function (r) { return r.json(); }).then(function (d) {
            if (!d.ok) throw new Error(d.error || 'Delete failed');
            loadCarts();
          }).catch(function (err) {
            alert(err.message || 'Delete failed.');
            delBtn.disabled = false;
          });
        });
        return;
      }

      if (expandBtn || (row && !e.target.closest('button'))) {
        var panelId = expandBtn ? expandBtn.dataset.scExpand : row.dataset.scPanel;
        var panel   = document.getElementById(panelId);
        if (!panel) return;
        var isOpen  = panel.classList.contains('open');
        listEl.querySelectorAll('.va-sc-detail.open').forEach(function (p) { p.classList.remove('open'); });
        listEl.querySelectorAll('.va-sc-row--open').forEach(function (r) { r.classList.remove('va-sc-row--open'); });
        listEl.querySelectorAll('.va-sc-expand-btn.open').forEach(function (b) { b.classList.remove('open'); });
        if (!isOpen) {
          panel.classList.add('open');
          if (row) row.classList.add('va-sc-row--open');
          var btn = expandBtn || row.querySelector('.va-sc-expand-btn');
          if (btn) btn.classList.add('open');
          var inner = panel.querySelector('.va-sc-detail-inner');
          if (inner && !panel.dataset.loaded) {
            inner.innerHTML = '<div style="padding:8px 0;color:var(--va-steel);font-size:13px">Loading\u2026</div>';
            var cartName = panel.dataset.scName;
            var cartErp  = panel.dataset.scErp || '';
            fetch(auth.proxy, {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop, action: 'saved-carts-load', name: cartName, owner_erp_no: cartErp })
            }).then(function(r) { return r.json(); }).then(function(d) {
              panel.dataset.loaded = '1';
              inner.innerHTML = (d.ok && d.items && d.items.length)
                ? buildScItemsTable(d.items)
                : '<div style="padding:8px 0;color:var(--va-steel);font-size:13px">No items in this cart.</div>';
            }).catch(function() {
              inner.innerHTML = '<div style="padding:8px 0;color:var(--va-steel);font-size:13px">Could not load items.</div>';
            });
          }
        }
      }
    });

    // Search wiring
    if (searchEl) {
      var searchWrap = searchEl.closest('.va-inv-search-wrap');
      searchEl.addEventListener('input', function () {
        if (searchWrap) searchWrap.classList.toggle('has-value', searchEl.value.length > 0);
        scState.page = 1;
        scRender();
      });
    }
    if (searchClear) {
      searchClear.addEventListener('click', function () {
        if (searchEl) { searchEl.value = ''; searchEl.focus(); }
        if (searchEl && searchEl.closest('.va-inv-search-wrap')) searchEl.closest('.va-inv-search-wrap').classList.remove('has-value');
        scState.page = 1;
        scRender();
      });
    }

    // Pager wiring
    document.addEventListener('click', function (e) {
      var id = e.target.id;
      if (id === 'va-sc-prev' || id === 'va-sc-prev-top') { if (scState.page > 1) { scState.page--; scRender(); } }
      else if (id === 'va-sc-next' || id === 'va-sc-next-top') { scState.page++; scRender(); }
    });

    var tabLoaded = false;
    new MutationObserver(function () {
      if (scTab.classList.contains('va-tab--active') && !tabLoaded) { tabLoaded = true; loadCarts(); }
    }).observe(scTab, { attributes: true, attributeFilter: ['class'] });

    if (scTab.classList.contains('va-tab--active')) { tabLoaded = true; loadCarts(); }
  }());

  // ── Team & Permissions tab ───────────────────────────────
  (function () {
    var teamTab    = document.getElementById('va-tab-team');
    var listEl     = document.getElementById('va-team-list');
    var subEl      = document.getElementById('va-team-sub');
    var noteEl     = document.getElementById('va-team-access-note');
    var errEl      = document.getElementById('va-team-error');
    var saveBtn    = document.getElementById('va-team-save');
    var resetBtn   = document.getElementById('va-team-reset');
    var searchEl   = document.getElementById('va-team-search');
    var searchClear= document.getElementById('va-team-search-clear');
    var selectAllBtn = document.getElementById('va-team-select-all');
    if (!teamTab || !listEl) return;

    var userSelectEl = document.getElementById('va-team-user-select');
    var teamState = { links: [], locations: [], isFullAccess: true, loaded: false, cachedAddresses: null };

    function proxy(payload, onOk, onErr) {
      var auth = window.__vaAuth || {};
      fetch(auth.proxy || '', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign({ customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop }, payload))
      }).then(function (r) { return r.json(); }).then(function (d) {
        if (!d.ok) throw new Error(d.error || 'Error');
        if (onOk) onOk(d);
      }).catch(function (e) { if (onErr) onErr(e); });
    }

    function getCheckedNos() {
      var nos = {};
      listEl.querySelectorAll('input[type=checkbox]:checked').forEach(function (el) { nos[el.value] = true; });
      return nos;
    }

    function updateSelectAll() {
      if (!selectAllBtn) return;
      var items = Array.from(listEl.querySelectorAll('.va-perm-item')).filter(function (el) { return el.style.display !== 'none'; });
      var allChecked = items.length > 0 && items.every(function (el) { return el.querySelector('input[type=checkbox]').checked; });
      selectAllBtn.textContent = allChecked ? 'Unselect all' : 'Select all';
    }

    function applySearch() {
      var q = searchEl ? searchEl.value.toLowerCase().trim() : '';
      if (searchEl && searchEl.closest('.va-perm-search-wrap')) {
        searchEl.closest('.va-perm-search-wrap').classList.toggle('has-value', q.length > 0);
      }
      listEl.querySelectorAll('.va-perm-item').forEach(function (el) {
        el.style.display = (!q || el.textContent.toLowerCase().includes(q)) ? '' : 'none';
      });
      updateSelectAll();
    }

    function render() {
      var prevByNo = {};
      teamState.links.forEach(function (l) { prevByNo[l.customerNo] = l.systemId; });
      var checkedNos = teamState.isFullAccess ? null : prevByNo; // null = all checked

      var html = '';
      teamState.locations.forEach(function (loc) {
        var chk = (!checkedNos || checkedNos[loc.customerNo]) ? ' checked' : '';
        html += '<label class="va-perm-item">'
          + '<input type="checkbox" value="' + escHtml(loc.customerNo) + '"' + chk + '>'
          + '<span class="va-perm-item-name">' + escHtml(loc.name || loc.customerNo)
          + (loc.addr ? '<span class="va-perm-item-addr">' + escHtml(loc.addr) + '</span>' : '')
          + '</span>'
          + '<span class="va-perm-item-no">' + escHtml(loc.customerNo) + '</span>'
          + '</label>';
      });
      listEl.innerHTML = html || '<div class="va-empty">No locations found.</div>';

      if (noteEl) {
        if (teamState.isFullAccess) {
          noteEl.textContent = 'You currently have full access to all locations. Uncheck any location to restrict your view.';
          noteEl.hidden = false;
        } else {
          noteEl.hidden = true;
        }
      }
      if (subEl) {
        subEl.textContent = teamState.locations.length + ' location' + (teamState.locations.length !== 1 ? 's' : '')
          + (teamState.isFullAccess ? ' · full access' : ' · ' + teamState.links.length + ' selected');
      }
      updateSelectAll();
    }

    function isFullAccess(links, locations) {
      if (!links.length) return true;
      var locationNos = {};
      locations.forEach(function (l) { locationNos[l.customerNo] = true; });
      return !links.some(function (l) { return locationNos[l.customerNo]; });
    }

    function buildLocations(addresses) {
      var byNo = {};
      addresses.forEach(function (a) {
        var cno = a.customerNo || '';
        if (!cno || byNo[cno]) return;
        var addrParts = [a.address || a.Address || '', a.city || a.City || '', a.county || a.County || '', a.postCode || a.PostCode || ''].filter(Boolean);
        byNo[cno] = { customerNo: cno, name: a.name || a.Name || cno, addr: addrParts.join(', ') };
      });
      return Object.values(byNo);
    }

    function selectedEmail() {
      var auth = window.__vaAuth || {};
      return (userSelectEl && userSelectEl.value) ? userSelectEl.value : (auth.customer_email || '');
    }

    function loadLinks(email) {
      listEl.innerHTML = '<div class="va-empty">Loading\u2026</div>';
      if (errEl) errEl.hidden = true;
      proxy({ action: 'user-perm-list', customer_email: email }, function (d) {
        teamState.links     = d.links || [];
        teamState.locations = buildLocations(teamState.cachedAddresses || []);
        teamState.isFullAccess = isFullAccess(teamState.links, teamState.locations);
        render();
      }, function (err) {
        listEl.innerHTML = '<div class="va-empty">Could not load permissions: ' + escHtml(err.message) + '</div>';
        if (subEl) subEl.textContent = '';
      });
    }

    function load() {
      var auth = window.__vaAuth || {};
      listEl.innerHTML = '<div class="va-empty">Loading\u2026</div>';
      if (errEl) errEl.hidden = true;

      // Fire address-list, user-list and user-perm-list in parallel; render once all return
      var results = {};
      function tryApply() {
        if (!('addresses' in results) || !('links' in results) || !('users' in results)) return;
        teamState.cachedAddresses = results.addresses;
        teamState.links        = results.links;
        teamState.locations    = buildLocations(results.addresses);
        teamState.isFullAccess = isFullAccess(results.links, teamState.locations);
        teamState.loaded          = true;
        // Populate user dropdown
        if (userSelectEl) {
          var currentEmail = auth.customer_email || '';
          userSelectEl.innerHTML = results.users.map(function (u) {
            var label = u.name ? u.name + ' (' + u.email + ')' : u.email;
            var sel   = u.email === currentEmail ? ' selected' : '';
            return '<option value="' + escHtml(u.email) + '"' + sel + '>' + escHtml(label) + '</option>';
          }).join('');
        }
        render();
      }

      proxy({ action: 'address-list', include_children: true }, function (d) {
        results.addresses = d.addresses || [];
        tryApply();
      }, function (err) {
        listEl.innerHTML = '<div class="va-empty">Could not load locations: ' + escHtml(err.message) + '</div>';
        if (subEl) subEl.textContent = '';
      });

      proxy({ action: 'user-list' }, function (d) {
        results.users = d.users || [];
        tryApply();
      }, function () {
        // Non-fatal: fall back to current user only
        results.users = [{ email: auth.customer_email || '', name: '' }];
        tryApply();
      });

      proxy({ action: 'user-perm-list', customer_email: auth.customer_email || '' }, function (d) {
        results.links = d.links || [];
        tryApply();
      }, function (err) {
        listEl.innerHTML = '<div class="va-empty">Could not load permissions: ' + escHtml(err.message) + '</div>';
        if (subEl) subEl.textContent = '';
      });
    }

    function save() {
      var auth = window.__vaAuth || {};
      var checkedNos  = getCheckedNos();
      var allNos      = teamState.locations.map(function (l) { return l.customerNo; });
      var isNowAll    = allNos.every(function (no) { return checkedNos[no]; });
      var prevByNo    = {};
      teamState.links.forEach(function (l) { prevByNo[l.customerNo] = l.systemId; });

      var toAdd    = [];
      var toDelete = [];

      if (isNowAll && teamState.isFullAccess) {
        // No change
        return;
      } else if (isNowAll && !teamState.isFullAccess) {
        // Remove all restrictions → delete all links
        toDelete = teamState.links.map(function (l) { return l.systemId; });
      } else {
        // Restrict to selection
        allNos.forEach(function (no) {
          if (checkedNos[no] && !prevByNo[no])  toAdd.push(no);
          if (!checkedNos[no] && prevByNo[no])  toDelete.push(prevByNo[no]);
        });
      }

      if (!toAdd.length && !toDelete.length) return;

      saveBtn.disabled = true; saveBtn.textContent = 'Saving\u2026';
      if (errEl) errEl.hidden = true;
      proxy({
        action: 'user-perm-save',
        customer_email: selectedEmail(),
        to_add:    toAdd,
        to_delete: toDelete
      }, function () {
        saveBtn.textContent = 'Saved \u2713';
        saveBtn.classList.add('va-btn--saved');
        loadLinks(selectedEmail());
        setTimeout(function () {
          saveBtn.disabled = false;
          saveBtn.textContent = 'Save';
          saveBtn.classList.remove('va-btn--saved');
        }, 2000);
      }, function (err) {
        saveBtn.disabled = false; saveBtn.textContent = 'Save';
        if (errEl) { errEl.textContent = err.message; errEl.hidden = false; }
      });
    }

    function resetToFullAccess() {
      if (teamState.isFullAccess) return; // already full access
      vaConfirm({ msg: 'Remove all location restrictions and restore full access?', okLabel: 'Reset', danger: true }).then(function (ok) {
        if (!ok) return;
        _resetToFullAccess();
      });
    }
    function _resetToFullAccess() {
      var toDelete = teamState.links.map(function (l) { return l.systemId; });
      if (!toDelete.length) return;
      var auth = window.__vaAuth || {};
      resetBtn.disabled = true; resetBtn.textContent = 'Resetting\u2026';
      if (errEl) errEl.hidden = true;
      proxy({
        action: 'user-perm-save',
        customer_email: selectedEmail(),
        to_add:    [],
        to_delete: toDelete
      }, function () {
        resetBtn.disabled = false; resetBtn.textContent = 'Reset to full access';
        loadLinks(selectedEmail());
      }, function (err) {
        resetBtn.disabled = false; resetBtn.textContent = 'Reset to full access';
        if (errEl) { errEl.textContent = err.message; errEl.hidden = false; }
      });
    }

    if (userSelectEl) userSelectEl.addEventListener('change', function () { loadLinks(userSelectEl.value); });
    if (saveBtn)  saveBtn.addEventListener('click', save);
    if (resetBtn) resetBtn.addEventListener('click', resetToFullAccess);
    if (searchEl) searchEl.addEventListener('input', applySearch);
    if (searchClear) searchClear.addEventListener('click', function () { if (searchEl) { searchEl.value = ''; searchEl.focus(); } applySearch(); });
    if (selectAllBtn) selectAllBtn.addEventListener('click', function () {
      var items = Array.from(listEl.querySelectorAll('.va-perm-item')).filter(function (el) { return el.style.display !== 'none'; });
      var allChecked = items.every(function (el) { return el.querySelector('input[type=checkbox]').checked; });
      items.forEach(function (el) { el.querySelector('input[type=checkbox]').checked = !allChecked; });
      updateSelectAll();
    });
    listEl.addEventListener('change', function (e) { if (e.target.matches('input[type=checkbox]')) updateSelectAll(); });

    new MutationObserver(function () {
      if (teamTab.classList.contains('va-tab--active') && !teamState.loaded) load();
    }).observe(teamTab, { attributes: true, attributeFilter: ['class'] });
    if (teamTab.classList.contains('va-tab--active')) load();
  }());

  // ── Contact rep dialog ────────────────────────────────
  (function () {
    var dialog    = document.getElementById('va-contact-dialog');
    var closeBtn  = document.getElementById('va-contact-close-btn');
    var cancelBtn = document.getElementById('va-contact-cancel-btn');
    var sendBtn   = document.getElementById('va-contact-send-btn');
    var subjectEl = document.getElementById('va-contact-subject');
    var messageEl = document.getElementById('va-contact-message');
    var repNameEl = document.getElementById('va-contact-rep-name');
    var repDetEl  = document.getElementById('va-contact-rep-detail');
    var repAvEl   = document.getElementById('va-contact-rep-av');
    var triggerEl = document.getElementById('va-contact-rep-link');
    if (!dialog || !triggerEl) return;

    var repEmail = '';
    var repName  = '';

    // Populate rep info when customer data resolves
    if (window.__vaCustomerInfo) {
      window.__vaCustomerInfo.then(function (info) {
        var sp = info && info.salesperson;
        if (!sp) return;
        repEmail = sp.email || '';
        repName  = sp.name  || '';
        // Strip prefix like "VALOR - " and title-case
        var display = repName.replace(/^[A-Z0-9 &]+\s*-\s*/i, '').toLowerCase()
          .replace(/\b\w/g, function (c) { return c.toUpperCase(); });
        repNameEl.textContent = display || repName;
        repAvEl.textContent   = display.split(' ').filter(Boolean).slice(0, 2)
          .map(function (w) { return w[0]; }).join('');
        var detail = [sp.email, sp.phoneNo].filter(Boolean).join(' \u00b7 ');
        repDetEl.textContent = detail;
      });
    }

    function openDialog() {
      subjectEl.value  = '';
      messageEl.value  = '';
      sendBtn.disabled    = false;
      sendBtn.textContent = 'Send message';
      dialog.hidden = false;
      setTimeout(function () { subjectEl.focus(); }, 50);
    }

    function closeDialog() { dialog.hidden = true; }

    triggerEl.addEventListener('click', function (e) { e.preventDefault(); openDialog(); });
    closeBtn.addEventListener('click',  closeDialog);
    cancelBtn.addEventListener('click', closeDialog);
    // Only close on a backdrop click that both starts AND ends on the backdrop,
    // so dragging a text selection out of an input doesn't dismiss the dialog.
    var downOnBackdrop = false;
    dialog.addEventListener('mousedown', function (e) { downOnBackdrop = (e.target === dialog); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog && downOnBackdrop) closeDialog(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !dialog.hidden) closeDialog(); });

    sendBtn.addEventListener('click', function () {
      var subject = (subjectEl.value || '').trim();
      var message = (messageEl.value || '').trim();
      if (!subject) { subjectEl.focus(); return; }
      if (!message) { messageEl.focus(); return; }
      if (!repEmail) { alert('Rep email not available.'); return; }

      var auth = window.__vaAuth || {};
      sendBtn.disabled    = true;
      sendBtn.textContent = 'Sending\u2026';
      fetch(auth.proxy || '', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action:    'contact-rep',
          customer_id: auth.customer_id, ts: auth.ts, token: auth.token, shop: Shopify.shop,
          subject:   subject,
          message:   message,
          repEmail:  repEmail,
          repName:   repName,
          fromEmail: auth.customer_email || '',
          fromName:  auth.customer_name || '',
        })
      })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.ok) {
          sendBtn.textContent = 'Sent!';
          setTimeout(closeDialog, 1500);
        } else {
          sendBtn.disabled    = false;
          sendBtn.textContent = 'Send message';
          alert('Failed to send. Please try again.');
        }
      })
      .catch(function () {
        sendBtn.disabled    = false;
        sendBtn.textContent = 'Send message';
        alert('Error sending message. Please try again.');
      });
    });
  }());

  // ── Edit profile dialog (Profile tab) ───────────────────
  (function () {
    var dialog   = document.getElementById('va-profile-dialog');
    var triggerEl = document.getElementById('va-profile-edit-btn');
    if (!dialog || !triggerEl) return;

    var firstEl  = document.getElementById('va-profile-first');
    var lastEl   = document.getElementById('va-profile-last');
    var phoneEl  = document.getElementById('va-profile-phone');
    var emailRo  = document.getElementById('va-profile-email-ro');
    var errEl    = document.getElementById('va-profile-error');
    var saveBtn  = document.getElementById('va-profile-save-btn');
    var closeBtn = document.getElementById('va-profile-close-btn');
    var cancelBtn = document.getElementById('va-profile-cancel-btn');

    var nameValEl  = document.getElementById('va-profile-name-value');
    var phoneValEl = document.getElementById('va-profile-phone-value');

    var auth = window.__vaAuth || {};

    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg || '';
      errEl.hidden = !msg;
    }

    function openDialog() {
      showError('');
      firstEl.value = auth.customer_first_name || '';
      lastEl.value  = auth.customer_last_name || '';
      phoneEl.value = auth.customer_phone || '';
      if (emailRo) emailRo.textContent = auth.customer_email || '';
      pendingPhoneMove    = false;
      saveBtn.disabled    = false;
      saveBtn.textContent = 'Save changes';
      dialog.hidden = false;
      setTimeout(function () { firstEl.focus(); }, 50);
    }

    function closeDialog() { dialog.hidden = true; }

    triggerEl.addEventListener('click', function (e) { e.preventDefault(); openDialog(); });
    closeBtn.addEventListener('click',  closeDialog);
    cancelBtn.addEventListener('click', closeDialog);
    // Only close on a backdrop click that both starts AND ends on the backdrop,
    // so dragging a text selection out of an input doesn't dismiss the dialog.
    var downOnBackdrop = false;
    dialog.addEventListener('mousedown', function (e) { downOnBackdrop = (e.target === dialog); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog && downOnBackdrop) closeDialog(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !dialog.hidden) closeDialog(); });

    // A phone number already held by a colleague comes back as a question rather
    // than a save: nothing is written until the buyer agrees to move it. The next
    // click repeats the request with phone_confirm_move, which is what authorises
    // the server to take the number off the other profile.
    var pendingPhoneMove = false;

    function resetSaveBtn() {
      pendingPhoneMove    = false;
      saveBtn.disabled    = false;
      saveBtn.textContent = 'Save changes';
    }

    // Consent is for one number. Editing the field after being asked must not
    // carry it over to a different one.
    phoneEl.addEventListener('input', function () {
      if (pendingPhoneMove) { resetSaveBtn(); showError(''); }
    });

    saveBtn.addEventListener('click', function () {
      if (!auth.customer_id || !auth.proxy) { showError('Your session has expired. Please reload the page.'); return; }
      var first = (firstEl.value || '').trim();
      var last  = (lastEl.value || '').trim();
      var phone = (phoneEl.value || '').trim();
      var confirmMove = pendingPhoneMove;

      showError('');
      saveBtn.disabled    = true;
      saveBtn.textContent = confirmMove ? 'Moving…' : 'Saving…';
      fetch(auth.proxy, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action:      'customer-update',
          customer_id: auth.customer_id, ts: auth.ts, token: auth.token,
          shop:        window.Shopify && Shopify.shop,
          first_name:  first,
          last_name:   last,
          phone:       phone,
          phone_confirm_move: confirmMove ? 1 : 0
        })
      })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.ok) {
          pendingPhoneMove = false;
          var c = d.customer;
          if (c) {
            // Keep the auth cache in sync so re-opening shows fresh values.
            auth.customer_first_name = c.firstName || '';
            auth.customer_last_name  = c.lastName || '';
            auth.customer_phone      = c.phone || '';
            auth.customer_name       = [c.firstName, c.lastName].filter(Boolean).join(' ');
            // Reflect into the visible panel.
            if (nameValEl)  nameValEl.textContent  = auth.customer_name || nameValEl.textContent;
            if (phoneValEl) {
              phoneValEl.textContent = c.phone || '—';
              phoneValEl.setAttribute('data-empty', c.phone ? '0' : '1');
            }
            // Let the SMS toggle finish an opt-in that was waiting on a phone number.
            if (c.phone) {
              document.dispatchEvent(new CustomEvent('va:phone-updated', { detail: { phone: c.phone } }));
            }
          }
          if (d.phone_note) {
            // Saved, but with a note about the phone (reassigned, or left unchanged).
            showError(d.phone_note);
            saveBtn.textContent = 'Saved';
            saveBtn.disabled = false;
          } else {
            saveBtn.textContent = 'Saved!';
            setTimeout(closeDialog, 900);
          }
        } else if (d && d.phone_confirm_required) {
          // Nothing was saved -- not the phone, not the name. Ask, and let the
          // next click carry the answer.
          showError(d.error || 'That phone number is already on another profile at your company. Is the number correct?');
          pendingPhoneMove    = true;
          saveBtn.disabled    = false;
          saveBtn.textContent = 'Yes, move it to my profile';
        } else {
          resetSaveBtn();
          showError((d && d.error) ? d.error : 'Couldn’t save your changes. Please try again.');
        }
      })
      .catch(function () {
        resetSaveBtn();
        showError('Network error. Please try again.');
      });
    });
  }());

  // ── Marketing consent toggles (Profile tab) ─────────────
  (function () {
    var auth = window.__vaAuth || {};

    function initConsentToggle(cfg) {
      var toggle   = document.getElementById(cfg.toggleId);
      var statusEl = document.getElementById(cfg.statusId);
      if (!toggle) return;
      if (!auth.customer_id || !auth.proxy) { toggle.disabled = true; return; }

      var busy = false;

      function setStatus(msg, kind) {
        if (!statusEl) return;
        statusEl.textContent = msg || '';
        statusEl.className = 'va-consent-status' + (kind ? ' is-' + kind : '');
      }

      function reflect(subscribed) {
        toggle.checked = !!subscribed;
        toggle.setAttribute('aria-checked', subscribed ? 'true' : 'false');
      }

      function reflectState(state, emptyMessage) {
        state = String(state || 'NOT_SUBSCRIBED').toUpperCase();
        if (state === 'PENDING') {
          // Keep the switch on so the customer can turn it off to cancel the
          // pending request, but do not present it as a completed subscription.
          reflect(true);
          setStatus(cfg.pendingMsg || 'Pending verification', 'pending');
          return;
        }
        if (state === 'SUBSCRIBED') {
          reflect(true);
          setStatus(cfg.subscribedMsg, 'ok');
          return;
        }
        reflect(false);
        setStatus(emptyMessage || '', emptyMessage ? 'ok' : '');
      }

      function call(extra) {
        var body = {
          action:      cfg.action,
          customer_id: auth.customer_id,
          ts:          auth.ts,
          token:       auth.token,
          shop:        window.Shopify && Shopify.shop
        };
        if (extra) Object.keys(extra).forEach(function (k) { body[k] = extra[k]; });
        return fetch(auth.proxy, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json(); });
      }

      // Read current state on load.
      setStatus('Loading…');
      call(null).then(function (d) {
        if (d && d.ok) {
          toggle.disabled = false;
          reflectState(d.state);
        } else {
          setStatus(cfg.loadErrMsg, 'err');
        }
      }).catch(function () {
        setStatus(cfg.loadErrMsg, 'err');
      });

      var pendingSms = false;

      function showNeedsPhonePrompt() {
        if (!statusEl) return;
        // Clickable prompt that opens the Edit profile dialog directly.
        statusEl.className = 'va-consent-status is-err';
        statusEl.textContent = '';
        statusEl.appendChild(document.createTextNode('Add a mobile number to your account first — '));
        var editLink = document.createElement('button');
        editLink.type = 'button';
        editLink.textContent = 'Edit profile';
        editLink.style.cssText = 'background:none;border:none;padding:0;font:inherit;color:inherit;text-decoration:underline;cursor:pointer;';
        editLink.addEventListener('click', function () {
          pendingSms = true; // remember intent so we can auto-subscribe once a phone is saved
          var editBtn = document.getElementById('va-profile-edit-btn');
          if (editBtn) editBtn.click();
        });
        statusEl.appendChild(editLink);
        statusEl.appendChild(document.createTextNode(' before subscribing.'));
      }

      function applyOptIn(want) {
        if (busy) return;
        busy = true;
        toggle.disabled = true;
        setStatus('Saving…');
        call({ opt_in: want }).then(function (d) {
          busy = false;
          toggle.disabled = false;
          if (d && d.ok) {
            reflectState(d.state, cfg.unsubscribedMsg);
          } else if (d && d.needsPhone) {
            reflect(false);
            showNeedsPhonePrompt();
          } else {
            reflect(!want); // revert
            setStatus((d && d.error) ? d.error : 'Couldn’t update your preference. Please try again.', 'err');
          }
        }).catch(function () {
          busy = false;
          toggle.disabled = false;
          reflect(!want); // revert
          setStatus('Network error. Please try again.', 'err');
        });
      }

      // Save on change.
      toggle.addEventListener('change', function () { applyOptIn(toggle.checked); });

      // If the user opened Edit profile from the "add a phone" prompt and then saved a
      // number, finish what they started by subscribing automatically. (pendingSms is only
      // ever set by the SMS toggle, so the email instance's listener is a no-op.)
      document.addEventListener('va:phone-updated', function (e) {
        if (!pendingSms) return;
        pendingSms = false;
        var phone = e.detail && e.detail.phone;
        if (!phone || busy) return;
        reflect(true);
        applyOptIn(true);
      });
    }

    initConsentToggle({
      toggleId: 'va-email-optin', statusId: 'va-email-status', action: 'email-consent',
      subscribedMsg:   'You’re subscribed to email updates.',
      pendingMsg:      'Pending verification',
      unsubscribedMsg: 'You’ve unsubscribed from email updates.',
      loadErrMsg:      'Unable to load your email preference right now.'
    });
    initConsentToggle({
      toggleId: 'va-sms-optin', statusId: 'va-sms-status', action: 'sms-consent',
      subscribedMsg:   'You’re subscribed to SMS updates.',
      pendingMsg:      'Pending verification',
      unsubscribedMsg: 'You’ve unsubscribed from SMS updates.',
      loadErrMsg:      'Unable to load your SMS preference right now.'
    });
  }());

})();
